var ru = Object.defineProperty;
var au = (t, e, r) => e in t ? ru(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Ve = (t, e, r) => (au(t, typeof e != "symbol" ? e + "" : e, r), r);
import { jsx as F, jsxs as Le, Fragment as Io } from "react/jsx-runtime";
import st, { createContext as Qe, useContext as Ee, createElement as De, forwardRef as tr, memo as nu, useDebugValue as Mn, useMemo as He, useEffect as X, useLayoutEffect as ou, useRef as U, useState as ie, useCallback as W, useReducer as _n, cloneElement as iu, Component as uu, Suspense as su } from "react";
import * as lu from "@tanstack/react-query";
import { useSuspenseQuery as du, dehydrate as Bn, QueryClientProvider as cu, HydrationBoundary as fu } from "@tanstack/react-query";
import { I18nextProvider as vu, useTranslation as mu } from "react-i18next";
import "i18next";
import { createPortal as hu } from "react-dom";
function pu(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function zn(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function w(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? zn(Object(r), !0).forEach(function(a) {
      pu(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : zn(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function ae(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function yu(t, e) {
  if (t) {
    if (typeof t == "string")
      return $n(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return $n(t, e);
  }
}
function $n(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function lt(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = yu(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
var wn = /* @__PURE__ */ Qe({});
function bu(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function qn(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function pt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qn(Object(r), !0).forEach(function(a) {
      bu(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qn(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function Cr(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function gu(t, e) {
  if (t) {
    if (typeof t == "string")
      return Vn(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Vn(t, e);
  }
}
function Vn(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function Kn(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = gu(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function Mu(t) {
  return typeof t == "function";
}
var Et = function(e, r, a) {
  a === void 0 && (a = r.children);
  var n = Ee(wn);
  if (n.useCreateElement)
    return n.useCreateElement(e, r, a);
  if (typeof e == "string" && Mu(a)) {
    r.children;
    var o = Cr(r, ["children"]);
    return a(o);
  }
  return /* @__PURE__ */ De(e, r, a);
};
function _u(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Un(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Xe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Un(Object(r), !0).forEach(function(a) {
      _u(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Un(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function wu(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function Eu(t, e) {
  if (t) {
    if (typeof t == "string")
      return Yn(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Yn(t, e);
  }
}
function Yn(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function Pu(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = Eu(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function En(t) {
  return typeof t == "object" && t != null;
}
function Tr(t) {
  var e;
  if (!En(t))
    return !1;
  var r = Object.getPrototypeOf(t);
  return r == null ? !0 : ((e = r.constructor) === null || e === void 0 ? void 0 : e.toString()) === Object.toString();
}
function Xn(t, e) {
  for (var r = Object.keys(t), a = {}, n = {}, o = 0, s = r; o < s.length; o++) {
    var i = s[o];
    e.indexOf(i) >= 0 ? a[i] = t[i] : n[i] = t[i];
  }
  return [a, n];
}
function Gn(t, e) {
  if (e === void 0 && (e = []), !Tr(t.state))
    return Xn(t, e);
  var r = Xn(t, [].concat(e, ["state"])), a = r[0], n = r[1], o = a.state, s = wu(a, ["state"]);
  return [Xe(Xe({}, o), s), n];
}
function It(t, e) {
  if (t === e)
    return !0;
  if (!t || !e || typeof t != "object" || typeof e != "object")
    return !1;
  var r = Object.keys(t), a = Object.keys(e), n = r.length;
  if (a.length !== n)
    return !1;
  for (var o = 0, s = r; o < s.length; o++) {
    var i = s[o];
    if (t[i] !== e[i])
      return !1;
  }
  return !0;
}
function Jn(t) {
  return t.name === "normalizePropsAreEqualInner" ? t : function(r, a) {
    return !Tr(r.state) || !Tr(a.state) ? t(r, a) : t(Xe(Xe({}, r.state), r), Xe(Xe({}, a.state), a));
  };
}
function Su(t) {
  return /* @__PURE__ */ tr(t);
}
function Ou(t, e) {
  return /* @__PURE__ */ nu(t, e);
}
function me(t) {
  var e = t.as, r = t.useHook, a = t.memo, n = t.propsAreEqual, o = n === void 0 ? r == null ? void 0 : r.unstable_propsAreEqual : n, s = t.keys, i = s === void 0 ? (r == null ? void 0 : r.__keys) || [] : s, u = t.useCreateElement, l = u === void 0 ? Et : u, d = function(h, c) {
    var v = h.as, f = v === void 0 ? e : v, p = Cr(h, ["as"]);
    if (r) {
      var b, M = Gn(p, i), g = M[0], y = M[1], _ = r(g, pt({
        ref: c
      }, y)), P = _.wrapElement, S = Cr(_, ["wrapElement"]), D = ((b = f.render) === null || b === void 0 ? void 0 : b.__keys) || f.__keys, O = D && Gn(p, D)[0], E = O ? pt(pt({}, S), O) : S, R = l(f, E);
      return P ? P(R) : R;
    }
    return l(f, pt({
      ref: c
    }, p));
  };
  return process.env.NODE_ENV !== "production" && r && (d.displayName = r.name.replace(/^(unstable_)?use/, "")), d = Su(d), a && (d = Ou(d, o && Jn(o))), d.__keys = i, d.unstable_propsAreEqual = Jn(o || It), d;
}
function Lo(t, e) {
  Mn(t);
  var r = Ee(wn);
  return r[t] != null ? r[t] : e;
}
function xu(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var a = "use" + t + "Props";
  Mn(a);
  var n = Lo(a);
  return n ? n(e, r) : r;
}
function Du(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var a = "use" + t + "Options";
  Mn(a);
  var n = Lo(a);
  return n ? pt(pt({}, e), n(e, r)) : e;
}
function Cu(t) {
  return Array.isArray(t) ? t : typeof t < "u" ? [t] : [];
}
function he(t) {
  var e, r, a = Cu(t.compose), n = function(u, l) {
    if (t.useOptions && (u = t.useOptions(u, l)), t.name && (u = Du(t.name, u, l)), t.compose)
      for (var d = Kn(a), m; !(m = d()).done; ) {
        var h = m.value;
        u = h.__useOptions(u, l);
      }
    return u;
  }, o = function(u, l, d) {
    if (u === void 0 && (u = {}), l === void 0 && (l = {}), d === void 0 && (d = !1), d || (u = n(u, l)), t.useProps && (l = t.useProps(u, l)), t.name && (l = xu(t.name, u, l)), t.compose)
      if (t.useComposeOptions && (u = t.useComposeOptions(u, l)), t.useComposeProps)
        l = t.useComposeProps(u, l);
      else
        for (var m = Kn(a), h; !(h = m()).done; ) {
          var c = h.value;
          l = c(u, l, !0);
        }
    var v = {}, f = l || {};
    for (var p in f)
      f[p] !== void 0 && (v[p] = f[p]);
    return v;
  };
  o.__useOptions = n;
  var s = a.reduce(function(i, u) {
    return i.push.apply(i, u.__keys || []), i;
  }, []);
  return o.__keys = [].concat(s, ((e = t.useState) === null || e === void 0 ? void 0 : e.__keys) || [], t.keys || []), o.unstable_propsAreEqual = t.propsAreEqual || ((r = a[0]) === null || r === void 0 ? void 0 : r.unstable_propsAreEqual) || It, process.env.NODE_ENV !== "production" && t.name && Object.defineProperty(o, "name", {
    value: "use" + t.name
  }), o;
}
function Qn(t, e) {
  e === void 0 && (e = null), t && (typeof t == "function" ? t(e) : t.current = e);
}
function Be(t, e) {
  return He(function() {
    return t == null && e == null ? null : function(r) {
      Qn(t, r), Qn(e, r);
    };
  }, [t, e]);
}
var Tu = ["button", "color", "file", "image", "reset", "submit"];
function sr(t) {
  if (t.tagName === "BUTTON")
    return !0;
  if (t.tagName === "INPUT") {
    var e = t;
    return Tu.indexOf(e.type) !== -1;
  }
  return !1;
}
function Wo(t) {
  for (var e = [], r = Pu(t), a; !(a = r()).done; ) {
    var n = a.value;
    Array.isArray(n) ? e.push.apply(e, Wo(n)) : e.push(n);
  }
  return e;
}
function Oe(t) {
  if (process.env.NODE_ENV !== "production") {
    var e;
    if (!t)
      return;
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
      a[n - 1] = arguments[n];
    var o = Wo(a.map(function(s) {
      return [s, `
`];
    }));
    (e = console).warn.apply(e, o.slice(0, -1));
    try {
      throw Error(o.join(""));
    } catch {
    }
  }
}
function Au(t) {
  return En(t) && "current" in t;
}
function Ht(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    r[a - 1] = arguments[a];
  process.env.NODE_ENV !== "production" && X(function() {
    process.env.NODE_ENV !== "production" && Oe.apply(void 0, [t].concat(r.map(function(n) {
      return Au(n) ? n.current : n;
    })));
  }, [t]);
}
function pe(t) {
  return t ? t.ownerDocument || t : document;
}
var Ar;
try {
  Ar = window;
} catch {
}
function Fo(t) {
  return t && pe(t).defaultView || Ar;
}
function Ru() {
  var t = Fo();
  return !!(typeof t < "u" && t.document && t.document.createElement);
}
var Pt = Ru(), Ze = Pt ? ou : X;
function Q(t) {
  var e = U(t);
  return Ze(function() {
    e.current = t;
  }), e;
}
function Ie(t) {
  return t.target === t.currentTarget;
}
function St(t) {
  var e = pe(t), r = e.activeElement;
  return r != null && r.nodeName ? r : null;
}
function We(t, e) {
  return t === e || t.contains(e);
}
function Bt(t) {
  var e = St(t);
  if (!e)
    return !1;
  if (We(t, e))
    return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id ? !0 : !!t.querySelector("#" + r) : !1;
}
function Pn(t) {
  return !We(t.currentTarget, t.target);
}
function rt(t) {
  return Pt ? window.navigator.userAgent.indexOf(t) !== -1 : !1;
}
function No(t, e) {
  return "matches" in t ? t.matches(e) : "msMatchesSelector" in t ? t.msMatchesSelector(e) : t.webkitMatchesSelector(e);
}
function Ho(t, e) {
  if ("closest" in t)
    return t.closest(e);
  do {
    if (No(t, e))
      return t;
    t = t.parentElement || t.parentNode;
  } while (t !== null && t.nodeType === 1);
  return null;
}
var Bo = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function ku(t) {
  var e = t;
  return e.offsetWidth > 0 || e.offsetHeight > 0 || t.getClientRects().length > 0;
}
function ju(t) {
  var e = parseInt(t.getAttribute("tabindex") || "0", 10);
  return e < 0;
}
function zo(t) {
  return No(t, Bo) && ku(t);
}
function Rr(t) {
  return zo(t) && !ju(t);
}
function $o(t, e) {
  var r = Array.from(t.querySelectorAll(Bo)), a = r.filter(Rr);
  return Rr(t) && a.unshift(t), !a.length && e ? r : a;
}
function qo(t, e) {
  var r = $o(t, e), a = r[0];
  return a || null;
}
function Iu(t, e) {
  var r = $o(t, e);
  return r[r.length - 1] || null;
}
var Lu = ["unstable_system"], lr = he({
  name: "Role",
  keys: Lu,
  propsAreEqual: function(e, r) {
    var a = e.unstable_system, n = ae(e, ["unstable_system"]), o = r.unstable_system, s = ae(r, ["unstable_system"]);
    return a !== o && !It(a, o) ? !1 : It(n, s);
  }
});
me({
  as: "div",
  useHook: lr
});
var Wu = ["disabled", "focusable"], Fu = rt("Mac") && !rt("Chrome") && (rt("Safari") || rt("Firefox"));
function Zn(t) {
  !Bt(t) && zo(t) && t.focus();
}
function Nu(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"].includes(t.tagName);
}
function Hu(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(t.tagName);
}
function Bu(t, e, r, a) {
  return t ? e && !r ? -1 : void 0 : e ? a : a || 0;
}
function hr(t, e) {
  return W(function(r) {
    var a;
    (a = t.current) === null || a === void 0 || a.call(t, r), !r.defaultPrevented && e && (r.stopPropagation(), r.preventDefault());
  }, [t, e]);
}
var rr = he({
  name: "Tabbable",
  compose: lr,
  keys: Wu,
  useOptions: function(e, r) {
    var a = r.disabled;
    return w({
      disabled: a
    }, e);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.tabIndex, o = r.onClickCapture, s = r.onMouseDownCapture, i = r.onMouseDown, u = r.onKeyPressCapture, l = r.style, d = ae(r, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]), m = U(null), h = Q(o), c = Q(s), v = Q(i), f = Q(u), p = !!e.disabled && !e.focusable, b = ie(!0), M = b[0], g = b[1], y = ie(!0), _ = y[0], P = y[1], S = e.disabled ? w({
      pointerEvents: "none"
    }, l) : l;
    Ze(function() {
      var x = m.current;
      if (!x) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't determine if the element is a native tabbable element because `ref` wasn't passed to the component.", "See https://reakit.io/docs/tabbable");
        return;
      }
      Nu(x) || g(!1), Hu(x) || P(!1);
    }, []);
    var D = hr(h, e.disabled), O = hr(c, e.disabled), E = hr(f, e.disabled), R = W(function(x) {
      var C;
      (C = v.current) === null || C === void 0 || C.call(v, x);
      var L = x.currentTarget;
      if (!x.defaultPrevented && Fu && !Pn(x) && sr(L)) {
        var T = requestAnimationFrame(function() {
          L.removeEventListener("mouseup", I, !0), Zn(L);
        }), I = function() {
          cancelAnimationFrame(T), Zn(L);
        };
        L.addEventListener("mouseup", I, {
          once: !0,
          capture: !0
        });
      }
    }, []);
    return w({
      ref: Be(m, a),
      style: S,
      tabIndex: Bu(p, M, _, n),
      disabled: p && _ ? !0 : void 0,
      "aria-disabled": e.disabled ? !0 : void 0,
      onClickCapture: D,
      onMouseDownCapture: O,
      onMouseDown: R,
      onKeyPressCapture: E
    }, d);
  }
});
me({
  as: "div",
  useHook: rr
});
var zu = ["unstable_clickOnEnter", "unstable_clickOnSpace"];
function $u(t) {
  var e = t.currentTarget;
  return t.isTrusted ? sr(e) || e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.tagName === "A" || e.tagName === "SELECT" : !1;
}
var Tt = he({
  name: "Clickable",
  compose: rr,
  keys: zu,
  useOptions: function(e) {
    var r = e.unstable_clickOnEnter, a = r === void 0 ? !0 : r, n = e.unstable_clickOnSpace, o = n === void 0 ? !0 : n, s = ae(e, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);
    return w({
      unstable_clickOnEnter: a,
      unstable_clickOnSpace: o
    }, s);
  },
  useProps: function(e, r) {
    var a = r.onKeyDown, n = r.onKeyUp, o = ae(r, ["onKeyDown", "onKeyUp"]), s = ie(!1), i = s[0], u = s[1], l = Q(a), d = Q(n), m = W(function(c) {
      var v;
      if ((v = l.current) === null || v === void 0 || v.call(l, c), !c.defaultPrevented && !e.disabled && !c.metaKey && Ie(c)) {
        var f = e.unstable_clickOnEnter && c.key === "Enter", p = e.unstable_clickOnSpace && c.key === " ";
        if (f || p) {
          if ($u(c))
            return;
          c.preventDefault(), f ? c.currentTarget.click() : p && u(!0);
        }
      }
    }, [e.disabled, e.unstable_clickOnEnter, e.unstable_clickOnSpace]), h = W(function(c) {
      var v;
      if ((v = d.current) === null || v === void 0 || v.call(d, c), !c.defaultPrevented && !e.disabled && !c.metaKey) {
        var f = e.unstable_clickOnSpace && c.key === " ";
        i && f && (u(!1), c.currentTarget.click());
      }
    }, [e.disabled, e.unstable_clickOnSpace, i]);
    return w({
      "data-active": i || void 0,
      onKeyDown: m,
      onKeyUp: h
    }, o);
  }
});
me({
  as: "button",
  memo: !0,
  useHook: Tt
});
var qu = [], Vo = he({
  name: "Button",
  compose: Tt,
  keys: qu,
  useProps: function(e, r) {
    var a = r.ref, n = ae(r, ["ref"]), o = U(null), s = ie(void 0), i = s[0], u = s[1], l = ie("button"), d = l[0], m = l[1];
    return X(function() {
      var h = o.current;
      if (!h) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't determine whether the element is a native button because `ref` wasn't passed to the component", "See https://reakit.io/docs/button");
        return;
      }
      sr(h) || (h.tagName !== "A" && u("button"), m(void 0));
    }, []), w({
      ref: Be(o, a),
      role: i,
      type: d
    }, n);
  }
}), Vu = me({
  as: "button",
  memo: !0,
  useHook: Vo
});
function Ku(t, e) {
  return e === -1 ? t : [].concat(t.slice(0, e), t.slice(e + 1));
}
function Ko(t, e, r) {
  if (typeof Event == "function")
    return new Event(e, r);
  var a = pe(t).createEvent("Event");
  return a.initEvent(e, r == null ? void 0 : r.bubbles, r == null ? void 0 : r.cancelable), a;
}
function dt(t) {
  var e = ie(t), r = e[0];
  return r;
}
function Uo(t, e) {
  var r = U(!1);
  X(function() {
    if (r.current)
      return t();
    r.current = !0;
  }, e);
}
function eo(t, e, r) {
  return r === void 0 && (r = {}), typeof FocusEvent == "function" ? new FocusEvent(e, r) : Ko(t, e, r);
}
function pr(t, e) {
  var r = eo(t, "blur", e), a = t.dispatchEvent(r), n = Xe(Xe({}, e), {}, {
    bubbles: !0
  });
  return t.dispatchEvent(eo(t, "focusout", n)), a;
}
function Uu(t, e, r) {
  if (r === void 0 && (r = {}), typeof KeyboardEvent == "function")
    return new KeyboardEvent(e, r);
  var a = pe(t).createEvent("KeyboardEvent");
  return a.initKeyboardEvent(e, r.bubbles, r.cancelable, Fo(t), r.key, r.location, r.ctrlKey, r.altKey, r.shiftKey, r.metaKey), a;
}
function Yu(t, e, r) {
  return t.dispatchEvent(Uu(t, e, r));
}
var Xu = Pt && "msCrypto" in window;
function Yo(t) {
  if (Xu) {
    var e = St(t.currentTarget);
    return e;
  }
  return t.relatedTarget;
}
function ar(t) {
  for (var e = [[]], r = function() {
    var s = n.value, i = e.find(function(u) {
      return !u[0] || u[0].groupId === s.groupId;
    });
    i ? i.push(s) : e.push([s]);
  }, a = lt(t), n; !(n = a()).done; )
    r();
  return e;
}
function kr(t) {
  for (var e = [], r = lt(t), a; !(a = r()).done; ) {
    var n = a.value;
    e.push.apply(e, n);
  }
  return e;
}
function ht(t) {
  return t.slice().reverse();
}
function Ke(t, e) {
  return e ? t.find(function(r) {
    return !r.disabled && r.id !== e;
  }) : t.find(function(r) {
    return !r.disabled;
  });
}
function tt(t, e) {
  var r;
  return e || e === null ? e : t.currentId || t.currentId === null ? t.currentId : (r = Ke(t.items || [])) === null || r === void 0 ? void 0 : r.id;
}
function Xo(t, e) {
  if (e)
    return t == null ? void 0 : t.find(function(r) {
      return r.id === e && !r.disabled;
    });
}
var Gu = ["baseId", "unstable_idCountRef", "setBaseId", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget"], Go = Gu, Ju = Go, Qu = Ju;
function Jo(t) {
  t.userFocus = !0, t.focus(), t.userFocus = !1;
}
function Zu(t) {
  return !!t.userFocus;
}
function to(t, e) {
  t.userFocus = e;
}
var es = Pt && "msCrypto" in window;
function ts(t) {
  return !(!Ie(t) || t.metaKey || t.key === "Tab");
}
function ro(t, e, r) {
  var a = Q(r);
  return W(function(n) {
    var o;
    if ((o = a.current) === null || o === void 0 || o.call(a, n), !n.defaultPrevented && t && ts(n)) {
      var s = e == null ? void 0 : e.ref.current;
      s && (Yu(s, n.type, n) || n.preventDefault(), n.currentTarget.contains(s) && n.stopPropagation());
    }
  }, [t, e]);
}
function rs(t) {
  var e = U(null);
  return X(function() {
    var r = pe(t.current), a = function(o) {
      var s = o.target;
      e.current = s;
    };
    return r.addEventListener("focus", a, !0), function() {
      r.removeEventListener("focus", a, !0);
    };
  }, []), e;
}
function as(t) {
  return Ke(kr(ht(ar(t))));
}
function yr(t, e) {
  return t == null ? void 0 : t.some(function(r) {
    return !!e && r.ref.current === e;
  });
}
function ns(t) {
  var e = Q(t), r = _n(function(o) {
    return o + 1;
  }, 0), a = r[0], n = r[1];
  return X(function() {
    var o, s = (o = e.current) === null || o === void 0 ? void 0 : o.ref.current;
    a && s && Jo(s);
  }, [a]), n;
}
var Qo = he({
  name: "Composite",
  compose: [rr],
  keys: Go,
  useOptions: function(e) {
    return w(w({}, e), {}, {
      currentId: tt(e)
    });
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onFocusCapture, o = r.onFocus, s = r.onBlurCapture, i = r.onKeyDown, u = r.onKeyDownCapture, l = r.onKeyUpCapture, d = ae(r, ["ref", "onFocusCapture", "onFocus", "onBlurCapture", "onKeyDown", "onKeyDownCapture", "onKeyUpCapture"]), m = U(null), h = Xo(e.items, e.currentId), c = U(null), v = Q(n), f = Q(o), p = Q(s), b = Q(i), M = ns(h), g = es ? rs(m) : void 0;
    X(function() {
      var E = m.current;
      e.unstable_moves && !h && (process.env.NODE_ENV !== "production" && Oe(!E, "Can't focus composite component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite"), E == null || E.focus());
    }, [e.unstable_moves, h]);
    var y = ro(e.unstable_virtual, h, u), _ = ro(e.unstable_virtual, h, l), P = W(function(E) {
      var R;
      if ((R = v.current) === null || R === void 0 || R.call(v, E), !E.defaultPrevented && e.unstable_virtual) {
        var x = (g == null ? void 0 : g.current) || E.relatedTarget, C = yr(e.items, x);
        Ie(E) && C && (E.stopPropagation(), c.current = x);
      }
    }, [e.unstable_virtual, e.items]), S = W(function(E) {
      var R;
      if ((R = f.current) === null || R === void 0 || R.call(f, E), !E.defaultPrevented) {
        if (e.unstable_virtual)
          Ie(E) && M();
        else if (Ie(E)) {
          var x;
          (x = e.setCurrentId) === null || x === void 0 || x.call(e, null);
        }
      }
    }, [e.unstable_virtual, e.setCurrentId]), D = W(function(E) {
      var R;
      if ((R = p.current) === null || R === void 0 || R.call(p, E), !E.defaultPrevented && e.unstable_virtual) {
        var x = (h == null ? void 0 : h.ref.current) || null, C = Yo(E), L = yr(e.items, C);
        if (Ie(E) && L)
          C === x ? c.current && c.current !== C && pr(c.current, E) : x && pr(x, E), E.stopPropagation();
        else {
          var T = yr(e.items, E.target);
          !T && x && pr(x, E);
        }
      }
    }, [e.unstable_virtual, e.items, h]), O = W(function(E) {
      var R, x;
      if ((R = b.current) === null || R === void 0 || R.call(b, E), !E.defaultPrevented && e.currentId === null && Ie(E)) {
        var C = e.orientation !== "horizontal", L = e.orientation !== "vertical", T = !!((x = e.groups) !== null && x !== void 0 && x.length), I = function() {
          if (T) {
            var le = as(e.items);
            if (le != null && le.id) {
              var ne;
              (ne = e.move) === null || ne === void 0 || ne.call(e, le.id);
            }
          } else {
            var oe;
            (oe = e.last) === null || oe === void 0 || oe.call(e);
          }
        }, G = {
          ArrowUp: (T || C) && I,
          ArrowRight: (T || L) && e.first,
          ArrowDown: (T || C) && e.first,
          ArrowLeft: (T || L) && e.last,
          Home: e.first,
          End: e.last,
          PageUp: e.first,
          PageDown: e.last
        }, Z = G[E.key];
        Z && (E.preventDefault(), Z());
      }
    }, [e.currentId, e.orientation, e.groups, e.items, e.move, e.last, e.first]);
    return w({
      ref: Be(m, a),
      id: e.baseId,
      onFocus: S,
      onFocusCapture: P,
      onBlurCapture: D,
      onKeyDownCapture: y,
      onKeyDown: O,
      onKeyUpCapture: _,
      "aria-activedescendant": e.unstable_virtual && (h == null ? void 0 : h.id) || void 0
    }, d);
  },
  useComposeProps: function(e, r) {
    r = lr(e, r, !0);
    var a = rr(e, r, !0);
    return e.unstable_virtual || e.currentId === null ? w({
      tabIndex: 0
    }, a) : w(w({}, r), {}, {
      ref: a.ref
    });
  }
});
me({
  as: "div",
  useHook: Qo,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Ht(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/composite"), Et(e, r, a);
  }
});
function ao(t) {
  try {
    var e = t instanceof HTMLInputElement && t.selectionStart !== null, r = t.tagName === "TEXTAREA", a = t.contentEditable === "true";
    return e || r || a || !1;
  } catch {
    return !1;
  }
}
function os(t) {
  var e = St(t);
  if (!e)
    return !1;
  if (e === t)
    return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id : !1;
}
function Lt(t, e) {
  var r = e === void 0 ? {} : e, a = r.preventScroll, n = r.isActive, o = n === void 0 ? os : n;
  return o(t) || (t.focus({
    preventScroll: a
  }), o(t)) ? -1 : requestAnimationFrame(function() {
    t.focus({
      preventScroll: a
    });
  });
}
var Zo = "id";
function is(t) {
  return t === void 0 && (t = Zo), (t ? t + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var Sn = /* @__PURE__ */ Qe(is);
function us(t) {
  var e = t.children, r = t.prefix, a = r === void 0 ? Zo : r, n = U(0), o = W(function(s) {
    return s === void 0 && (s = a), (s ? s + "-" : "") + ++n.current;
  }, [a]);
  return /* @__PURE__ */ De(Sn.Provider, {
    value: o
  }, e);
}
var ss = ["baseId", "unstable_idCountRef", "setBaseId"], ls = [].concat(ss, ["id"]), ei = he({
  keys: ls,
  useOptions: function(e, r) {
    var a = Ee(Sn), n = ie(function() {
      return e.unstable_idCountRef ? (e.unstable_idCountRef.current += 1, "-" + e.unstable_idCountRef.current) : e.baseId ? "-" + a("") : "";
    }), o = n[0], s = He(function() {
      return e.baseId || a();
    }, [e.baseId, a]), i = r.id || e.id || "" + s + o;
    return w(w({}, e), {}, {
      id: i
    });
  },
  useProps: function(e, r) {
    return w({
      id: e.id
    }, r);
  }
});
me({
  as: "div",
  useHook: ei
});
function ds(t, e, r) {
  return t.dispatchEvent(Ko(t, e, r));
}
function no(t, e) {
  if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement) {
    var r, a = Object.getPrototypeOf(t), n = (r = Object.getOwnPropertyDescriptor(a, "value")) === null || r === void 0 ? void 0 : r.set;
    n && (n.call(t, e), ds(t, "input", {
      bubbles: !0
    }));
  }
}
function br(t) {
  return t.querySelector("[data-composite-item-widget]");
}
function cs(t) {
  return He(function() {
    var e;
    return (e = t.items) === null || e === void 0 ? void 0 : e.find(function(r) {
      return t.id && r.id === t.id;
    });
  }, [t.items, t.id]);
}
function fs(t, e) {
  if (Ie(t))
    return !1;
  for (var r = lt(e), a; !(a = r()).done; ) {
    var n = a.value;
    if (n.ref.current === t.target)
      return !0;
  }
  return !1;
}
var jr = he({
  name: "CompositeItem",
  compose: [Tt, ei],
  keys: Qu,
  propsAreEqual: function(e, r) {
    if (!r.id || e.id !== r.id)
      return Tt.unstable_propsAreEqual(e, r);
    var a = e.currentId, n = e.unstable_moves, o = ae(e, ["currentId", "unstable_moves"]), s = r.currentId, i = r.unstable_moves, u = ae(r, ["currentId", "unstable_moves"]);
    if (s !== a) {
      if (r.id === s || r.id === a)
        return !1;
    } else if (n !== i)
      return !1;
    return Tt.unstable_propsAreEqual(o, u);
  },
  useOptions: function(e) {
    return w(w({}, e), {}, {
      id: e.id,
      currentId: tt(e),
      unstable_clickOnSpace: e.unstable_hasActiveWidget ? !1 : e.unstable_clickOnSpace
    });
  },
  useProps: function(e, r) {
    var a, n = r.ref, o = r.tabIndex, s = o === void 0 ? 0 : o, i = r.onMouseDown, u = r.onFocus, l = r.onBlurCapture, d = r.onKeyDown, m = r.onClick, h = ae(r, ["ref", "tabIndex", "onMouseDown", "onFocus", "onBlurCapture", "onKeyDown", "onClick"]), c = U(null), v = e.id, f = e.disabled && !e.focusable, p = e.currentId === v, b = Q(p), M = U(!1), g = cs(e), y = Q(i), _ = Q(u), P = Q(l), S = Q(d), D = Q(m), O = !e.unstable_virtual && !e.unstable_hasActiveWidget && p || // We don't want to set tabIndex="-1" when using CompositeItem as a
    // standalone component, without state props.
    !((a = e.items) !== null && a !== void 0 && a.length);
    X(function() {
      var T;
      if (v)
        return (T = e.registerItem) === null || T === void 0 || T.call(e, {
          id: v,
          ref: c,
          disabled: !!f
        }), function() {
          var I;
          (I = e.unregisterItem) === null || I === void 0 || I.call(e, v);
        };
    }, [v, f, e.registerItem, e.unregisterItem]), X(function() {
      var T = c.current;
      if (!T) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't focus composite item component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite");
        return;
      }
      e.unstable_moves && b.current && Jo(T);
    }, [e.unstable_moves]);
    var E = W(function(T) {
      var I;
      (I = y.current) === null || I === void 0 || I.call(y, T), to(T.currentTarget, !0);
    }, []), R = W(function(T) {
      var I, G, Z = Zu(T.currentTarget);
      if (to(T.currentTarget, !1), (I = _.current) === null || I === void 0 || I.call(_, T), !T.defaultPrevented && !Pn(T) && v && !fs(T, e.items) && ((G = e.setCurrentId) === null || G === void 0 || G.call(e, v), Z && e.unstable_virtual && e.baseId && Ie(T))) {
        var ee = T.target, le = pe(ee).getElementById(e.baseId);
        le && (M.current = !0, Lt(le));
      }
    }, [v, e.items, e.setCurrentId, e.unstable_virtual, e.baseId]), x = W(function(T) {
      var I;
      (I = P.current) === null || I === void 0 || I.call(P, T), !T.defaultPrevented && e.unstable_virtual && M.current && (M.current = !1, T.preventDefault(), T.stopPropagation());
    }, [e.unstable_virtual]), C = W(function(T) {
      var I;
      if (Ie(T)) {
        var G = e.orientation !== "horizontal", Z = e.orientation !== "vertical", ee = !!(g != null && g.groupId), le = {
          ArrowUp: (ee || G) && e.up,
          ArrowRight: (ee || Z) && e.next,
          ArrowDown: (ee || G) && e.down,
          ArrowLeft: (ee || Z) && e.previous,
          Home: function() {
            if (!ee || T.ctrlKey) {
              var te;
              (te = e.first) === null || te === void 0 || te.call(e);
            } else {
              var J;
              (J = e.previous) === null || J === void 0 || J.call(e, !0);
            }
          },
          End: function() {
            if (!ee || T.ctrlKey) {
              var te;
              (te = e.last) === null || te === void 0 || te.call(e);
            } else {
              var J;
              (J = e.next) === null || J === void 0 || J.call(e, !0);
            }
          },
          PageUp: function() {
            if (ee) {
              var te;
              (te = e.up) === null || te === void 0 || te.call(e, !0);
            } else {
              var J;
              (J = e.first) === null || J === void 0 || J.call(e);
            }
          },
          PageDown: function() {
            if (ee) {
              var te;
              (te = e.down) === null || te === void 0 || te.call(e, !0);
            } else {
              var J;
              (J = e.last) === null || J === void 0 || J.call(e);
            }
          }
        }, ne = le[T.key];
        if (ne) {
          T.preventDefault(), ne();
          return;
        }
        if ((I = S.current) === null || I === void 0 || I.call(S, T), !T.defaultPrevented) {
          if (T.key.length === 1 && T.key !== " ") {
            var oe = br(T.currentTarget);
            oe && ao(oe) && (oe.focus(), no(oe, ""));
          } else if (T.key === "Delete" || T.key === "Backspace") {
            var be = br(T.currentTarget);
            be && ao(be) && (T.preventDefault(), no(be, ""));
          }
        }
      }
    }, [e.orientation, g, e.up, e.next, e.down, e.previous, e.first, e.last]), L = W(function(T) {
      var I;
      if ((I = D.current) === null || I === void 0 || I.call(D, T), !T.defaultPrevented) {
        var G = T.currentTarget, Z = br(G);
        Z && !Bt(Z) && Z.focus();
      }
    }, []);
    return w({
      ref: Be(c, n),
      id: v,
      tabIndex: O ? s : -1,
      "aria-selected": e.unstable_virtual && p ? !0 : void 0,
      onMouseDown: E,
      onFocus: R,
      onBlurCapture: x,
      onKeyDown: C,
      onClick: L
    }, h);
  }
});
me({
  as: "button",
  memo: !0,
  useHook: jr
});
function vs(t) {
  return typeof t == "function";
}
function Ye(t, e) {
  return vs(t) ? t(e) : t;
}
function ti(t) {
  t === void 0 && (t = {});
  var e = dt(t), r = e.baseId, a = Ee(Sn), n = U(0), o = ie(function() {
    return r || a();
  }), s = o[0], i = o[1];
  return {
    baseId: s,
    setBaseId: i,
    unstable_idCountRef: n
  };
}
function ri(t, e) {
  return !!(e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING);
}
function oo(t, e) {
  return t.findIndex(function(r) {
    return !r.ref.current || !e.ref.current ? !1 : ri(e.ref.current, r.ref.current);
  });
}
function ai(t) {
  for (var e = 0, r = lt(t), a; !(a = r()).done; ) {
    var n = a.value.length;
    n > e && (e = n);
  }
  return e;
}
function io(t) {
  for (var e = ar(t), r = ai(e), a = [], n = 0; n < r; n += 1)
    for (var o = lt(e), s; !(s = o()).done; ) {
      var i = s.value;
      i[n] && a.push(w(w({}, i[n]), {}, {
        // If there's no groupId, it means that it's not a grid composite,
        // but a single row instead. So, instead of verticalizing it, that
        // is, assigning a different groupId based on the column index, we
        // keep it undefined so they will be part of the same group.
        // It's useful when using up/down on one-dimensional composites.
        groupId: i[n].groupId ? "" + n : void 0
      }));
    }
  return a;
}
function ms(t) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    ref: {
      current: null
    },
    groupId: t
  };
}
function uo(t, e, r) {
  for (var a = ai(t), n = lt(t), o; !(o = n()).done; )
    for (var s = o.value, i = 0; i < a; i += 1) {
      var u = s[i];
      if (!u || r && u.disabled) {
        var l = i === 0, d = l && r ? Ke(s) : s[i - 1];
        s[i] = d && e !== (d == null ? void 0 : d.id) && r ? d : ms(d == null ? void 0 : d.groupId);
      }
    }
  return t;
}
var hs = {
  id: null,
  ref: {
    current: null
  }
};
function ps(t, e, r) {
  var a = t.findIndex(function(n) {
    return n.id === e;
  });
  return [].concat(t.slice(a + 1), r ? [hs] : [], t.slice(0, a));
}
function gr(t, e) {
  return t.filter(function(r) {
    return r.groupId === e;
  });
}
var ys = {
  horizontal: "vertical",
  vertical: "horizontal"
};
function bs(t) {
  return t && ys[t];
}
function so(t, e, r) {
  return r in t ? [].concat(t.slice(0, r), [e], t.slice(r)) : [].concat(t, [e]);
}
function Ir(t) {
  var e = t.map(function(a, n) {
    return [n, a];
  }), r = !1;
  return e.sort(function(a, n) {
    var o = a[0], s = a[1], i = n[0], u = n[1], l = s.ref.current, d = u.ref.current;
    return !l || !d ? 0 : ri(l, d) ? (o > i && (r = !0), -1) : (o < i && (r = !0), 1);
  }), r ? e.map(function(a) {
    a[0];
    var n = a[1];
    return n;
  }) : t;
}
function ni(t, e) {
  var r = Ir(t);
  t !== r && e(r);
}
function gs(t) {
  for (var e, r = t[0], a = t.slice(1), n = r == null || (e = r.ref.current) === null || e === void 0 ? void 0 : e.parentElement, o = function() {
    var u = n;
    if (a.every(function(l) {
      return u.contains(l.ref.current);
    }))
      return {
        v: n
      };
    n = n.parentElement;
  }; n; ) {
    var s = o();
    if (typeof s == "object")
      return s.v;
  }
  return pe(n).body;
}
function Ms(t, e) {
  var r = U([]);
  X(function() {
    for (var a = function() {
      var d = !!r.current.length;
      d && ni(t, e), r.current = t;
    }, n = gs(t), o = new IntersectionObserver(a, {
      root: n
    }), s = lt(t), i; !(i = s()).done; ) {
      var u = i.value;
      u.ref.current && o.observe(u.ref.current);
    }
    return function() {
      o.disconnect();
    };
  }, [t]);
}
function _s(t, e) {
  X(function() {
    var r = function() {
      return ni(t, e);
    }, a = setTimeout(r, 250);
    return function() {
      return clearTimeout(a);
    };
  });
}
function ws(t, e) {
  typeof IntersectionObserver == "function" ? Ms(t, e) : _s(t, e);
}
function xe(t, e) {
  var r = t.unstable_virtual, a = t.rtl, n = t.orientation, o = t.items, s = t.groups, i = t.currentId, u = t.loop, l = t.wrap, d = t.pastIds, m = t.shift, h = t.unstable_moves, c = t.unstable_includesBaseElement, v = t.initialVirtual, f = t.initialRTL, p = t.initialOrientation, b = t.initialCurrentId, M = t.initialLoop, g = t.initialWrap, y = t.initialShift, _ = t.hasSetCurrentId;
  switch (e.type) {
    case "registerGroup": {
      var P = e.group;
      if (s.length === 0)
        return w(w({}, t), {}, {
          groups: [P]
        });
      var S = oo(s, P);
      return w(w({}, t), {}, {
        groups: so(s, P, S)
      });
    }
    case "unregisterGroup": {
      var D = e.id, O = s.filter(function(Te) {
        return Te.id !== D;
      });
      return O.length === s.length ? t : w(w({}, t), {}, {
        groups: O
      });
    }
    case "registerItem": {
      var E = e.item, R = s.find(function(Te) {
        var mr;
        return (mr = Te.ref.current) === null || mr === void 0 ? void 0 : mr.contains(E.ref.current);
      }), x = w({
        groupId: R == null ? void 0 : R.id
      }, E), C = oo(o, x), L = w(w({}, t), {}, {
        items: so(o, x, C)
      });
      if (!_ && !h && b === void 0) {
        var T;
        return w(w({}, L), {}, {
          currentId: (T = Ke(L.items)) === null || T === void 0 ? void 0 : T.id
        });
      }
      return L;
    }
    case "unregisterItem": {
      var I = e.id, G = o.filter(function(Te) {
        return Te.id !== I;
      });
      if (G.length === o.length)
        return t;
      var Z = d.filter(function(Te) {
        return Te !== I;
      }), ee = w(w({}, t), {}, {
        pastIds: Z,
        items: G
      });
      if (i && i === I) {
        var le = c ? null : tt(w(w({}, ee), {}, {
          currentId: Z[0]
        }));
        return w(w({}, ee), {}, {
          currentId: le
        });
      }
      return ee;
    }
    case "move": {
      var ne = e.id;
      if (ne === void 0)
        return t;
      var oe = d.filter(function(Te) {
        return Te !== i && Te !== ne;
      }), be = i ? [i].concat(oe) : oe, de = w(w({}, t), {}, {
        pastIds: be
      });
      if (ne === null)
        return w(w({}, de), {}, {
          unstable_moves: h + 1,
          currentId: tt(de, ne)
        });
      var te = Xo(o, ne);
      return w(w({}, de), {}, {
        unstable_moves: te ? h + 1 : h,
        currentId: tt(de, te == null ? void 0 : te.id)
      });
    }
    case "next": {
      if (i == null)
        return xe(t, w(w({}, e), {}, {
          type: "first"
        }));
      var J = n !== "vertical", ge = a && J, ve = ge ? ht(o) : o, we = ve.find(function(Te) {
        return Te.id === i;
      });
      if (!we)
        return xe(t, w(w({}, e), {}, {
          type: "first"
        }));
      var A = !!we.groupId, j = ve.indexOf(we), V = ve.slice(j + 1), B = gr(V, we.groupId);
      if (e.allTheWay) {
        var H = Ke(ge ? gr(ve, we.groupId) : ht(B));
        return xe(t, w(w({}, e), {}, {
          type: "move",
          id: H == null ? void 0 : H.id
        }));
      }
      var Y = bs(
        // If it's a grid and orientation is not set, it's a next/previous
        // call, which is inherently horizontal. up/down will call next with
        // orientation set to vertical by default (see below on up/down cases).
        A ? n || "horizontal" : n
      ), z = u && u !== Y, $ = A && l && l !== Y, K = (
        // `previous` and `up` will set action.hasNullItem, but when calling
        // next directly, hasNullItem will only be true if it's not a grid and
        // loop is set to true, which means that pressing right or down keys on
        // grids will never focus the composite element. On one-dimensional
        // composites that don't loop, pressing right or down keys also doesn't
        // focus the composite element.
        e.hasNullItem || !A && z && c
      );
      if (z) {
        var re = $ && !K ? ve : gr(ve, we.groupId), q = ps(re, i, K), k = Ke(q, i);
        return xe(t, w(w({}, e), {}, {
          type: "move",
          id: k == null ? void 0 : k.id
        }));
      }
      if ($) {
        var ue = Ke(
          // We can use nextItems, which contains all the next items, including
          // items from other groups, to wrap between groups. However, if there
          // is a null item (the composite element), we'll only use the next
          // items in the group. So moving next from the last item will focus
          // the composite element (null). On grid composites, horizontal
          // navigation never focuses the composite element, only vertical.
          K ? B : V,
          i
        ), Me = K ? (ue == null ? void 0 : ue.id) || null : ue == null ? void 0 : ue.id;
        return xe(t, w(w({}, e), {}, {
          type: "move",
          id: Me
        }));
      }
      var je = Ke(B, i);
      return !je && K ? xe(t, w(w({}, e), {}, {
        type: "move",
        id: null
      })) : xe(t, w(w({}, e), {}, {
        type: "move",
        id: je == null ? void 0 : je.id
      }));
    }
    case "previous": {
      var qt = !!s.length, Vt = !qt && c, Kt = xe(w(w({}, t), {}, {
        items: ht(o)
      }), w(w({}, e), {}, {
        type: "next",
        hasNullItem: Vt
      }));
      return w(w({}, Kt), {}, {
        items: o
      });
    }
    case "down": {
      var Ut = m && !e.allTheWay, Ki = io(kr(uo(ar(o), i, Ut))), Ui = u && u !== "horizontal", Yi = Ui && c, Xi = xe(w(w({}, t), {}, {
        orientation: "vertical",
        items: Ki
      }), w(w({}, e), {}, {
        type: "next",
        hasNullItem: Yi
      }));
      return w(w({}, Xi), {}, {
        orientation: n,
        items: o
      });
    }
    case "up": {
      var Gi = m && !e.allTheWay, Ji = io(ht(kr(uo(ar(o), i, Gi)))), Qi = c, Zi = xe(w(w({}, t), {}, {
        orientation: "vertical",
        items: Ji
      }), w(w({}, e), {}, {
        type: "next",
        hasNullItem: Qi
      }));
      return w(w({}, Zi), {}, {
        orientation: n,
        items: o
      });
    }
    case "first": {
      var vr = Ke(o);
      return xe(t, w(w({}, e), {}, {
        type: "move",
        id: vr == null ? void 0 : vr.id
      }));
    }
    case "last": {
      var eu = xe(w(w({}, t), {}, {
        items: ht(o)
      }), w(w({}, e), {}, {
        type: "first"
      }));
      return w(w({}, eu), {}, {
        items: o
      });
    }
    case "sort":
      return w(w({}, t), {}, {
        items: Ir(o),
        groups: Ir(s)
      });
    case "setVirtual":
      return w(w({}, t), {}, {
        unstable_virtual: Ye(e.virtual, r)
      });
    case "setRTL":
      return w(w({}, t), {}, {
        rtl: Ye(e.rtl, a)
      });
    case "setOrientation":
      return w(w({}, t), {}, {
        orientation: Ye(e.orientation, n)
      });
    case "setCurrentId": {
      var tu = tt(w(w({}, t), {}, {
        currentId: Ye(e.currentId, i)
      }));
      return w(w({}, t), {}, {
        currentId: tu,
        hasSetCurrentId: !0
      });
    }
    case "setLoop":
      return w(w({}, t), {}, {
        loop: Ye(e.loop, u)
      });
    case "setWrap":
      return w(w({}, t), {}, {
        wrap: Ye(e.wrap, l)
      });
    case "setShift":
      return w(w({}, t), {}, {
        shift: Ye(e.shift, m)
      });
    case "setIncludesBaseElement":
      return w(w({}, t), {}, {
        unstable_includesBaseElement: Ye(e.includesBaseElement, c)
      });
    case "reset":
      return w(w({}, t), {}, {
        unstable_virtual: v,
        rtl: f,
        orientation: p,
        currentId: tt(w(w({}, t), {}, {
          currentId: b
        })),
        loop: M,
        wrap: g,
        shift: y,
        unstable_moves: 0,
        pastIds: []
      });
    case "setItems":
      return w(w({}, t), {}, {
        items: e.items
      });
    default:
      throw new Error();
  }
}
function ce(t) {
  return W(t, []);
}
function Es() {
  var t = U(!1);
  return Ze(function() {
    return function() {
      t.current = !0;
    };
  }, []), t;
}
function Ps(t) {
  t === void 0 && (t = {});
  var e = dt(t), r = e.unstable_virtual, a = r === void 0 ? !1 : r, n = e.rtl, o = n === void 0 ? !1 : n, s = e.orientation, i = e.currentId, u = e.loop, l = u === void 0 ? !1 : u, d = e.wrap, m = d === void 0 ? !1 : d, h = e.shift, c = h === void 0 ? !1 : h, v = e.unstable_includesBaseElement, f = ae(e, ["unstable_virtual", "rtl", "orientation", "currentId", "loop", "wrap", "shift", "unstable_includesBaseElement"]), p = ti(f), b = _n(xe, {
    unstable_virtual: a,
    rtl: o,
    orientation: s,
    items: [],
    groups: [],
    currentId: i,
    loop: l,
    wrap: m,
    shift: c,
    unstable_moves: 0,
    pastIds: [],
    unstable_includesBaseElement: v ?? i === null,
    initialVirtual: a,
    initialRTL: o,
    initialOrientation: s,
    initialCurrentId: i,
    initialLoop: l,
    initialWrap: m,
    initialShift: c
  }), M = b[0];
  M.pastIds, M.initialVirtual, M.initialRTL, M.initialOrientation, M.initialCurrentId, M.initialLoop, M.initialWrap, M.initialShift, M.hasSetCurrentId;
  var g = ae(M, ["pastIds", "initialVirtual", "initialRTL", "initialOrientation", "initialCurrentId", "initialLoop", "initialWrap", "initialShift", "hasSetCurrentId"]), y = b[1], _ = ie(!1), P = _[0], S = _[1], D = Es(), O = W(function(E) {
    return y({
      type: "setItems",
      items: E
    });
  }, []);
  return ws(g.items, O), w(w(w({}, p), g), {}, {
    unstable_hasActiveWidget: P,
    unstable_setHasActiveWidget: S,
    registerItem: ce(function(E) {
      D.current || y({
        type: "registerItem",
        item: E
      });
    }),
    unregisterItem: ce(function(E) {
      D.current || y({
        type: "unregisterItem",
        id: E
      });
    }),
    registerGroup: ce(function(E) {
      D.current || y({
        type: "registerGroup",
        group: E
      });
    }),
    unregisterGroup: ce(function(E) {
      D.current || y({
        type: "unregisterGroup",
        id: E
      });
    }),
    move: ce(function(E) {
      return y({
        type: "move",
        id: E
      });
    }),
    next: ce(function(E) {
      return y({
        type: "next",
        allTheWay: E
      });
    }),
    previous: ce(function(E) {
      return y({
        type: "previous",
        allTheWay: E
      });
    }),
    up: ce(function(E) {
      return y({
        type: "up",
        allTheWay: E
      });
    }),
    down: ce(function(E) {
      return y({
        type: "down",
        allTheWay: E
      });
    }),
    first: ce(function() {
      return y({
        type: "first"
      });
    }),
    last: ce(function() {
      return y({
        type: "last"
      });
    }),
    sort: ce(function() {
      return y({
        type: "sort"
      });
    }),
    unstable_setVirtual: ce(function(E) {
      return y({
        type: "setVirtual",
        virtual: E
      });
    }),
    setRTL: ce(function(E) {
      return y({
        type: "setRTL",
        rtl: E
      });
    }),
    setOrientation: ce(function(E) {
      return y({
        type: "setOrientation",
        orientation: E
      });
    }),
    setCurrentId: ce(function(E) {
      return y({
        type: "setCurrentId",
        currentId: E
      });
    }),
    setLoop: ce(function(E) {
      return y({
        type: "setLoop",
        loop: E
      });
    }),
    setWrap: ce(function(E) {
      return y({
        type: "setWrap",
        wrap: E
      });
    }),
    setShift: ce(function(E) {
      return y({
        type: "setShift",
        shift: E
      });
    }),
    unstable_setIncludesBaseElement: ce(function(E) {
      return y({
        type: "setIncludesBaseElement",
        includesBaseElement: E
      });
    }),
    reset: ce(function() {
      return y({
        type: "reset"
      });
    })
  });
}
var Pe = "top", Re = "bottom", ke = "right", Se = "left", On = "auto", zt = [Pe, Re, ke, Se], yt = "start", Wt = "end", Ss = "clippingParents", oi = "viewport", xt = "popper", Os = "reference", lo = /* @__PURE__ */ zt.reduce(function(t, e) {
  return t.concat([e + "-" + yt, e + "-" + Wt]);
}, []), ii = /* @__PURE__ */ [].concat(zt, [On]).reduce(function(t, e) {
  return t.concat([e, e + "-" + yt, e + "-" + Wt]);
}, []), xs = "beforeRead", Ds = "read", Cs = "afterRead", Ts = "beforeMain", As = "main", Rs = "afterMain", ks = "beforeWrite", js = "write", Is = "afterWrite", Ls = [xs, Ds, Cs, Ts, As, Rs, ks, js, Is];
function Ne(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Ce(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function it(t) {
  var e = Ce(t).Element;
  return t instanceof e || t instanceof Element;
}
function Ae(t) {
  var e = Ce(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function xn(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Ce(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Ws(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var a = e.styles[r] || {}, n = e.attributes[r] || {}, o = e.elements[r];
    !Ae(o) || !Ne(o) || (Object.assign(o.style, a), Object.keys(n).forEach(function(s) {
      var i = n[s];
      i === !1 ? o.removeAttribute(s) : o.setAttribute(s, i === !0 ? "" : i);
    }));
  });
}
function Fs(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(a) {
      var n = e.elements[a], o = e.attributes[a] || {}, s = Object.keys(e.styles.hasOwnProperty(a) ? e.styles[a] : r[a]), i = s.reduce(function(u, l) {
        return u[l] = "", u;
      }, {});
      !Ae(n) || !Ne(n) || (Object.assign(n.style, i), Object.keys(o).forEach(function(u) {
        n.removeAttribute(u);
      }));
    });
  };
}
const Ns = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Ws,
  effect: Fs,
  requires: ["computeStyles"]
};
function Fe(t) {
  return t.split("-")[0];
}
var at = Math.max, nr = Math.min, bt = Math.round;
function Lr() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function ui() {
  return !/^((?!chrome|android).)*safari/i.test(Lr());
}
function gt(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var a = t.getBoundingClientRect(), n = 1, o = 1;
  e && Ae(t) && (n = t.offsetWidth > 0 && bt(a.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && bt(a.height) / t.offsetHeight || 1);
  var s = it(t) ? Ce(t) : window, i = s.visualViewport, u = !ui() && r, l = (a.left + (u && i ? i.offsetLeft : 0)) / n, d = (a.top + (u && i ? i.offsetTop : 0)) / o, m = a.width / n, h = a.height / o;
  return {
    width: m,
    height: h,
    top: d,
    right: l + m,
    bottom: d + h,
    left: l,
    x: l,
    y: d
  };
}
function Dn(t) {
  var e = gt(t), r = t.offsetWidth, a = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - a) <= 1 && (a = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: a
  };
}
function si(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && xn(r)) {
    var a = e;
    do {
      if (a && t.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Ue(t) {
  return Ce(t).getComputedStyle(t);
}
function Hs(t) {
  return ["table", "td", "th"].indexOf(Ne(t)) >= 0;
}
function et(t) {
  return ((it(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function dr(t) {
  return Ne(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (xn(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    et(t)
  );
}
function co(t) {
  return !Ae(t) || // https://github.com/popperjs/popper-core/issues/837
  Ue(t).position === "fixed" ? null : t.offsetParent;
}
function Bs(t) {
  var e = /firefox/i.test(Lr()), r = /Trident/i.test(Lr());
  if (r && Ae(t)) {
    var a = Ue(t);
    if (a.position === "fixed")
      return null;
  }
  var n = dr(t);
  for (xn(n) && (n = n.host); Ae(n) && ["html", "body"].indexOf(Ne(n)) < 0; ) {
    var o = Ue(n);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function $t(t) {
  for (var e = Ce(t), r = co(t); r && Hs(r) && Ue(r).position === "static"; )
    r = co(r);
  return r && (Ne(r) === "html" || Ne(r) === "body" && Ue(r).position === "static") ? e : r || Bs(t) || e;
}
function Cn(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function At(t, e, r) {
  return at(t, nr(e, r));
}
function zs(t, e, r) {
  var a = At(t, e, r);
  return a > r ? r : a;
}
function li() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function di(t) {
  return Object.assign({}, li(), t);
}
function ci(t, e) {
  return e.reduce(function(r, a) {
    return r[a] = t, r;
  }, {});
}
var $s = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, di(typeof e != "number" ? e : ci(e, zt));
};
function qs(t) {
  var e, r = t.state, a = t.name, n = t.options, o = r.elements.arrow, s = r.modifiersData.popperOffsets, i = Fe(r.placement), u = Cn(i), l = [Se, ke].indexOf(i) >= 0, d = l ? "height" : "width";
  if (!(!o || !s)) {
    var m = $s(n.padding, r), h = Dn(o), c = u === "y" ? Pe : Se, v = u === "y" ? Re : ke, f = r.rects.reference[d] + r.rects.reference[u] - s[u] - r.rects.popper[d], p = s[u] - r.rects.reference[u], b = $t(o), M = b ? u === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, g = f / 2 - p / 2, y = m[c], _ = M - h[d] - m[v], P = M / 2 - h[d] / 2 + g, S = At(y, P, _), D = u;
    r.modifiersData[a] = (e = {}, e[D] = S, e.centerOffset = S - P, e);
  }
}
function Vs(t) {
  var e = t.state, r = t.options, a = r.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = e.elements.popper.querySelector(n), !n) || si(e.elements.popper, n) && (e.elements.arrow = n));
}
const Ks = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: qs,
  effect: Vs,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Mt(t) {
  return t.split("-")[1];
}
var Us = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ys(t, e) {
  var r = t.x, a = t.y, n = e.devicePixelRatio || 1;
  return {
    x: bt(r * n) / n || 0,
    y: bt(a * n) / n || 0
  };
}
function fo(t) {
  var e, r = t.popper, a = t.popperRect, n = t.placement, o = t.variation, s = t.offsets, i = t.position, u = t.gpuAcceleration, l = t.adaptive, d = t.roundOffsets, m = t.isFixed, h = s.x, c = h === void 0 ? 0 : h, v = s.y, f = v === void 0 ? 0 : v, p = typeof d == "function" ? d({
    x: c,
    y: f
  }) : {
    x: c,
    y: f
  };
  c = p.x, f = p.y;
  var b = s.hasOwnProperty("x"), M = s.hasOwnProperty("y"), g = Se, y = Pe, _ = window;
  if (l) {
    var P = $t(r), S = "clientHeight", D = "clientWidth";
    if (P === Ce(r) && (P = et(r), Ue(P).position !== "static" && i === "absolute" && (S = "scrollHeight", D = "scrollWidth")), P = P, n === Pe || (n === Se || n === ke) && o === Wt) {
      y = Re;
      var O = m && P === _ && _.visualViewport ? _.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        P[S]
      );
      f -= O - a.height, f *= u ? 1 : -1;
    }
    if (n === Se || (n === Pe || n === Re) && o === Wt) {
      g = ke;
      var E = m && P === _ && _.visualViewport ? _.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        P[D]
      );
      c -= E - a.width, c *= u ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: i
  }, l && Us), x = d === !0 ? Ys({
    x: c,
    y: f
  }, Ce(r)) : {
    x: c,
    y: f
  };
  if (c = x.x, f = x.y, u) {
    var C;
    return Object.assign({}, R, (C = {}, C[y] = M ? "0" : "", C[g] = b ? "0" : "", C.transform = (_.devicePixelRatio || 1) <= 1 ? "translate(" + c + "px, " + f + "px)" : "translate3d(" + c + "px, " + f + "px, 0)", C));
  }
  return Object.assign({}, R, (e = {}, e[y] = M ? f + "px" : "", e[g] = b ? c + "px" : "", e.transform = "", e));
}
function Xs(t) {
  var e = t.state, r = t.options, a = r.gpuAcceleration, n = a === void 0 ? !0 : a, o = r.adaptive, s = o === void 0 ? !0 : o, i = r.roundOffsets, u = i === void 0 ? !0 : i, l = {
    placement: Fe(e.placement),
    variation: Mt(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: n,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, fo(Object.assign({}, l, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: u
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, fo(Object.assign({}, l, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const Gs = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Xs,
  data: {}
};
var Yt = {
  passive: !0
};
function Js(t) {
  var e = t.state, r = t.instance, a = t.options, n = a.scroll, o = n === void 0 ? !0 : n, s = a.resize, i = s === void 0 ? !0 : s, u = Ce(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && l.forEach(function(d) {
    d.addEventListener("scroll", r.update, Yt);
  }), i && u.addEventListener("resize", r.update, Yt), function() {
    o && l.forEach(function(d) {
      d.removeEventListener("scroll", r.update, Yt);
    }), i && u.removeEventListener("resize", r.update, Yt);
  };
}
const Qs = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Js,
  data: {}
};
var Zs = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Zt(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return Zs[e];
  });
}
var el = {
  start: "end",
  end: "start"
};
function vo(t) {
  return t.replace(/start|end/g, function(e) {
    return el[e];
  });
}
function Tn(t) {
  var e = Ce(t), r = e.pageXOffset, a = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function An(t) {
  return gt(et(t)).left + Tn(t).scrollLeft;
}
function tl(t, e) {
  var r = Ce(t), a = et(t), n = r.visualViewport, o = a.clientWidth, s = a.clientHeight, i = 0, u = 0;
  if (n) {
    o = n.width, s = n.height;
    var l = ui();
    (l || !l && e === "fixed") && (i = n.offsetLeft, u = n.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: i + An(t),
    y: u
  };
}
function rl(t) {
  var e, r = et(t), a = Tn(t), n = (e = t.ownerDocument) == null ? void 0 : e.body, o = at(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), s = at(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), i = -a.scrollLeft + An(t), u = -a.scrollTop;
  return Ue(n || r).direction === "rtl" && (i += at(r.clientWidth, n ? n.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: i,
    y: u
  };
}
function Rn(t) {
  var e = Ue(t), r = e.overflow, a = e.overflowX, n = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + a);
}
function fi(t) {
  return ["html", "body", "#document"].indexOf(Ne(t)) >= 0 ? t.ownerDocument.body : Ae(t) && Rn(t) ? t : fi(dr(t));
}
function Rt(t, e) {
  var r;
  e === void 0 && (e = []);
  var a = fi(t), n = a === ((r = t.ownerDocument) == null ? void 0 : r.body), o = Ce(a), s = n ? [o].concat(o.visualViewport || [], Rn(a) ? a : []) : a, i = e.concat(s);
  return n ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(Rt(dr(s)))
  );
}
function Wr(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function al(t, e) {
  var r = gt(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function mo(t, e, r) {
  return e === oi ? Wr(tl(t, r)) : it(e) ? al(e, r) : Wr(rl(et(t)));
}
function nl(t) {
  var e = Rt(dr(t)), r = ["absolute", "fixed"].indexOf(Ue(t).position) >= 0, a = r && Ae(t) ? $t(t) : t;
  return it(a) ? e.filter(function(n) {
    return it(n) && si(n, a) && Ne(n) !== "body";
  }) : [];
}
function ol(t, e, r, a) {
  var n = e === "clippingParents" ? nl(t) : [].concat(e), o = [].concat(n, [r]), s = o[0], i = o.reduce(function(u, l) {
    var d = mo(t, l, a);
    return u.top = at(d.top, u.top), u.right = nr(d.right, u.right), u.bottom = nr(d.bottom, u.bottom), u.left = at(d.left, u.left), u;
  }, mo(t, s, a));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function vi(t) {
  var e = t.reference, r = t.element, a = t.placement, n = a ? Fe(a) : null, o = a ? Mt(a) : null, s = e.x + e.width / 2 - r.width / 2, i = e.y + e.height / 2 - r.height / 2, u;
  switch (n) {
    case Pe:
      u = {
        x: s,
        y: e.y - r.height
      };
      break;
    case Re:
      u = {
        x: s,
        y: e.y + e.height
      };
      break;
    case ke:
      u = {
        x: e.x + e.width,
        y: i
      };
      break;
    case Se:
      u = {
        x: e.x - r.width,
        y: i
      };
      break;
    default:
      u = {
        x: e.x,
        y: e.y
      };
  }
  var l = n ? Cn(n) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (o) {
      case yt:
        u[l] = u[l] - (e[d] / 2 - r[d] / 2);
        break;
      case Wt:
        u[l] = u[l] + (e[d] / 2 - r[d] / 2);
        break;
    }
  }
  return u;
}
function Ft(t, e) {
  e === void 0 && (e = {});
  var r = e, a = r.placement, n = a === void 0 ? t.placement : a, o = r.strategy, s = o === void 0 ? t.strategy : o, i = r.boundary, u = i === void 0 ? Ss : i, l = r.rootBoundary, d = l === void 0 ? oi : l, m = r.elementContext, h = m === void 0 ? xt : m, c = r.altBoundary, v = c === void 0 ? !1 : c, f = r.padding, p = f === void 0 ? 0 : f, b = di(typeof p != "number" ? p : ci(p, zt)), M = h === xt ? Os : xt, g = t.rects.popper, y = t.elements[v ? M : h], _ = ol(it(y) ? y : y.contextElement || et(t.elements.popper), u, d, s), P = gt(t.elements.reference), S = vi({
    reference: P,
    element: g,
    strategy: "absolute",
    placement: n
  }), D = Wr(Object.assign({}, g, S)), O = h === xt ? D : P, E = {
    top: _.top - O.top + b.top,
    bottom: O.bottom - _.bottom + b.bottom,
    left: _.left - O.left + b.left,
    right: O.right - _.right + b.right
  }, R = t.modifiersData.offset;
  if (h === xt && R) {
    var x = R[n];
    Object.keys(E).forEach(function(C) {
      var L = [ke, Re].indexOf(C) >= 0 ? 1 : -1, T = [Pe, Re].indexOf(C) >= 0 ? "y" : "x";
      E[C] += x[T] * L;
    });
  }
  return E;
}
function il(t, e) {
  e === void 0 && (e = {});
  var r = e, a = r.placement, n = r.boundary, o = r.rootBoundary, s = r.padding, i = r.flipVariations, u = r.allowedAutoPlacements, l = u === void 0 ? ii : u, d = Mt(a), m = d ? i ? lo : lo.filter(function(v) {
    return Mt(v) === d;
  }) : zt, h = m.filter(function(v) {
    return l.indexOf(v) >= 0;
  });
  h.length === 0 && (h = m);
  var c = h.reduce(function(v, f) {
    return v[f] = Ft(t, {
      placement: f,
      boundary: n,
      rootBoundary: o,
      padding: s
    })[Fe(f)], v;
  }, {});
  return Object.keys(c).sort(function(v, f) {
    return c[v] - c[f];
  });
}
function ul(t) {
  if (Fe(t) === On)
    return [];
  var e = Zt(t);
  return [vo(t), e, vo(e)];
}
function sl(t) {
  var e = t.state, r = t.options, a = t.name;
  if (!e.modifiersData[a]._skip) {
    for (var n = r.mainAxis, o = n === void 0 ? !0 : n, s = r.altAxis, i = s === void 0 ? !0 : s, u = r.fallbackPlacements, l = r.padding, d = r.boundary, m = r.rootBoundary, h = r.altBoundary, c = r.flipVariations, v = c === void 0 ? !0 : c, f = r.allowedAutoPlacements, p = e.options.placement, b = Fe(p), M = b === p, g = u || (M || !v ? [Zt(p)] : ul(p)), y = [p].concat(g).reduce(function(de, te) {
      return de.concat(Fe(te) === On ? il(e, {
        placement: te,
        boundary: d,
        rootBoundary: m,
        padding: l,
        flipVariations: v,
        allowedAutoPlacements: f
      }) : te);
    }, []), _ = e.rects.reference, P = e.rects.popper, S = /* @__PURE__ */ new Map(), D = !0, O = y[0], E = 0; E < y.length; E++) {
      var R = y[E], x = Fe(R), C = Mt(R) === yt, L = [Pe, Re].indexOf(x) >= 0, T = L ? "width" : "height", I = Ft(e, {
        placement: R,
        boundary: d,
        rootBoundary: m,
        altBoundary: h,
        padding: l
      }), G = L ? C ? ke : Se : C ? Re : Pe;
      _[T] > P[T] && (G = Zt(G));
      var Z = Zt(G), ee = [];
      if (o && ee.push(I[x] <= 0), i && ee.push(I[G] <= 0, I[Z] <= 0), ee.every(function(de) {
        return de;
      })) {
        O = R, D = !1;
        break;
      }
      S.set(R, ee);
    }
    if (D)
      for (var le = v ? 3 : 1, ne = function(te) {
        var J = y.find(function(ge) {
          var ve = S.get(ge);
          if (ve)
            return ve.slice(0, te).every(function(we) {
              return we;
            });
        });
        if (J)
          return O = J, "break";
      }, oe = le; oe > 0; oe--) {
        var be = ne(oe);
        if (be === "break")
          break;
      }
    e.placement !== O && (e.modifiersData[a]._skip = !0, e.placement = O, e.reset = !0);
  }
}
const ll = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: sl,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ho(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function po(t) {
  return [Pe, ke, Re, Se].some(function(e) {
    return t[e] >= 0;
  });
}
function dl(t) {
  var e = t.state, r = t.name, a = e.rects.reference, n = e.rects.popper, o = e.modifiersData.preventOverflow, s = Ft(e, {
    elementContext: "reference"
  }), i = Ft(e, {
    altBoundary: !0
  }), u = ho(s, a), l = ho(i, n, o), d = po(u), m = po(l);
  e.modifiersData[r] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: m
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": m
  });
}
const cl = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: dl
};
function fl(t, e, r) {
  var a = Fe(t), n = [Se, Pe].indexOf(a) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, s = o[0], i = o[1];
  return s = s || 0, i = (i || 0) * n, [Se, ke].indexOf(a) >= 0 ? {
    x: i,
    y: s
  } : {
    x: s,
    y: i
  };
}
function vl(t) {
  var e = t.state, r = t.options, a = t.name, n = r.offset, o = n === void 0 ? [0, 0] : n, s = ii.reduce(function(d, m) {
    return d[m] = fl(m, e.rects, o), d;
  }, {}), i = s[e.placement], u = i.x, l = i.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += u, e.modifiersData.popperOffsets.y += l), e.modifiersData[a] = s;
}
const ml = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: vl
};
function hl(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = vi({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const pl = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: hl,
  data: {}
};
function yl(t) {
  return t === "x" ? "y" : "x";
}
function bl(t) {
  var e = t.state, r = t.options, a = t.name, n = r.mainAxis, o = n === void 0 ? !0 : n, s = r.altAxis, i = s === void 0 ? !1 : s, u = r.boundary, l = r.rootBoundary, d = r.altBoundary, m = r.padding, h = r.tether, c = h === void 0 ? !0 : h, v = r.tetherOffset, f = v === void 0 ? 0 : v, p = Ft(e, {
    boundary: u,
    rootBoundary: l,
    padding: m,
    altBoundary: d
  }), b = Fe(e.placement), M = Mt(e.placement), g = !M, y = Cn(b), _ = yl(y), P = e.modifiersData.popperOffsets, S = e.rects.reference, D = e.rects.popper, O = typeof f == "function" ? f(Object.assign({}, e.rects, {
    placement: e.placement
  })) : f, E = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), R = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, x = {
    x: 0,
    y: 0
  };
  if (P) {
    if (o) {
      var C, L = y === "y" ? Pe : Se, T = y === "y" ? Re : ke, I = y === "y" ? "height" : "width", G = P[y], Z = G + p[L], ee = G - p[T], le = c ? -D[I] / 2 : 0, ne = M === yt ? S[I] : D[I], oe = M === yt ? -D[I] : -S[I], be = e.elements.arrow, de = c && be ? Dn(be) : {
        width: 0,
        height: 0
      }, te = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : li(), J = te[L], ge = te[T], ve = At(0, S[I], de[I]), we = g ? S[I] / 2 - le - ve - J - E.mainAxis : ne - ve - J - E.mainAxis, A = g ? -S[I] / 2 + le + ve + ge + E.mainAxis : oe + ve + ge + E.mainAxis, j = e.elements.arrow && $t(e.elements.arrow), V = j ? y === "y" ? j.clientTop || 0 : j.clientLeft || 0 : 0, B = (C = R == null ? void 0 : R[y]) != null ? C : 0, H = G + we - B - V, Y = G + A - B, z = At(c ? nr(Z, H) : Z, G, c ? at(ee, Y) : ee);
      P[y] = z, x[y] = z - G;
    }
    if (i) {
      var $, K = y === "x" ? Pe : Se, re = y === "x" ? Re : ke, q = P[_], k = _ === "y" ? "height" : "width", ue = q + p[K], Me = q - p[re], je = [Pe, Se].indexOf(b) !== -1, qt = ($ = R == null ? void 0 : R[_]) != null ? $ : 0, Vt = je ? ue : q - S[k] - D[k] - qt + E.altAxis, Kt = je ? q + S[k] + D[k] - qt - E.altAxis : Me, Ut = c && je ? zs(Vt, q, Kt) : At(c ? Vt : ue, q, c ? Kt : Me);
      P[_] = Ut, x[_] = Ut - q;
    }
    e.modifiersData[a] = x;
  }
}
const gl = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: bl,
  requiresIfExists: ["offset"]
};
function Ml(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function _l(t) {
  return t === Ce(t) || !Ae(t) ? Tn(t) : Ml(t);
}
function wl(t) {
  var e = t.getBoundingClientRect(), r = bt(e.width) / t.offsetWidth || 1, a = bt(e.height) / t.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function El(t, e, r) {
  r === void 0 && (r = !1);
  var a = Ae(e), n = Ae(e) && wl(e), o = et(e), s = gt(t, n, r), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((Ne(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Rn(o)) && (i = _l(e)), Ae(e) ? (u = gt(e, !0), u.x += e.clientLeft, u.y += e.clientTop) : o && (u.x = An(o))), {
    x: s.left + i.scrollLeft - u.x,
    y: s.top + i.scrollTop - u.y,
    width: s.width,
    height: s.height
  };
}
function Pl(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  t.forEach(function(o) {
    e.set(o.name, o);
  });
  function n(o) {
    r.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(i) {
      if (!r.has(i)) {
        var u = e.get(i);
        u && n(u);
      }
    }), a.push(o);
  }
  return t.forEach(function(o) {
    r.has(o.name) || n(o);
  }), a;
}
function Sl(t) {
  var e = Pl(t);
  return Ls.reduce(function(r, a) {
    return r.concat(e.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function Ol(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function xl(t) {
  var e = t.reduce(function(r, a) {
    var n = r[a.name];
    return r[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var yo = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function bo() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function Dl(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, a = r === void 0 ? [] : r, n = e.defaultOptions, o = n === void 0 ? yo : n;
  return function(i, u, l) {
    l === void 0 && (l = o);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, yo, o),
      modifiersData: {},
      elements: {
        reference: i,
        popper: u
      },
      attributes: {},
      styles: {}
    }, m = [], h = !1, c = {
      state: d,
      setOptions: function(b) {
        var M = typeof b == "function" ? b(d.options) : b;
        f(), d.options = Object.assign({}, o, d.options, M), d.scrollParents = {
          reference: it(i) ? Rt(i) : i.contextElement ? Rt(i.contextElement) : [],
          popper: Rt(u)
        };
        var g = Sl(xl([].concat(a, d.options.modifiers)));
        return d.orderedModifiers = g.filter(function(y) {
          return y.enabled;
        }), v(), c.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var b = d.elements, M = b.reference, g = b.popper;
          if (bo(M, g)) {
            d.rects = {
              reference: El(M, $t(g), d.options.strategy === "fixed"),
              popper: Dn(g)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(E) {
              return d.modifiersData[E.name] = Object.assign({}, E.data);
            });
            for (var y = 0; y < d.orderedModifiers.length; y++) {
              if (d.reset === !0) {
                d.reset = !1, y = -1;
                continue;
              }
              var _ = d.orderedModifiers[y], P = _.fn, S = _.options, D = S === void 0 ? {} : S, O = _.name;
              typeof P == "function" && (d = P({
                state: d,
                options: D,
                name: O,
                instance: c
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ol(function() {
        return new Promise(function(p) {
          c.forceUpdate(), p(d);
        });
      }),
      destroy: function() {
        f(), h = !0;
      }
    };
    if (!bo(i, u))
      return c;
    c.setOptions(l).then(function(p) {
      !h && l.onFirstUpdate && l.onFirstUpdate(p);
    });
    function v() {
      d.orderedModifiers.forEach(function(p) {
        var b = p.name, M = p.options, g = M === void 0 ? {} : M, y = p.effect;
        if (typeof y == "function") {
          var _ = y({
            state: d,
            name: b,
            instance: c,
            options: g
          }), P = function() {
          };
          m.push(_ || P);
        }
      });
    }
    function f() {
      m.forEach(function(p) {
        return p();
      }), m = [];
    }
    return c;
  };
}
var Cl = [Qs, pl, Gs, Ns, ml, ll, gl, Ks, cl], Tl = /* @__PURE__ */ Dl({
  defaultModifiers: Cl
});
function Al(t) {
  var e = U(null);
  return Ze(function() {
    e.current = t;
  }, [t]), e;
}
function mi(t) {
  t === void 0 && (t = {});
  var e = dt(t), r = e.visible, a = r === void 0 ? !1 : r, n = e.animated, o = n === void 0 ? !1 : n, s = ae(e, ["visible", "animated"]), i = ti(s), u = ie(a), l = u[0], d = u[1], m = ie(o), h = m[0], c = m[1], v = ie(!1), f = v[0], p = v[1], b = Al(l), M = b.current != null && b.current !== l;
  h && !f && M && p(!0), X(function() {
    if (typeof h == "number" && f) {
      var S = setTimeout(function() {
        return p(!1);
      }, h);
      return function() {
        clearTimeout(S);
      };
    }
    if (h && f && process.env.NODE_ENV === "development") {
      var D = setTimeout(function() {
        process.env.NODE_ENV !== "production" && Oe(f, "It's been 8 seconds but stopAnimation has not been called. Does the disclousure element have a CSS transition?");
      }, 8e3);
      return function() {
        clearTimeout(D);
      };
    }
    return function() {
    };
  }, [h, f]);
  var g = W(function() {
    return d(!0);
  }, []), y = W(function() {
    return d(!1);
  }, []), _ = W(function() {
    return d(function(S) {
      return !S;
    });
  }, []), P = W(function() {
    return p(!1);
  }, []);
  return w(w({}, i), {}, {
    visible: l,
    animated: h,
    animating: f,
    show: g,
    hide: y,
    toggle: _,
    setVisible: d,
    setAnimated: c,
    stopAnimation: P
  });
}
function Rl(t) {
  t === void 0 && (t = {});
  var e = dt(t), r = e.modal, a = r === void 0 ? !0 : r, n = ae(e, ["modal"]), o = mi(n), s = ie(a), i = s[0], u = s[1], l = U(null);
  return w(w({}, o), {}, {
    modal: i,
    setModal: u,
    unstable_disclosureRef: l
  });
}
var kl = rt("Mac") && !rt("Chrome") && rt("Safari");
function go(t) {
  return function(e) {
    return t && !It(e, t) ? t : e;
  };
}
function jl(t) {
  t === void 0 && (t = {});
  var e = dt(t), r = e.gutter, a = r === void 0 ? 12 : r, n = e.placement, o = n === void 0 ? "bottom" : n, s = e.unstable_flip, i = s === void 0 ? !0 : s, u = e.unstable_offset, l = e.unstable_preventOverflow, d = l === void 0 ? !0 : l, m = e.unstable_fixed, h = m === void 0 ? !1 : m, c = e.modal, v = c === void 0 ? !1 : c, f = ae(e, ["gutter", "placement", "unstable_flip", "unstable_offset", "unstable_preventOverflow", "unstable_fixed", "modal"]), p = U(null), b = U(null), M = U(null), g = U(null), y = ie(o), _ = y[0], P = y[1], S = ie(o), D = S[0], O = S[1], E = ie(u || [0, a]), R = E[0], x = ie({
    position: "fixed",
    left: "100%",
    top: "100%"
  }), C = x[0], L = x[1], T = ie({}), I = T[0], G = T[1], Z = Rl(w({
    modal: v
  }, f)), ee = W(function() {
    return p.current ? (p.current.forceUpdate(), !0) : !1;
  }, []), le = W(function(ne) {
    ne.placement && O(ne.placement), ne.styles && (L(go(ne.styles.popper)), g.current && G(go(ne.styles.arrow)));
  }, []);
  return Ze(function() {
    return b.current && M.current && (p.current = Tl(b.current, M.current, {
      // https://popper.js.org/docs/v2/constructors/#options
      placement: _,
      strategy: h ? "fixed" : "absolute",
      // Safari needs styles to be applied in the first render, otherwise
      // hovering over the popover when it gets visible for the first time
      // will change its dimensions unexpectedly.
      onFirstUpdate: kl ? le : void 0,
      modifiers: [{
        // https://popper.js.org/docs/v2/modifiers/event-listeners/
        name: "eventListeners",
        enabled: Z.visible
      }, {
        // https://popper.js.org/docs/v2/modifiers/apply-styles/
        name: "applyStyles",
        enabled: !1
      }, {
        // https://popper.js.org/docs/v2/modifiers/flip/
        name: "flip",
        enabled: i,
        options: {
          padding: 8
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/offset/
        name: "offset",
        options: {
          offset: R
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
        name: "preventOverflow",
        enabled: d,
        options: {
          tetherOffset: function() {
            var oe;
            return ((oe = g.current) === null || oe === void 0 ? void 0 : oe.clientWidth) || 0;
          }
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/arrow/
        name: "arrow",
        enabled: !!g.current,
        options: {
          element: g.current
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
        name: "updateState",
        phase: "write",
        requires: ["computeStyles"],
        enabled: Z.visible && process.env.NODE_ENV !== "test",
        fn: function(oe) {
          var be = oe.state;
          return le(be);
        }
      }]
    })), function() {
      p.current && (p.current.destroy(), p.current = null);
    };
  }, [_, h, Z.visible, i, R, d]), X(function() {
    if (Z.visible) {
      var ne = window.requestAnimationFrame(function() {
        var oe;
        (oe = p.current) === null || oe === void 0 || oe.forceUpdate();
      });
      return function() {
        window.cancelAnimationFrame(ne);
      };
    }
  }, [Z.visible]), w(w({}, Z), {}, {
    unstable_referenceRef: b,
    unstable_popoverRef: M,
    unstable_arrowRef: g,
    unstable_popoverStyles: C,
    unstable_arrowStyles: I,
    unstable_update: ee,
    unstable_originalPlacement: _,
    placement: D,
    place: P
  });
}
var Il = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"], hi = Il, Ll = hi, pi = he({
  name: "DisclosureContent",
  compose: lr,
  keys: Ll,
  useProps: function(e, r) {
    var a = r.onTransitionEnd, n = r.onAnimationEnd, o = r.style, s = ae(r, ["onTransitionEnd", "onAnimationEnd", "style"]), i = e.animated && e.animating, u = ie(null), l = u[0], d = u[1], m = !e.visible && !i, h = m ? w({
      display: "none"
    }, o) : o, c = Q(a), v = Q(n), f = U(0);
    X(function() {
      if (e.animated)
        return f.current = window.requestAnimationFrame(function() {
          f.current = window.requestAnimationFrame(function() {
            e.visible ? d("enter") : d(i ? "leave" : null);
          });
        }), function() {
          return window.cancelAnimationFrame(f.current);
        };
    }, [e.animated, e.visible, i]);
    var p = W(function(g) {
      if (Ie(g) && i && e.animated === !0) {
        var y;
        (y = e.stopAnimation) === null || y === void 0 || y.call(e);
      }
    }, [e.animated, i, e.stopAnimation]), b = W(function(g) {
      var y;
      (y = c.current) === null || y === void 0 || y.call(c, g), p(g);
    }, [p]), M = W(function(g) {
      var y;
      (y = v.current) === null || y === void 0 || y.call(v, g), p(g);
    }, [p]);
    return w({
      id: e.baseId,
      "data-enter": l === "enter" ? "" : void 0,
      "data-leave": l === "leave" ? "" : void 0,
      onTransitionEnd: b,
      onAnimationEnd: M,
      hidden: m,
      style: h
    }, s);
  }
}), Wl = me({
  as: "div",
  useHook: pi
});
function yi() {
  return Pt ? document.body : null;
}
var Mo = /* @__PURE__ */ Qe(yi());
function _t(t) {
  var e = t.children, r = Ee(Mo) || yi(), a = ie(function() {
    if (Pt) {
      var o = document.createElement("div");
      return o.className = _t.__className, o;
    }
    return null;
  }), n = a[0];
  return Ze(function() {
    if (!(!n || !r))
      return r.appendChild(n), function() {
        r.removeChild(n);
      };
  }, [n, r]), n ? /* @__PURE__ */ hu(/* @__PURE__ */ De(Mo.Provider, {
    value: n
  }, e), n) : null;
}
_t.__className = "__reakit-portal";
_t.__selector = "." + _t.__className;
function Fr(t, e) {
  var r = t.indexOf(e);
  return Ku(t, r);
}
var Je = /* @__PURE__ */ Qe(null);
function Fl(t, e, r) {
  var a = "unstable_orphan" in r && r.unstable_orphan, n = Ee(Je), o = ie([]), s = o[0], i = o[1], u = n || {}, l = u.addChild, d = u.removeChild, m = W(function(f) {
    return i(function(p) {
      return [].concat(p, [f]);
    });
  }, []), h = W(function(f) {
    return i(function(p) {
      return Fr(p, f);
    });
  }, []);
  X(function() {
    if (!(!l || a))
      return l(t), function() {
        d == null || d(t);
      };
  }, [t, l, d, a]);
  var c = He(function() {
    return {
      orientation: r.orientation,
      next: r.next,
      previous: r.previous,
      ref: t,
      role: e,
      parent: n,
      children: s,
      addChild: m,
      removeChild: h
    };
  }, [r.orientation, r.next, r.previous, t, e, n, s, m, h]), v = W(function(f) {
    return /* @__PURE__ */ De(Je.Provider, {
      value: c
    }, f);
  }, [c]);
  return v;
}
function Nl(t) {
  if (Array.isArray(t)) {
    for (var e = 0, r = Array(t.length); e < t.length; e++)
      r[e] = t[e];
    return r;
  } else
    return Array.from(t);
}
var kn = !1;
if (typeof window < "u") {
  var _o = {
    get passive() {
      kn = !0;
    }
  };
  window.addEventListener("testPassive", null, _o), window.removeEventListener("testPassive", null, _o);
}
var bi = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), Ge = [], or = !1, gi = -1, kt = void 0, jt = void 0, Mi = function(e) {
  return Ge.some(function(r) {
    return !!(r.options.allowTouchMove && r.options.allowTouchMove(e));
  });
}, ir = function(e) {
  var r = e || window.event;
  return Mi(r.target) || r.touches.length > 1 ? !0 : (r.preventDefault && r.preventDefault(), !1);
}, Hl = function(e) {
  if (jt === void 0) {
    var r = !!e && e.reserveScrollBarGap === !0, a = window.innerWidth - document.documentElement.clientWidth;
    r && a > 0 && (jt = document.body.style.paddingRight, document.body.style.paddingRight = a + "px");
  }
  kt === void 0 && (kt = document.body.style.overflow, document.body.style.overflow = "hidden");
}, Bl = function() {
  jt !== void 0 && (document.body.style.paddingRight = jt, jt = void 0), kt !== void 0 && (document.body.style.overflow = kt, kt = void 0);
}, zl = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, $l = function(e, r) {
  var a = e.targetTouches[0].clientY - gi;
  return Mi(e.target) ? !1 : r && r.scrollTop === 0 && a > 0 || zl(r) && a < 0 ? ir(e) : (e.stopPropagation(), !0);
}, ql = function(e, r) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!Ge.some(function(n) {
    return n.targetElement === e;
  })) {
    var a = {
      targetElement: e,
      options: r || {}
    };
    Ge = [].concat(Nl(Ge), [a]), bi ? (e.ontouchstart = function(n) {
      n.targetTouches.length === 1 && (gi = n.targetTouches[0].clientY);
    }, e.ontouchmove = function(n) {
      n.targetTouches.length === 1 && $l(n, e);
    }, or || (document.addEventListener("touchmove", ir, kn ? { passive: !1 } : void 0), or = !0)) : Hl(r);
  }
}, Vl = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  Ge = Ge.filter(function(r) {
    return r.targetElement !== e;
  }), bi ? (e.ontouchstart = null, e.ontouchmove = null, or && Ge.length === 0 && (document.removeEventListener("touchmove", ir, kn ? { passive: !1 } : void 0), or = !1)) : Ge.length || Bl();
}, Kl = /* @__PURE__ */ Qe(void 0);
function Ul(t) {
  return Array.isArray(t) ? !t.length : En(t) ? !Object.keys(t).length : t == null || t === "";
}
var _i = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"], Yl = [].concat(_i, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]), Xl = _i, Gl = Xl;
function Jl(t, e) {
  var r = U(null), a = !!(e.animated && e.animating);
  return X(function() {
    if (!(e.visible || a)) {
      var n = function(i) {
        var u = i.target;
        "focus" in u && (r.current = u, e.unstable_disclosureRef && (e.unstable_disclosureRef.current = u));
      }, o = pe(t.current);
      return o.addEventListener("focusin", n), function() {
        return o.removeEventListener("focusin", n);
      };
    }
  }, [e.visible, a, e.unstable_disclosureRef, t]), X(function() {
    var n;
    if (!(!e.visible || a)) {
      var o = function(u) {
        var l = u.currentTarget;
        sr(l) && (u.preventDefault(), l.focus());
      }, s = ((n = e.unstable_disclosureRef) === null || n === void 0 ? void 0 : n.current) || r.current;
      return s == null || s.addEventListener("mousedown", o), function() {
        return s == null ? void 0 : s.removeEventListener("mousedown", o);
      };
    }
  }, [e.visible, a, e.unstable_disclosureRef]), e.unstable_disclosureRef || r;
}
function Ql(t, e) {
  var r = !!(e.preventBodyScroll && e.visible);
  X(function() {
    var a = t.current;
    if (!(!a || !r))
      return ql(a, {
        reserveScrollBarGap: !0
      }), function() {
        return Vl(a);
      };
  }, [t, r]);
}
function Zl(t, e, r) {
  var a = r.unstable_initialFocusRef, n = r.visible && r.unstable_autoFocusOnShow, o = !!(r.animated && r.animating);
  Uo(function() {
    var s = t.current;
    if (process.env.NODE_ENV !== "production" && Oe(!!n && !s, "[reakit/Dialog]", "Can't set initial focus on dialog because `ref` wasn't passed to the dialog element.", "See https://reakit.io/docs/dialog"), !!n && s && !o && !e.some(function(l) {
      return l.current && !l.current.hidden;
    }))
      if (a != null && a.current)
        a.current.focus({
          preventScroll: !0
        });
      else {
        var i = qo(s, !0), u = function() {
          return Bt(s);
        };
        i ? Lt(i, {
          preventScroll: !0,
          isActive: u
        }) : (Lt(s, {
          preventScroll: !0,
          isActive: u
        }), process.env.NODE_ENV !== "production" && Oe(s.tabIndex === void 0 || s.tabIndex < 0, "It's recommended to have at least one tabbable element inside dialog. The dialog element has been automatically focused.", "If this is the intended behavior, pass `tabIndex={0}` to the dialog element to disable this warning.", "See https://reakit.io/docs/dialog/#initial-focus", s));
      }
  }, [t, n, o, e, a]);
}
function ed(t, e) {
  var r = U(null);
  return X(function() {
    var a = t.current;
    !a || !e.visible || (r.current = Ho(a, _t.__selector));
  }, [t, e.visible]), r;
}
function wo(t) {
  t.parentNode != null && t.parentNode.removeChild(t);
}
var wi = "__reakit-focus-trap";
function td(t) {
  var e;
  return (e = t.classList) === null || e === void 0 ? void 0 : e.contains(wi);
}
function rd(t, e, r) {
  var a = ed(t, r), n = r.visible && r.modal, o = U(null), s = U(null);
  X(function() {
    if (n) {
      var i = a.current;
      if (!i) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't trap focus within modal dialog because either `ref` wasn't passed to component or the component wasn't rendered within a portal", "See https://reakit.io/docs/dialog");
        return;
      }
      if (!o.current) {
        var u = pe(i);
        o.current = u.createElement("div"), o.current.className = wi, o.current.tabIndex = 0, o.current.style.position = "fixed", o.current.setAttribute("aria-hidden", "true");
      }
      return s.current || (s.current = o.current.cloneNode()), i.insertAdjacentElement("beforebegin", o.current), i.insertAdjacentElement("afterend", s.current), function() {
        o.current && wo(o.current), s.current && wo(s.current);
      };
    }
  }, [a, n]), X(function() {
    var i = o.current, u = s.current;
    if (!(!n || !i || !u)) {
      var l = function(m) {
        var h = t.current;
        if (!(!h || e.length)) {
          m.preventDefault();
          var c = m.target === u, v = c ? qo(h) : Iu(h);
          v ? v.focus() : h.focus();
        }
      };
      return i.addEventListener("focus", l), u.addEventListener("focus", l), function() {
        i.removeEventListener("focus", l), u.removeEventListener("focus", l);
      };
    }
  }, [t, e, n]);
}
function ad(t) {
  var e = t.current;
  if (!e)
    return !1;
  var r = St(e);
  return !r || We(e, r) ? !1 : !!(Rr(r) || r.getAttribute("data-dialog") === "true");
}
function nd(t, e, r) {
  var a = r.unstable_autoFocusOnHide && !r.visible, n = !!(r.animated && r.animating);
  Uo(function() {
    var o;
    if (a && !n && !ad(t)) {
      var s = ((o = r.unstable_finalFocusRef) === null || o === void 0 ? void 0 : o.current) || e.current;
      if (s) {
        if (s.id) {
          var i = pe(s), u = i.querySelector("[aria-activedescendant='" + s.id + "']");
          if (u) {
            Lt(u);
            return;
          }
        }
        Lt(s);
        return;
      }
      process.env.NODE_ENV !== "production" && Oe(!0, "Can't return focus after closing dialog. Either render a disclosure component or provide a `unstable_finalFocusRef` prop.", "See https://reakit.io/docs/dialog", t.current);
    }
  }, [a, n, t, e]);
}
var Eo = /* @__PURE__ */ Qe({});
function od(t, e) {
  var r = Ee(Eo), a = ie([]), n = a[0], o = a[1], s = ie(n), i = s[0], u = s[1], l = W(function(f) {
    var p;
    (p = r.addDialog) === null || p === void 0 || p.call(r, f), o(function(b) {
      return [].concat(b, [f]);
    });
  }, [r.addDialog]), d = W(function(f) {
    var p;
    (p = r.removeDialog) === null || p === void 0 || p.call(r, f), o(function(b) {
      return Fr(b, f);
    });
  }, [r.removeDialog]), m = W(function(f) {
    var p;
    (p = r.showDialog) === null || p === void 0 || p.call(r, f), u(function(b) {
      return [].concat(b, [f]);
    });
  }, [r.showDialog]), h = W(function(f) {
    var p;
    (p = r.hideDialog) === null || p === void 0 || p.call(r, f), u(function(b) {
      return Fr(b, f);
    });
  }, [r.hideDialog]);
  X(function() {
    var f;
    if (!e.unstable_orphan)
      return (f = r.addDialog) === null || f === void 0 || f.call(r, t), function() {
        var p;
        (p = r.removeDialog) === null || p === void 0 || p.call(r, t);
      };
  }, [e.unstable_orphan, r.addDialog, t, r.removeDialog]), X(function() {
    var f;
    if (!e.unstable_orphan && e.modal && e.visible)
      return (f = r.showDialog) === null || f === void 0 || f.call(r, t), function() {
        var p;
        (p = r.hideDialog) === null || p === void 0 || p.call(r, t);
      };
  }, [e.unstable_orphan, e.modal, e.visible, r.showDialog, t, r.hideDialog]), X(function() {
    if (r.visible === !1 && e.visible && !e.unstable_orphan) {
      var f;
      (f = e.hide) === null || f === void 0 || f.call(e);
    }
  }, [r.visible, e.visible, e.hide, e.unstable_orphan]);
  var c = He(function() {
    return {
      visible: e.visible,
      addDialog: l,
      removeDialog: d,
      showDialog: m,
      hideDialog: h
    };
  }, [e.visible, l, d, m, h]), v = W(function(f) {
    return /* @__PURE__ */ De(Eo.Provider, {
      value: c
    }, f);
  }, [c]);
  return {
    dialogs: n,
    visibleModals: i,
    wrap: v
  };
}
function id(t) {
  return function(e) {
    var r = e.current;
    if (!r)
      return !1;
    if (We(r, t))
      return !0;
    var a = pe(r), n = a.querySelector('[data-dialog-ref="' + r.id + '"]');
    return n ? We(n, t) : !1;
  };
}
function ud(t, e) {
  return We(e, t);
}
function sd(t) {
  var e = pe(t);
  return t.tagName === "HTML" ? !0 : We(e.body, t);
}
function Nr(t, e, r, a, n, o, s) {
  var i = Q(n);
  X(function() {
    if (o) {
      var u = function(m) {
        if (i.current) {
          var h = t.current, c = e.current, v = m.target;
          if (!h) {
            process.env.NODE_ENV !== "production" && Oe(!0, "Can't detect events outside dialog because `ref` wasn't passed to component.", "See https://reakit.io/docs/dialog");
            return;
          }
          sd(v) && (We(h, v) || c && ud(v, c) || td(v) || r.some(id(v)) || i.current(m));
        }
      }, l = pe(t.current);
      return l.addEventListener(a, u, s), function() {
        return l.removeEventListener(a, u, s);
      };
    }
  }, [t, e, r, a, o, i]);
}
function ld(t, e) {
  var r = U();
  return X(function() {
    if (e.visible && e.hideOnClickOutside) {
      var a = pe(t.current), n = function(s) {
        r.current = s.target;
      };
      return a.addEventListener("mousedown", n), function() {
        return a.removeEventListener("mousedown", n);
      };
    }
  }, [e.visible, e.hideOnClickOutside, t]), r;
}
function dd(t, e, r, a) {
  var n = ld(t, a);
  Nr(t, e, r, "click", function(o) {
    if (n.current === o.target) {
      var s;
      (s = a.hide) === null || s === void 0 || s.call(a);
    }
  }, a.visible && a.hideOnClickOutside), Nr(t, e, r, "focusin", function(o) {
    var s = pe(t.current);
    if (o.target !== s && o.target !== s.body) {
      var i;
      (i = a.hide) === null || i === void 0 || i.call(a);
    }
  }, a.visible && a.hideOnClickOutside);
}
function cd(t, e, r) {
  var a = function(o) {
    return Nr(t, {
      current: null
    }, e, o, function(s) {
      s.stopPropagation(), s.preventDefault();
    }, r.visible && r.modal, !0);
  };
  a("mouseover"), a("mousemove"), a("mouseout");
}
function fd(t, e) {
  X(function() {
    var r = t.current;
    if (!(!e.visible || !r)) {
      var a = new MutationObserver(function(n) {
        var o = n[0].target;
        if (o === r) {
          var s = pe(r), i = St(r);
          (i === s.body || Ul(i)) && r.focus();
        }
      });
      return a.observe(r, {
        childList: !0,
        subtree: !0
      }), function() {
        a.disconnect();
      };
    }
  }, [e.visible, t]);
}
function Po(t) {
  return t && t.tagName && t.tagName !== "HTML" && t !== pe(t).body;
}
function vd(t, e) {
  var r = _n(function(s) {
    return s + 1;
  }, 0), a = r[0], n = r[1];
  Ze(function() {
    var s = t.current;
    e.visible && a && (Po(St(s)) || (process.env.NODE_ENV !== "production" && Oe(!s, "Can't focus dialog after a nested element got blurred because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), s == null || s.focus()));
  }, [a, t]);
  var o = W(function(s) {
    if (e.visible) {
      var i = Yo(s);
      Po(i) || n();
    }
  }, [e.visible]);
  return o;
}
var Ei = he({
  name: "Dialog",
  compose: pi,
  keys: Yl,
  useOptions: function(e) {
    var r = e.modal, a = r === void 0 ? !0 : r, n = e.hideOnEsc, o = n === void 0 ? !0 : n, s = e.hideOnClickOutside, i = s === void 0 ? !0 : s, u = e.preventBodyScroll, l = u === void 0 ? a : u, d = e.unstable_autoFocusOnShow, m = d === void 0 ? !0 : d, h = e.unstable_autoFocusOnHide, c = h === void 0 ? !0 : h, v = e.unstable_orphan, f = ae(e, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);
    return w({
      modal: a,
      hideOnEsc: o,
      hideOnClickOutside: i,
      preventBodyScroll: a && l,
      unstable_autoFocusOnShow: m,
      unstable_autoFocusOnHide: c,
      unstable_orphan: a && v
    }, f);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onKeyDown, o = r.onBlur, s = r.wrapElement, i = r.tabIndex, u = ae(r, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]), l = U(null), d = Ee(Kl), m = d && d === e.baseId, h = Jl(l, e), c = Q(n), v = Q(o), f = vd(l, e), p = od(l, e), b = p.dialogs, M = p.visibleModals, g = p.wrap, y = e.modal && !M.length ? !0 : void 0;
    Ql(l, e), rd(l, M, e), fd(l, e), Zl(l, b, e), nd(l, h, e), dd(l, h, b, e), cd(l, b, e);
    var _ = W(function(D) {
      var O;
      if ((O = c.current) === null || O === void 0 || O.call(c, D), !D.defaultPrevented && D.key === "Escape" && e.hideOnEsc) {
        if (!e.hide) {
          process.env.NODE_ENV !== "production" && Oe(!0, "`hideOnEsc` prop is truthy, but `hide` prop wasn't provided.", "See https://reakit.io/docs/dialog", l.current);
          return;
        }
        D.stopPropagation(), e.hide();
      }
    }, [e.hideOnEsc, e.hide]), P = W(function(D) {
      var O;
      (O = v.current) === null || O === void 0 || O.call(v, D), f(D);
    }, [f]), S = W(function(D) {
      return D = g(D), e.modal && !m && (D = /* @__PURE__ */ De(_t, null, D)), s && (D = s(D)), // Prevents Menu > Dialog > Menu to behave as a sub menu
      /* @__PURE__ */ De(Je.Provider, {
        value: null
      }, D);
    }, [g, e.modal, m, s]);
    return w({
      ref: Be(l, a),
      role: "dialog",
      tabIndex: i ?? -1,
      "aria-modal": y,
      "data-dialog": !0,
      onKeyDown: _,
      onBlur: P,
      wrapElement: S
    }, u);
  }
});
me({
  as: "div",
  useHook: Ei,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Ht(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/dialog"), Et(e, r, a);
  }
});
var md = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"], Pi = md, hd = Pi, pd = hd, Si = he({
  name: "Popover",
  compose: Ei,
  keys: Pi,
  useOptions: function(e) {
    var r = e.modal, a = r === void 0 ? !1 : r, n = ae(e, ["modal"]);
    return w({
      modal: a
    }, n);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.style, o = ae(r, ["ref", "style"]);
    return w({
      ref: Be(e.unstable_popoverRef, a),
      style: w(w({}, e.unstable_popoverStyles), n)
    }, o);
  }
});
me({
  as: "div",
  useHook: Si,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Ht(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/popover"), Et(e, r, a);
  }
});
var Oi = he({
  name: "Disclosure",
  compose: Vo,
  keys: hi,
  useProps: function(e, r) {
    var a = r.onClick, n = r["aria-controls"], o = ae(r, ["onClick", "aria-controls"]), s = Q(a), i = n ? n + " " + e.baseId : e.baseId, u = W(function(l) {
      var d, m;
      (d = s.current) === null || d === void 0 || d.call(s, l), !l.defaultPrevented && ((m = e.toggle) === null || m === void 0 || m.call(e));
    }, [e.toggle]);
    return w({
      "aria-expanded": !!e.visible,
      "aria-controls": i,
      onClick: u
    }, o);
  }
}), yd = me({
  as: "button",
  memo: !0,
  useHook: Oi
}), xi = he({
  name: "DialogDisclosure",
  compose: Oi,
  keys: Gl,
  useProps: function(e, r) {
    var a = r.ref, n = r.onClick, o = ae(r, ["ref", "onClick"]), s = U(null), i = Q(n), u = ie(!1), l = u[0], d = u[1], m = e.unstable_disclosureRef;
    Ze(function() {
      var c = s.current;
      process.env.NODE_ENV !== "production" && Oe(!c, "Can't determine whether the element is the current disclosure because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), m && !m.current && (m.current = c);
      var v = !(m != null && m.current) || m.current === c;
      d(!!e.visible && v);
    }, [e.visible, m]);
    var h = W(function(c) {
      var v;
      (v = i.current) === null || v === void 0 || v.call(i, c), !c.defaultPrevented && m && (m.current = c.currentTarget);
    }, [m]);
    return w({
      ref: Be(s, a),
      "aria-haspopup": "dialog",
      "aria-expanded": l,
      onClick: h
    }, o);
  }
});
me({
  as: "button",
  memo: !0,
  useHook: xi
});
var bd = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "unstable_values", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "unstable_setValue"], gd = [].concat(bd, ["visible", "animated", "animating", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"]), Di = gd, Md = Di, Ci = Md, Ti = Ci, _d = Ti, wd = _d, Ed = wd;
function Pd(t, e, r) {
  var a = e.items, n = a === void 0 ? [] : a, o = e.move;
  r === void 0 && (r = 500);
  var s = ie(""), i = s[0], u = s[1];
  X(function() {
    if (i) {
      var l = setTimeout(function() {
        return u("");
      }, r), d = n.find(function(m) {
        return !!(m.ref.current && m.ref.current.textContent && m.ref.current.textContent.toLowerCase().startsWith(i));
      });
      return d && o(d.id), function() {
        return clearTimeout(l);
      };
    }
  }, [i, n, o, r]), X(function() {
    var l = t.current;
    if (l) {
      var d = function(h) {
        var c;
        if (!(h.key.length > 1) && !h.shiftKey && !h.metaKey && !h.ctrlKey && !h.altKey) {
          var v = h.target, f = (c = v.getAttribute) === null || c === void 0 ? void 0 : c.call(v, "role"), p = v === l, b = f && f.indexOf("menuitem") !== -1 && Ho(v, "[role=menu],[role=menubar]") === l;
          !p && !b || /^[a-z0-9_-]$/i.test(h.key) && (h.stopPropagation(), h.preventDefault(), u(function(M) {
            return "" + M + h.key;
          }));
        }
      };
      return l.addEventListener("keydown", d), function() {
        return l.removeEventListener("keydown", d);
      };
    }
  }, [t, u]);
}
var Ai = he({
  name: "MenuBar",
  compose: Qo,
  keys: Ci,
  useProps: function(e, r) {
    var a = r.ref, n = r.wrapElement, o = r.role, s = o === void 0 ? "menubar" : o, i = ae(r, ["ref", "wrapElement", "role"]), u = U(null), l = Fl(u, s, e);
    Pd(u, e);
    var d = W(function(m) {
      return m = l(m), n ? n(m) : m;
    }, [l, n]);
    return w({
      ref: Be(u, a),
      role: s,
      "aria-orientation": e.orientation,
      wrapElement: d
    }, i);
  }
});
me({
  as: "div",
  useHook: Ai,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Ht(!r["aria-label"] && !r["aria-labelledby"] && r.role !== "menubar", "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), Et(e, r, a);
  }
});
function Sd(t) {
  return He(function() {
    var e;
    return t == null || (e = t.split("-")) === null || e === void 0 ? void 0 : e[0];
  }, [t]);
}
var Od = he({
  name: "Menu",
  compose: [Ai, Si],
  keys: Di,
  useOptions: function(e) {
    var r = Ee(Je), a = (r == null ? void 0 : r.role) === "menubar";
    return w(w({
      unstable_autoFocusOnHide: !a,
      modal: !1
    }, e), {}, {
      // will be handled by MenuButton
      unstable_autoFocusOnShow: !1,
      // will be handled differently from usePopover/useDialog
      hideOnEsc: !1
    });
  },
  useProps: function(e, r) {
    for (var a = r.onKeyDown, n = ae(r, ["onKeyDown"]), o = Q(a), s = Ee(Je), i = !!s, u = s; u && u.role !== "menubar"; )
      u = u.parent;
    var l = u || {}, d = l.next, m = l.previous, h = l.orientation, c = h === "horizontal", v = Sd(e.placement), f = W(function(p) {
      var b;
      if ((b = o.current) === null || b === void 0 || b.call(o, p), !p.defaultPrevented) {
        if (p.key === "Escape") {
          var M;
          i || p.stopPropagation(), (M = e.hide) === null || M === void 0 || M.call(e);
        } else if (i && !Pn(p)) {
          var g = c && v !== "left" ? d : v === "left" && e.hide, y = c && v !== "right" ? m : v === "right" && e.hide, _ = {
            ArrowRight: g,
            ArrowLeft: y
          }, P = _[p.key];
          P && (p.preventDefault(), i && p.stopPropagation(), P());
        }
      }
    }, [i, c, d, m, v, e.hide]);
    return w({
      role: "menu",
      onKeyDown: f
    }, n);
  }
}), xd = me({
  as: "div",
  useHook: Od,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Ht(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), Et(e, r, a);
  }
});
function Dd(t) {
  t === void 0 && (t = {});
  var e = dt(t), r = e.orientation, a = r === void 0 ? "horizontal" : r, n = e.unstable_values, o = n === void 0 ? {} : n, s = ae(e, ["orientation", "unstable_values"]), i = ie(o), u = i[0], l = i[1], d = Ps(w(w({}, s), {}, {
    orientation: a
  }));
  return w(w({}, d), {}, {
    unstable_values: u,
    unstable_setValue: W(function(m, h) {
      l(function(c) {
        var v;
        return w(w({}, c), {}, (v = {}, v[m] = typeof h == "function" ? h(c) : h, v));
      });
    }, [])
  });
}
var Hr = he({
  name: "PopoverDisclosure",
  compose: xi,
  keys: pd,
  useProps: function(e, r) {
    var a = r.ref, n = ae(r, ["ref"]);
    return w({
      ref: Be(e.unstable_referenceRef, a)
    }, n);
  }
});
me({
  as: "button",
  memo: !0,
  useHook: Hr
});
function jn(t) {
  var e = t == null ? void 0 : t.find(function(r) {
    return r.current && !r.current.hidden;
  });
  return e == null ? void 0 : e.current;
}
var Cd = function() {
}, Td = he({
  name: "MenuButton",
  compose: Hr,
  keys: Ti,
  propsAreEqual: function(e, r) {
    e.unstable_popoverStyles, e.unstable_arrowStyles, e.currentId, e.unstable_moves;
    var a = ae(e, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.currentId, r.unstable_moves;
    var n = ae(r, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    return Hr.unstable_propsAreEqual(a, n);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onClick, o = r.onKeyDown, s = r.onFocus, i = r.onMouseEnter, u = r.onMouseDown, l = ae(r, ["ref", "onClick", "onKeyDown", "onFocus", "onMouseEnter", "onMouseDown"]), d = Ee(Je), m = U(null), h = U(!1), c = e.placement.split("-"), v = c[0], f = !!d, p = (d == null ? void 0 : d.role) === "menubar", b = e.disabled || l["aria-disabled"], M = Q(n), g = Q(o), y = Q(s), _ = Q(i), P = Q(u), S = W(function(x) {
      var C;
      if (x.key === "Escape") {
        var L;
        (L = e.hide) === null || L === void 0 || L.call(e);
      } else if (!b) {
        var T = e.first && function() {
          return setTimeout(e.first);
        }, I = e.last && function() {
          return setTimeout(e.last);
        }, G = {
          Enter: T,
          " ": T,
          ArrowUp: (v === "top" || v === "bottom") && I,
          ArrowRight: v === "right" && T,
          ArrowDown: (v === "bottom" || v === "top") && T,
          ArrowLeft: v === "left" && T
        }, Z = G[x.key];
        if (Z) {
          var ee;
          x.preventDefault(), x.stopPropagation(), (ee = e.show) === null || ee === void 0 || ee.call(e), Z();
          return;
        }
      }
      (C = g.current) === null || C === void 0 || C.call(g, x);
    }, [b, e.hide, e.first, e.last, v, e.show]), D = W(function(x) {
      var C;
      if ((C = _.current) === null || C === void 0 || C.call(_, x), !x.defaultPrevented && d) {
        var L = x.currentTarget;
        p ? jn(d.children) && L.focus() : setTimeout(function() {
          if (Bt(L)) {
            var T;
            (T = e.show) === null || T === void 0 || T.call(e);
          }
        }, 200);
      }
    }, [d, p, e.show]), O = W(function(x) {
      var C;
      h.current = !0, (C = P.current) === null || C === void 0 || C.call(P, x);
    }, []), E = W(function(x) {
      var C;
      if ((C = y.current) === null || C === void 0 || C.call(y, x), !x.defaultPrevented && !b && p && !h.current) {
        var L;
        (L = e.show) === null || L === void 0 || L.call(e);
      }
    }, [p, b, e.show]), R = W(function(x) {
      var C;
      if ((C = M.current) === null || C === void 0 || C.call(M, x), !x.defaultPrevented) {
        if (f && !p) {
          var L;
          (L = e.show) === null || L === void 0 || L.call(e);
        } else {
          var T;
          if ((T = e.toggle) === null || T === void 0 || T.call(e), h.current && !p && !e.visible) {
            var I;
            (I = e.move) === null || I === void 0 || I.call(e, null);
          }
        }
        h.current = !1;
      }
    }, [f, p, e.show, e.toggle, e.visible, e.move]);
    return w({
      ref: Be(m, a),
      "aria-haspopup": "menu",
      onKeyDown: S,
      onMouseEnter: D,
      onMouseDown: O,
      onFocus: E,
      onClick: R
    }, l);
  },
  useComposeOptions: function(e) {
    return w(w({}, e), {}, {
      // Toggling is handled by MenuButton
      toggle: Cd
    });
  }
}), Ad = me({
  as: "button",
  memo: !0,
  useHook: Td
});
function Xt(t, e, r) {
  return Math.abs((t.x * (e.y - r.y) + e.x * (r.y - t.y) + r.x * (t.y - e.y)) / 2);
}
function Rd(t, e, r, a) {
  var n = Xt(e, r, a), o = Xt(t, r, a), s = Xt(e, t, a), i = Xt(e, r, t);
  return n === o + s + i;
}
function kd(t, e) {
  var r = e.getBoundingClientRect(), a = r.top, n = r.right, o = r.bottom, s = r.left, i = s > t.clientX ? s : n;
  return [{
    x: i,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function jd(t, e) {
  var r = Q(e), a = U(null), n = U(null), o = U(null), s = U(0), i = U(0), u = W(function(m) {
    if (t != null && t.children.length) {
      n.current = null, o.current = null;
      var h = jn(t.children);
      if (h) {
        var c = kd(m, h);
        n.current = c[0], o.current = c[1];
      }
    }
  }, [t == null ? void 0 : t.children]), l = W(function(m) {
    var h = s.current !== m.clientX || i.current !== m.clientY;
    if (m.isTrusted && !h)
      return !0;
    var c = Math.abs(s.current - m.clientX);
    s.current = m.clientX, i.current = m.clientY;
    var v = function() {
      return n.current && o.current;
    };
    return m.type === "mouseleave" && !v() && u(m), v() ? c && a.current && Rd({
      x: m.clientX,
      y: m.clientY
    }, a.current, n.current, o.current) : !1;
  }, [u]), d = W(function(m) {
    var h;
    (h = r.current) === null || h === void 0 || h.call(r, m), !m.defaultPrevented && (t == null ? void 0 : t.role) !== "menubar" && (a.current = {
      x: m.clientX,
      y: m.clientY
    }, u(m));
  }, [t == null ? void 0 : t.role, u]);
  return {
    onMouseEnter: d,
    isMouseInTransitToSubmenu: l
  };
}
function In(t) {
  var e = t.relatedTarget;
  return (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE ? t.relatedTarget : t.toElement || null;
}
function Id(t) {
  var e = In(t);
  return e ? We(t.currentTarget, e) : !1;
}
function Ld(t, e) {
  if (!(e != null && e.length))
    return !1;
  var r = In(t);
  if (!r)
    return !1;
  var a = jn(e);
  return a && We(a, r);
}
function Wd(t, e) {
  var r = In(t);
  return r ? e == null ? void 0 : e.some(function(a) {
    return a.ref.current && We(a.ref.current, r);
  }) : !1;
}
var Fd = he({
  name: "MenuItem",
  compose: jr,
  keys: Ed,
  propsAreEqual: function(e, r) {
    e.unstable_popoverStyles, e.unstable_arrowStyles, e.visible;
    var a = ae(e, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.visible;
    var n = ae(r, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    return jr.unstable_propsAreEqual(a, n);
  },
  useProps: function(e, r) {
    var a = r.onMouseEnter, n = r.onMouseMove, o = r.onMouseLeave, s = ae(r, ["onMouseEnter", "onMouseMove", "onMouseLeave"]), i = Ee(Je), u = Q(n), l = Q(o), d = jd(i, a), m = d.onMouseEnter, h = d.isMouseInTransitToSubmenu, c = W(function(f) {
      var p, b;
      (p = u.current) === null || p === void 0 || p.call(u, f), !f.defaultPrevented && (i == null ? void 0 : i.role) !== "menubar" && (h(f) || Bt(f.currentTarget) || (b = e.move) === null || b === void 0 || b.call(e, f.currentTarget.id));
    }, [e.move]), v = W(function(f) {
      var p;
      if ((p = l.current) === null || p === void 0 || p.call(l, f), !f.defaultPrevented && (i == null ? void 0 : i.role) !== "menubar" && !Id(f) && !Ld(f, i == null ? void 0 : i.children) && !Wd(f, e.items)) {
        var b;
        if (h(f))
          return;
        (b = e.move) === null || b === void 0 || b.call(e, null);
      }
    }, [i == null ? void 0 : i.role, i == null ? void 0 : i.children, e.items, e.move]);
    return w({
      role: "menuitem",
      onMouseEnter: m,
      onMouseMove: c,
      onMouseLeave: v
    }, s);
  }
}), Nd = me({
  as: "button",
  memo: !0,
  useHook: Fd
});
function Hd(t) {
  t === void 0 && (t = {});
  var e = Ee(Je), r = dt(t), a = r.orientation, n = a === void 0 ? "vertical" : a, o = r.gutter, s = o === void 0 ? 0 : o, i = ae(r, ["orientation", "gutter"]), u = i.placement || (e && e.orientation === "vertical" ? "right-start" : "bottom-start"), l = Dd(w(w({}, i), {}, {
    orientation: n
  })), d = jl(w(w({}, i), {}, {
    placement: u,
    gutter: s
  }));
  return X(function() {
    d.visible || l.reset();
  }, [d.visible, l.reset]), w(w({}, l), d);
}
function Bd(t) {
  var e = t.children, r = t.unstable_system;
  return /* @__PURE__ */ De(wn.Provider, {
    value: r
  }, e);
}
var zd = {};
function $d(t) {
  var e = t.unstable_prefix, r = t.unstable_system, a = r === void 0 ? zd : r, n = t.children;
  return /* @__PURE__ */ De(us, {
    prefix: e
  }, /* @__PURE__ */ De(Bd, {
    unstable_system: a
  }, n));
}
function Ri(t = {}) {
  var e;
  return new lu.QueryClient({
    ...t,
    defaultOptions: {
      ...t.defaultOptions,
      queries: {
        retry: 3,
        retryDelay(r) {
          return r * 100;
        },
        ...(e = t.defaultOptions) == null ? void 0 : e.queries
      }
    }
  });
}
const qd = ({ children: t, i18nInstance: e }) => /* @__PURE__ */ F(vu, { i18n: e, children: t }), Ln = (t = "label") => {
  const e = Array.isArray(t) ? t : [t];
  return mu(e);
};
var Vd = function() {
  const e = Array.prototype.slice.call(arguments).filter(Boolean), r = {}, a = [];
  e.forEach((o) => {
    (o ? o.split(" ") : []).forEach((i) => {
      if (i.startsWith("atm_")) {
        const [, u] = i.split("_");
        r[u] = i;
      } else
        a.push(i);
    });
  });
  const n = [];
  for (const o in r)
    Object.prototype.hasOwnProperty.call(r, o) && n.push(r[o]);
  return n.push(...a), n.join(" ");
}, ur = Vd;
const Kd = "defaultAnimation_d16p72kf";
tr(function({ animationClass: e = !0, children: r, header: a, id: n, onToggle: o, visible: s = !1 }, i) {
  const u = e === !0 || typeof e == "string" && e !== "", l = mi({
    animated: u ? 300 : !1,
    baseId: n.toString(),
    visible: s
  }), d = typeof e == "string" && e !== "" ? e : Kd, m = U(l.visible);
  return X(() => {
    m.current !== l.visible && (m.current = l.visible, o == null || o(l.visible));
  }, [l.visible, o]), /* @__PURE__ */ Le(Io, { children: [
    /* @__PURE__ */ F(yd, { ...l, ref: i, ...a.props, children: (h) => iu(a, h) }),
    /* @__PURE__ */ F(
      Wl,
      {
        ...l,
        className: ur(u && d),
        ...s ? { "data-enter": !0 } : {},
        children: r
      }
    )
  ] });
});
function Ud(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var Yd = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Mr = /* @__PURE__ */ Ud(
  function(t) {
    return Yd.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Xd = (t) => t.toUpperCase() === t, Gd = (t) => (e) => t.indexOf(e) === -1, ki = (t, e) => {
  const r = {};
  return Object.keys(t).filter(Gd(e)).forEach((a) => {
    r[a] = t[a];
  }), r;
};
function Jd(t, e, r) {
  const a = ki(e, r);
  if (!t) {
    const n = typeof Mr == "function" ? { default: Mr } : Mr;
    Object.keys(a).forEach((o) => {
      n.default(o) || delete a[o];
    });
  }
  return a;
}
var Qd = (t, e) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof t == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof t == "number" && isFinite(t))
      return;
    const r = typeof t == "object" ? JSON.stringify(t) : String(t);
    console.warn(
      `An interpolation evaluated to '${r}' in the component '${e}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, Zd = 0;
function So(t) {
  let e = "";
  return process.env.NODE_ENV === "test" && (e += `mocked-styled-${Zd++}`, t && t.__wyw_meta && t.__wyw_meta.className && (e += ` ${t.__wyw_meta.className}`)), (r) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(r))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const a = (o, s) => {
      const { as: i = t, class: u = e } = o, l = r.propsAsIs === void 0 ? !(typeof i == "string" && i.indexOf("-") === -1 && !Xd(i[0])) : r.propsAsIs, d = Jd(l, o, [
        "as",
        "class"
      ]);
      d.ref = s, d.className = r.atomic ? ur(r.class, d.className || u) : ur(d.className || u, r.class);
      const { vars: m } = r;
      if (m) {
        const h = {};
        for (const f in m) {
          const p = m[f], b = p[0], M = p[1] || "", g = typeof b == "function" ? b(o) : b;
          Qd(g, r.name), h[`--${f}`] = `${g}${M}`;
        }
        const c = d.style || {}, v = Object.keys(c);
        v.length > 0 && v.forEach((f) => {
          h[f] = c[f];
        }), d.style = h;
      }
      return t.__wyw_meta && t !== i ? (d.as = i, De(t, d)) : De(i, d);
    }, n = tr ? tr(a) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (o) => {
        const s = ki(o, ["innerRef"]);
        return a(s, o.innerRef);
      }
    );
    return n.displayName = r.name, n.__wyw_meta = {
      className: r.class || e,
      extends: t
    }, n;
  };
}
var ji = process.env.NODE_ENV !== "production" ? new Proxy(So, {
  get(t, e) {
    return t(e);
  }
}) : So;
const ec = () => /* @__PURE__ */ Le("svg", { fill: "none", height: "11", viewBox: "0 0 11 11", width: "11", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ F("circle", { cx: "5.5", cy: "5.5", r: "5", stroke: "#9D9DA3" }),
  /* @__PURE__ */ F(
    "path",
    {
      d: "M5.32 7.68c-.378 0-.683.314-.683.691 0 .368.296.692.682.692.386 0 .692-.324.692-.692 0-.377-.315-.691-.692-.691zM5.436 2.444c-1.212 0-1.769.719-1.769 1.204 0 .35.296.511.539.511.485 0 .287-.691 1.203-.691.449 0 .808.198.808.61 0 .485-.503.764-.799 1.015-.26.225-.602.593-.602 1.365 0 .467.126.602.494.602.44 0 .53-.198.53-.368 0-.467.009-.737.503-1.123.242-.188 1.006-.799 1.006-1.643s-.764-1.482-1.913-1.482z",
      fill: "#9D9DA3"
    }
  )
] });
const tc = /* @__PURE__ */ ji("div")({
  name: "NoContentWrapper",
  class: "NoContentWrapper_n20pplq",
  propsAsIs: !1
}), rc = /* @__PURE__ */ ji("p")({
  name: "NoContentText",
  class: "NoContentText_n102xecg",
  propsAsIs: !1
}), ac = ({ children: t }) => /* @__PURE__ */ Le(tc, { children: [
  /* @__PURE__ */ F(ec, {}),
  /* @__PURE__ */ F(rc, { "data-testid": "no-content-text", children: t })
] });
var Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ye(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ii = { exports: {} };
(function(t, e) {
  (function(a, n) {
    t.exports = n(st);
  })(Dt, (r) => (
    /******/
    (() => {
      var a = {
        /***/
        "./node_modules/css-mediaquery/index.js": (
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          (i, u) => {
            u.match = v, u.parse = f;
            var l = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, d = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, m = /^(?:(min|max)-)?(.+)/, h = /(em|rem|px|cm|mm|in|pt|pc)?$/, c = /(dpi|dpcm|dppx)?$/;
            function v(g, y) {
              return f(g).some(function(_) {
                var P = _.inverse, S = _.type === "all" || y.type === _.type;
                if (S && P || !(S || P))
                  return !1;
                var D = _.expressions.every(function(O) {
                  var E = O.feature, R = O.modifier, x = O.value, C = y[E];
                  if (!C)
                    return !1;
                  switch (E) {
                    case "orientation":
                    case "scan":
                      return C.toLowerCase() === x.toLowerCase();
                    case "width":
                    case "height":
                    case "device-width":
                    case "device-height":
                      x = M(x), C = M(C);
                      break;
                    case "resolution":
                      x = b(x), C = b(C);
                      break;
                    case "aspect-ratio":
                    case "device-aspect-ratio":
                    case /* Deprecated */
                    "device-pixel-ratio":
                      x = p(x), C = p(C);
                      break;
                    case "grid":
                    case "color":
                    case "color-index":
                    case "monochrome":
                      x = parseInt(x, 10) || 1, C = parseInt(C, 10) || 0;
                      break;
                  }
                  switch (R) {
                    case "min":
                      return C >= x;
                    case "max":
                      return C <= x;
                    default:
                      return C === x;
                  }
                });
                return D && !P || !D && P;
              });
            }
            function f(g) {
              return g.split(",").map(function(y) {
                y = y.trim();
                var _ = y.match(l), P = _[1], S = _[2], D = _[3] || "", O = {};
                return O.inverse = !!P && P.toLowerCase() === "not", O.type = S ? S.toLowerCase() : "all", D = D.match(/\([^\)]+\)/g) || [], O.expressions = D.map(function(E) {
                  var R = E.match(d), x = R[1].toLowerCase().match(m);
                  return {
                    modifier: x[1],
                    feature: x[2],
                    value: R[2]
                  };
                }), O;
              });
            }
            function p(g) {
              var y = Number(g), _;
              return y || (_ = g.match(/^(\d+)\s*\/\s*(\d+)$/), y = _[1] / _[2]), y;
            }
            function b(g) {
              var y = parseFloat(g), _ = String(g).match(c)[1];
              switch (_) {
                case "dpcm":
                  return y / 2.54;
                case "dppx":
                  return y * 96;
                default:
                  return y;
              }
            }
            function M(g) {
              var y = parseFloat(g), _ = String(g).match(h)[1];
              switch (_) {
                case "em":
                  return y * 16;
                case "rem":
                  return y * 16;
                case "cm":
                  return y * 96 / 2.54;
                case "mm":
                  return y * 96 / 2.54 / 10;
                case "in":
                  return y * 96;
                case "pt":
                  return y * 72;
                case "pc":
                  return y * 72 / 12;
                default:
                  return y;
              }
            }
          }
        ),
        /***/
        "./node_modules/hyphenate-style-name/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          (i, u, l) => {
            l.r(u), l.d(u, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            var d = /[A-Z]/g, m = /^ms-/, h = {};
            function c(p) {
              return "-" + p.toLowerCase();
            }
            function v(p) {
              if (h.hasOwnProperty(p))
                return h[p];
              var b = p.replace(d, c);
              return h[p] = m.test(b) ? "-" + b : b;
            }
            const f = v;
          }
        ),
        /***/
        "./node_modules/matchmediaquery/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          (i, u, l) => {
            var d = l(
              /*! css-mediaquery */
              "./node_modules/css-mediaquery/index.js"
            ).match, m = typeof window < "u" ? window.matchMedia : null;
            function h(v, f, p) {
              var b = this;
              if (m && !p) {
                var M = m.call(window, v);
                this.matches = M.matches, this.media = M.media, M.addListener(_);
              } else
                this.matches = d(v, f), this.media = v;
              this.addListener = g, this.removeListener = y, this.dispose = P;
              function g(S) {
                M && M.addListener(S);
              }
              function y(S) {
                M && M.removeListener(S);
              }
              function _(S) {
                b.matches = S.matches, b.media = S.media;
              }
              function P() {
                M && M.removeListener(_);
              }
            }
            function c(v, f, p) {
              return new h(v, f, p);
            }
            i.exports = c;
          }
        ),
        /***/
        "./node_modules/object-assign/index.js": (
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          (i) => {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */
            var u = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
            function m(c) {
              if (c == null)
                throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(c);
            }
            function h() {
              try {
                if (!Object.assign)
                  return !1;
                var c = new String("abc");
                if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
                  return !1;
                for (var v = {}, f = 0; f < 10; f++)
                  v["_" + String.fromCharCode(f)] = f;
                var p = Object.getOwnPropertyNames(v).map(function(M) {
                  return v[M];
                });
                if (p.join("") !== "0123456789")
                  return !1;
                var b = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(M) {
                  b[M] = M;
                }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
              } catch {
                return !1;
              }
            }
            i.exports = h() ? Object.assign : function(c, v) {
              for (var f, p = m(c), b, M = 1; M < arguments.length; M++) {
                f = Object(arguments[M]);
                for (var g in f)
                  l.call(f, g) && (p[g] = f[g]);
                if (u) {
                  b = u(f);
                  for (var y = 0; y < b.length; y++)
                    d.call(f, b[y]) && (p[b[y]] = f[b[y]]);
                }
              }
              return p;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/checkPropTypes.js": (
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          (i, u, l) => {
            var d = function() {
            };
            {
              var m = l(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), h = {}, c = l(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              d = function(f) {
                var p = "Warning: " + f;
                typeof console < "u" && console.error(p);
                try {
                  throw new Error(p);
                } catch {
                }
              };
            }
            function v(f, p, b, M, g) {
              for (var y in f)
                if (c(f, y)) {
                  var _;
                  try {
                    if (typeof f[y] != "function") {
                      var P = Error(
                        (M || "React class") + ": " + b + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw P.name = "Invariant Violation", P;
                    }
                    _ = f[y](p, y, M, b, null, m);
                  } catch (D) {
                    _ = D;
                  }
                  if (_ && !(_ instanceof Error) && d(
                    (M || "React class") + ": type specification of " + b + " `" + y + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof _ + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ), _ instanceof Error && !(_.message in h)) {
                    h[_.message] = !0;
                    var S = g ? g() : "";
                    d(
                      "Failed " + b + " type: " + _.message + (S ?? "")
                    );
                  }
                }
            }
            v.resetWarningCache = function() {
              h = {};
            }, i.exports = v;
          }
        ),
        /***/
        "./node_modules/prop-types/factoryWithTypeCheckers.js": (
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          (i, u, l) => {
            var d = l(
              /*! react-is */
              "./node_modules/react-is/index.js"
            ), m = l(
              /*! object-assign */
              "./node_modules/object-assign/index.js"
            ), h = l(
              /*! ./lib/ReactPropTypesSecret */
              "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
            ), c = l(
              /*! ./lib/has */
              "./node_modules/prop-types/lib/has.js"
            ), v = l(
              /*! ./checkPropTypes */
              "./node_modules/prop-types/checkPropTypes.js"
            ), f = function() {
            };
            f = function(b) {
              var M = "Warning: " + b;
              typeof console < "u" && console.error(M);
              try {
                throw new Error(M);
              } catch {
              }
            };
            function p() {
              return null;
            }
            i.exports = function(b, M) {
              var g = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
              function _(A) {
                var j = A && (g && A[g] || A[y]);
                if (typeof j == "function")
                  return j;
              }
              var P = "<<anonymous>>", S = {
                array: R("array"),
                bigint: R("bigint"),
                bool: R("boolean"),
                func: R("function"),
                number: R("number"),
                object: R("object"),
                string: R("string"),
                symbol: R("symbol"),
                any: x(),
                arrayOf: C,
                element: L(),
                elementType: T(),
                instanceOf: I,
                node: le(),
                objectOf: Z,
                oneOf: G,
                oneOfType: ee,
                shape: oe,
                exact: be
              };
              function D(A, j) {
                return A === j ? A !== 0 || 1 / A === 1 / j : A !== A && j !== j;
              }
              function O(A, j) {
                this.message = A, this.data = j && typeof j == "object" ? j : {}, this.stack = "";
              }
              O.prototype = Error.prototype;
              function E(A) {
                var j = {}, V = 0;
                function B(Y, z, $, K, re, q, k) {
                  if (K = K || P, q = q || $, k !== h) {
                    if (M) {
                      var ue = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                      );
                      throw ue.name = "Invariant Violation", ue;
                    } else if (typeof console < "u") {
                      var Me = K + ":" + $;
                      !j[Me] && // Avoid spamming the console because they are often not actionable except for lib authors
                      V < 3 && (f(
                        "You are manually calling a React.PropTypes validation function for the `" + q + "` prop on `" + K + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ), j[Me] = !0, V++);
                    }
                  }
                  return z[$] == null ? Y ? z[$] === null ? new O("The " + re + " `" + q + "` is marked as required " + ("in `" + K + "`, but its value is `null`.")) : new O("The " + re + " `" + q + "` is marked as required in " + ("`" + K + "`, but its value is `undefined`.")) : null : A(z, $, K, re, q);
                }
                var H = B.bind(null, !1);
                return H.isRequired = B.bind(null, !0), H;
              }
              function R(A) {
                function j(V, B, H, Y, z, $) {
                  var K = V[B], re = J(K);
                  if (re !== A) {
                    var q = ge(K);
                    return new O(
                      "Invalid " + Y + " `" + z + "` of type " + ("`" + q + "` supplied to `" + H + "`, expected ") + ("`" + A + "`."),
                      { expectedType: A }
                    );
                  }
                  return null;
                }
                return E(j);
              }
              function x() {
                return E(p);
              }
              function C(A) {
                function j(V, B, H, Y, z) {
                  if (typeof A != "function")
                    return new O("Property `" + z + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
                  var $ = V[B];
                  if (!Array.isArray($)) {
                    var K = J($);
                    return new O("Invalid " + Y + " `" + z + "` of type " + ("`" + K + "` supplied to `" + H + "`, expected an array."));
                  }
                  for (var re = 0; re < $.length; re++) {
                    var q = A($, re, H, Y, z + "[" + re + "]", h);
                    if (q instanceof Error)
                      return q;
                  }
                  return null;
                }
                return E(j);
              }
              function L() {
                function A(j, V, B, H, Y) {
                  var z = j[V];
                  if (!b(z)) {
                    var $ = J(z);
                    return new O("Invalid " + H + " `" + Y + "` of type " + ("`" + $ + "` supplied to `" + B + "`, expected a single ReactElement."));
                  }
                  return null;
                }
                return E(A);
              }
              function T() {
                function A(j, V, B, H, Y) {
                  var z = j[V];
                  if (!d.isValidElementType(z)) {
                    var $ = J(z);
                    return new O("Invalid " + H + " `" + Y + "` of type " + ("`" + $ + "` supplied to `" + B + "`, expected a single ReactElement type."));
                  }
                  return null;
                }
                return E(A);
              }
              function I(A) {
                function j(V, B, H, Y, z) {
                  if (!(V[B] instanceof A)) {
                    var $ = A.name || P, K = we(V[B]);
                    return new O("Invalid " + Y + " `" + z + "` of type " + ("`" + K + "` supplied to `" + H + "`, expected ") + ("instance of `" + $ + "`."));
                  }
                  return null;
                }
                return E(j);
              }
              function G(A) {
                if (!Array.isArray(A))
                  return arguments.length > 1 ? f(
                    "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                  ) : f("Invalid argument supplied to oneOf, expected an array."), p;
                function j(V, B, H, Y, z) {
                  for (var $ = V[B], K = 0; K < A.length; K++)
                    if (D($, A[K]))
                      return null;
                  var re = JSON.stringify(A, function(k, ue) {
                    var Me = ge(ue);
                    return Me === "symbol" ? String(ue) : ue;
                  });
                  return new O("Invalid " + Y + " `" + z + "` of value `" + String($) + "` " + ("supplied to `" + H + "`, expected one of " + re + "."));
                }
                return E(j);
              }
              function Z(A) {
                function j(V, B, H, Y, z) {
                  if (typeof A != "function")
                    return new O("Property `" + z + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
                  var $ = V[B], K = J($);
                  if (K !== "object")
                    return new O("Invalid " + Y + " `" + z + "` of type " + ("`" + K + "` supplied to `" + H + "`, expected an object."));
                  for (var re in $)
                    if (c($, re)) {
                      var q = A($, re, H, Y, z + "." + re, h);
                      if (q instanceof Error)
                        return q;
                    }
                  return null;
                }
                return E(j);
              }
              function ee(A) {
                if (!Array.isArray(A))
                  return f("Invalid argument supplied to oneOfType, expected an instance of array."), p;
                for (var j = 0; j < A.length; j++) {
                  var V = A[j];
                  if (typeof V != "function")
                    return f(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ve(V) + " at index " + j + "."
                    ), p;
                }
                function B(H, Y, z, $, K) {
                  for (var re = [], q = 0; q < A.length; q++) {
                    var k = A[q], ue = k(H, Y, z, $, K, h);
                    if (ue == null)
                      return null;
                    ue.data && c(ue.data, "expectedType") && re.push(ue.data.expectedType);
                  }
                  var Me = re.length > 0 ? ", expected one of type [" + re.join(", ") + "]" : "";
                  return new O("Invalid " + $ + " `" + K + "` supplied to " + ("`" + z + "`" + Me + "."));
                }
                return E(B);
              }
              function le() {
                function A(j, V, B, H, Y) {
                  return de(j[V]) ? null : new O("Invalid " + H + " `" + Y + "` supplied to " + ("`" + B + "`, expected a ReactNode."));
                }
                return E(A);
              }
              function ne(A, j, V, B, H) {
                return new O(
                  (A || "React class") + ": " + j + " type `" + V + "." + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`."
                );
              }
              function oe(A) {
                function j(V, B, H, Y, z) {
                  var $ = V[B], K = J($);
                  if (K !== "object")
                    return new O("Invalid " + Y + " `" + z + "` of type `" + K + "` " + ("supplied to `" + H + "`, expected `object`."));
                  for (var re in A) {
                    var q = A[re];
                    if (typeof q != "function")
                      return ne(H, Y, z, re, ge(q));
                    var k = q($, re, H, Y, z + "." + re, h);
                    if (k)
                      return k;
                  }
                  return null;
                }
                return E(j);
              }
              function be(A) {
                function j(V, B, H, Y, z) {
                  var $ = V[B], K = J($);
                  if (K !== "object")
                    return new O("Invalid " + Y + " `" + z + "` of type `" + K + "` " + ("supplied to `" + H + "`, expected `object`."));
                  var re = m({}, V[B], A);
                  for (var q in re) {
                    var k = A[q];
                    if (c(A, q) && typeof k != "function")
                      return ne(H, Y, z, q, ge(k));
                    if (!k)
                      return new O(
                        "Invalid " + Y + " `" + z + "` key `" + q + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify(V[B], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
                      );
                    var ue = k($, q, H, Y, z + "." + q, h);
                    if (ue)
                      return ue;
                  }
                  return null;
                }
                return E(j);
              }
              function de(A) {
                switch (typeof A) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;
                  case "boolean":
                    return !A;
                  case "object":
                    if (Array.isArray(A))
                      return A.every(de);
                    if (A === null || b(A))
                      return !0;
                    var j = _(A);
                    if (j) {
                      var V = j.call(A), B;
                      if (j !== A.entries) {
                        for (; !(B = V.next()).done; )
                          if (!de(B.value))
                            return !1;
                      } else
                        for (; !(B = V.next()).done; ) {
                          var H = B.value;
                          if (H && !de(H[1]))
                            return !1;
                        }
                    } else
                      return !1;
                    return !0;
                  default:
                    return !1;
                }
              }
              function te(A, j) {
                return A === "symbol" ? !0 : j ? j["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && j instanceof Symbol : !1;
              }
              function J(A) {
                var j = typeof A;
                return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : te(j, A) ? "symbol" : j;
              }
              function ge(A) {
                if (typeof A > "u" || A === null)
                  return "" + A;
                var j = J(A);
                if (j === "object") {
                  if (A instanceof Date)
                    return "date";
                  if (A instanceof RegExp)
                    return "regexp";
                }
                return j;
              }
              function ve(A) {
                var j = ge(A);
                switch (j) {
                  case "array":
                  case "object":
                    return "an " + j;
                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + j;
                  default:
                    return j;
                }
              }
              function we(A) {
                return !A.constructor || !A.constructor.name ? P : A.constructor.name;
              }
              return S.checkPropTypes = v, S.resetWarningCache = v.resetWarningCache, S.PropTypes = S, S;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          (i, u, l) => {
            {
              var d = l(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), m = !0;
              i.exports = l(
                /*! ./factoryWithTypeCheckers */
                "./node_modules/prop-types/factoryWithTypeCheckers.js"
              )(d.isElement, m);
            }
          }
        ),
        /***/
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          (i) => {
            var u = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            i.exports = u;
          }
        ),
        /***/
        "./node_modules/prop-types/lib/has.js": (
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          (i) => {
            i.exports = Function.call.bind(Object.prototype.hasOwnProperty);
          }
        ),
        /***/
        "./node_modules/react-is/cjs/react-is.development.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          (i, u) => {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
            (function() {
              var l = typeof Symbol == "function" && Symbol.for, d = l ? Symbol.for("react.element") : 60103, m = l ? Symbol.for("react.portal") : 60106, h = l ? Symbol.for("react.fragment") : 60107, c = l ? Symbol.for("react.strict_mode") : 60108, v = l ? Symbol.for("react.profiler") : 60114, f = l ? Symbol.for("react.provider") : 60109, p = l ? Symbol.for("react.context") : 60110, b = l ? Symbol.for("react.async_mode") : 60111, M = l ? Symbol.for("react.concurrent_mode") : 60111, g = l ? Symbol.for("react.forward_ref") : 60112, y = l ? Symbol.for("react.suspense") : 60113, _ = l ? Symbol.for("react.suspense_list") : 60120, P = l ? Symbol.for("react.memo") : 60115, S = l ? Symbol.for("react.lazy") : 60116, D = l ? Symbol.for("react.block") : 60121, O = l ? Symbol.for("react.fundamental") : 60117, E = l ? Symbol.for("react.responder") : 60118, R = l ? Symbol.for("react.scope") : 60119;
              function x(k) {
                return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                k === h || k === M || k === v || k === c || k === y || k === _ || typeof k == "object" && k !== null && (k.$$typeof === S || k.$$typeof === P || k.$$typeof === f || k.$$typeof === p || k.$$typeof === g || k.$$typeof === O || k.$$typeof === E || k.$$typeof === R || k.$$typeof === D);
              }
              function C(k) {
                if (typeof k == "object" && k !== null) {
                  var ue = k.$$typeof;
                  switch (ue) {
                    case d:
                      var Me = k.type;
                      switch (Me) {
                        case b:
                        case M:
                        case h:
                        case v:
                        case c:
                        case y:
                          return Me;
                        default:
                          var je = Me && Me.$$typeof;
                          switch (je) {
                            case p:
                            case g:
                            case S:
                            case P:
                            case f:
                              return je;
                            default:
                              return ue;
                          }
                      }
                    case m:
                      return ue;
                  }
                }
              }
              var L = b, T = M, I = p, G = f, Z = d, ee = g, le = h, ne = S, oe = P, be = m, de = v, te = c, J = y, ge = !1;
              function ve(k) {
                return ge || (ge = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), we(k) || C(k) === b;
              }
              function we(k) {
                return C(k) === M;
              }
              function A(k) {
                return C(k) === p;
              }
              function j(k) {
                return C(k) === f;
              }
              function V(k) {
                return typeof k == "object" && k !== null && k.$$typeof === d;
              }
              function B(k) {
                return C(k) === g;
              }
              function H(k) {
                return C(k) === h;
              }
              function Y(k) {
                return C(k) === S;
              }
              function z(k) {
                return C(k) === P;
              }
              function $(k) {
                return C(k) === m;
              }
              function K(k) {
                return C(k) === v;
              }
              function re(k) {
                return C(k) === c;
              }
              function q(k) {
                return C(k) === y;
              }
              u.AsyncMode = L, u.ConcurrentMode = T, u.ContextConsumer = I, u.ContextProvider = G, u.Element = Z, u.ForwardRef = ee, u.Fragment = le, u.Lazy = ne, u.Memo = oe, u.Portal = be, u.Profiler = de, u.StrictMode = te, u.Suspense = J, u.isAsyncMode = ve, u.isConcurrentMode = we, u.isContextConsumer = A, u.isContextProvider = j, u.isElement = V, u.isForwardRef = B, u.isFragment = H, u.isLazy = Y, u.isMemo = z, u.isPortal = $, u.isProfiler = K, u.isStrictMode = re, u.isSuspense = q, u.isValidElementType = x, u.typeOf = C;
            })();
          }
        ),
        /***/
        "./node_modules/react-is/index.js": (
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          (i, u, l) => {
            i.exports = l(
              /*! ./cjs/react-is.development.js */
              "./node_modules/react-is/cjs/react-is.development.js"
            );
          }
        ),
        /***/
        "./node_modules/shallow-equal/dist/index.esm.js": (
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          (i, u, l) => {
            l.r(u), l.d(u, {
              /* harmony export */
              shallowEqualArrays: () => (
                /* binding */
                m
              ),
              /* harmony export */
              shallowEqualObjects: () => (
                /* binding */
                d
              )
              /* harmony export */
            });
            function d(h, c) {
              if (h === c)
                return !0;
              if (!h || !c)
                return !1;
              var v = Object.keys(h), f = Object.keys(c), p = v.length;
              if (f.length !== p)
                return !1;
              for (var b = 0; b < p; b++) {
                var M = v[b];
                if (h[M] !== c[M] || !Object.prototype.hasOwnProperty.call(c, M))
                  return !1;
              }
              return !0;
            }
            function m(h, c) {
              if (h === c)
                return !0;
              if (!h || !c)
                return !1;
              var v = h.length;
              if (c.length !== v)
                return !1;
              for (var f = 0; f < v; f++)
                if (h[f] !== c[f])
                  return !1;
              return !0;
            }
          }
        ),
        /***/
        "./src/Component.ts": (
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function(i, u, l) {
            var d = this && this.__rest || function(v, f) {
              var p = {};
              for (var b in v)
                Object.prototype.hasOwnProperty.call(v, b) && f.indexOf(b) < 0 && (p[b] = v[b]);
              if (v != null && typeof Object.getOwnPropertySymbols == "function")
                for (var M = 0, b = Object.getOwnPropertySymbols(v); M < b.length; M++)
                  f.indexOf(b[M]) < 0 && Object.prototype.propertyIsEnumerable.call(v, b[M]) && (p[b[M]] = v[b[M]]);
              return p;
            }, m = this && this.__importDefault || function(v) {
              return v && v.__esModule ? v : { default: v };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var h = m(l(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            )), c = function(v) {
              var f = v.children, p = v.device, b = v.onChange, M = d(v, ["children", "device", "onChange"]), g = (0, h.default)(M, p, b);
              return typeof f == "function" ? f(g) : g ? f : null;
            };
            u.default = c;
          }
        ),
        /***/
        "./src/Context.ts": (
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          (i, u, l) => {
            Object.defineProperty(u, "__esModule", { value: !0 });
            var d = l(
              /*! react */
              "react"
            ), m = (0, d.createContext)(void 0);
            u.default = m;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function(i, u, l) {
            var d = this && this.__importDefault || function(f) {
              return f && f.__esModule ? f : { default: f };
            };
            Object.defineProperty(u, "__esModule", { value: !0 }), u.Context = u.toQuery = u.useMediaQuery = u.default = void 0;
            var m = d(l(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            ));
            u.useMediaQuery = m.default;
            var h = d(l(
              /*! ./Component */
              "./src/Component.ts"
            ));
            u.default = h.default;
            var c = d(l(
              /*! ./toQuery */
              "./src/toQuery.ts"
            ));
            u.toQuery = c.default;
            var v = d(l(
              /*! ./Context */
              "./src/Context.ts"
            ));
            u.Context = v.default;
          }
        ),
        /***/
        "./src/mediaQuery.ts": (
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function(i, u, l) {
            var d = this && this.__assign || function() {
              return d = Object.assign || function(y) {
                for (var _, P = 1, S = arguments.length; P < S; P++) {
                  _ = arguments[P];
                  for (var D in _)
                    Object.prototype.hasOwnProperty.call(_, D) && (y[D] = _[D]);
                }
                return y;
              }, d.apply(this, arguments);
            }, m = this && this.__rest || function(y, _) {
              var P = {};
              for (var S in y)
                Object.prototype.hasOwnProperty.call(y, S) && _.indexOf(S) < 0 && (P[S] = y[S]);
              if (y != null && typeof Object.getOwnPropertySymbols == "function")
                for (var D = 0, S = Object.getOwnPropertySymbols(y); D < S.length; D++)
                  _.indexOf(S[D]) < 0 && Object.prototype.propertyIsEnumerable.call(y, S[D]) && (P[S[D]] = y[S[D]]);
              return P;
            }, h = this && this.__importDefault || function(y) {
              return y && y.__esModule ? y : { default: y };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var c = h(l(
              /*! prop-types */
              "./node_modules/prop-types/index.js"
            )), v = c.default.oneOfType([
              c.default.string,
              c.default.number
            ]), f = {
              all: c.default.bool,
              grid: c.default.bool,
              aural: c.default.bool,
              braille: c.default.bool,
              handheld: c.default.bool,
              print: c.default.bool,
              projection: c.default.bool,
              screen: c.default.bool,
              tty: c.default.bool,
              tv: c.default.bool,
              embossed: c.default.bool
            }, p = {
              orientation: c.default.oneOf([
                "portrait",
                "landscape"
              ]),
              scan: c.default.oneOf([
                "progressive",
                "interlace"
              ]),
              aspectRatio: c.default.string,
              deviceAspectRatio: c.default.string,
              height: v,
              deviceHeight: v,
              width: v,
              deviceWidth: v,
              color: c.default.bool,
              colorIndex: c.default.bool,
              monochrome: c.default.bool,
              resolution: v,
              type: Object.keys(f)
            };
            p.type;
            var b = m(
              p,
              ["type"]
            ), M = d({ minAspectRatio: c.default.string, maxAspectRatio: c.default.string, minDeviceAspectRatio: c.default.string, maxDeviceAspectRatio: c.default.string, minHeight: v, maxHeight: v, minDeviceHeight: v, maxDeviceHeight: v, minWidth: v, maxWidth: v, minDeviceWidth: v, maxDeviceWidth: v, minColor: c.default.number, maxColor: c.default.number, minColorIndex: c.default.number, maxColorIndex: c.default.number, minMonochrome: c.default.number, maxMonochrome: c.default.number, minResolution: v, maxResolution: v }, b), g = d(d({}, f), M);
            u.default = {
              all: g,
              types: f,
              matchers: p,
              features: M
            };
          }
        ),
        /***/
        "./src/toQuery.ts": (
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function(i, u, l) {
            var d = this && this.__importDefault || function(b) {
              return b && b.__esModule ? b : { default: b };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = d(l(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), h = d(l(
              /*! ./mediaQuery */
              "./src/mediaQuery.ts"
            )), c = function(b) {
              return "not ".concat(b);
            }, v = function(b, M) {
              var g = (0, m.default)(b);
              return typeof M == "number" && (M = "".concat(M, "px")), M === !0 ? g : M === !1 ? c(g) : "(".concat(g, ": ").concat(M, ")");
            }, f = function(b) {
              return b.join(" and ");
            }, p = function(b) {
              var M = [];
              return Object.keys(h.default.all).forEach(function(g) {
                var y = b[g];
                y != null && M.push(v(g, y));
              }), f(M);
            };
            u.default = p;
          }
        ),
        /***/
        "./src/useMediaQuery.ts": (
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function(i, u, l) {
            var d = this && this.__importDefault || function(O) {
              return O && O.__esModule ? O : { default: O };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = l(
              /*! react */
              "react"
            ), h = d(l(
              /*! matchmediaquery */
              "./node_modules/matchmediaquery/index.js"
            )), c = d(l(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), v = l(
              /*! shallow-equal */
              "./node_modules/shallow-equal/dist/index.esm.js"
            ), f = d(l(
              /*! ./toQuery */
              "./src/toQuery.ts"
            )), p = d(l(
              /*! ./Context */
              "./src/Context.ts"
            )), b = function(O) {
              return O.query || (0, f.default)(O);
            }, M = function(O) {
              if (O) {
                var E = Object.keys(O);
                return E.reduce(function(R, x) {
                  return R[(0, c.default)(x)] = O[x], R;
                }, {});
              }
            }, g = function() {
              var O = (0, m.useRef)(!1);
              return (0, m.useEffect)(function() {
                O.current = !0;
              }, []), O.current;
            }, y = function(O) {
              var E = (0, m.useContext)(p.default), R = function() {
                return M(O) || M(E);
              }, x = (0, m.useState)(R), C = x[0], L = x[1];
              return (0, m.useEffect)(function() {
                var T = R();
                (0, v.shallowEqualObjects)(C, T) || L(T);
              }, [O, E]), C;
            }, _ = function(O) {
              var E = function() {
                return b(O);
              }, R = (0, m.useState)(E), x = R[0], C = R[1];
              return (0, m.useEffect)(function() {
                var L = E();
                x !== L && C(L);
              }, [O]), x;
            }, P = function(O, E) {
              var R = function() {
                return (0, h.default)(O, E || {}, !!E);
              }, x = (0, m.useState)(R), C = x[0], L = x[1], T = g();
              return (0, m.useEffect)(function() {
                if (T) {
                  var I = R();
                  return L(I), function() {
                    I && I.dispose();
                  };
                }
              }, [O, E]), C;
            }, S = function(O) {
              var E = (0, m.useState)(O.matches), R = E[0], x = E[1];
              return (0, m.useEffect)(function() {
                var C = function(L) {
                  x(L.matches);
                };
                return O.addListener(C), x(O.matches), function() {
                  O.removeListener(C);
                };
              }, [O]), R;
            }, D = function(O, E, R) {
              var x = y(E), C = _(O);
              if (!C)
                throw new Error("Invalid or missing MediaQuery!");
              var L = P(C, x), T = S(L), I = g();
              return (0, m.useEffect)(function() {
                I && R && R(T);
              }, [T]), (0, m.useEffect)(function() {
                return function() {
                  L && L.dispose();
                };
              }, []), T;
            };
            u.default = D;
          }
        ),
        /***/
        react: (
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          (i) => {
            i.exports = r;
          }
        )
        /******/
      }, n = {};
      function o(i) {
        var u = n[i];
        if (u !== void 0)
          return u.exports;
        var l = n[i] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return a[i].call(l.exports, l, l.exports, o), l.exports;
      }
      o.d = (i, u) => {
        for (var l in u)
          o.o(u, l) && !o.o(i, l) && Object.defineProperty(i, l, { enumerable: !0, get: u[l] });
      }, o.o = (i, u) => Object.prototype.hasOwnProperty.call(i, u), o.r = (i) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      };
      var s = o("./src/index.ts");
      return s;
    })()
  ));
})(Ii);
var nc = Ii.exports;
const oc = {
  query: "(min-width: 768px)"
}, ic = (t) => /* @__PURE__ */ Le(
  "svg",
  {
    "data-testid": "oc-logo",
    fill: "none",
    height: "50",
    viewBox: "0 0 400 400",
    width: "50",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ F("path", { d: "M0 0h400v400H0z", fill: "#022e4a" }),
      /* @__PURE__ */ F(
        "path",
        {
          d: "M146.408 142.92C115.256 142.92 90 168.472 90 200.001c0 31.528 25.256 57.087 56.408 57.087s56.409-25.559 56.409-57.087-25.256-57.081-56.409-57.081m0 85.564c-15.542 0-28.141-12.75-28.141-28.483s12.599-28.477 28.141-28.477c15.543 0 28.142 12.75 28.142 28.477s-12.599 28.483-28.142 28.483M310 154.565l-11.157 23.554c-5.703-4.959-13.388-8.43-25.29-8.43-20.082 0-31.24 13.884-31.24 30.248s11.158 30.25 31.24 30.25c11.902 0 19.091-3.72 25.29-8.679L310 245.311c-9.173 5.951-22.067 11.654-37.935 11.654-36.447 0-59.753-24.299-59.753-57.028s23.307-57.025 59.753-57.025c15.868 0 29.01 5.455 37.935 11.653",
          fill: "#fff"
        }
      )
    ]
  }
);
const uc = "button_bvtzfi5", sc = "buttonWithBadge_b1eprg2a", lc = "drifter_d12jom77", dc = "drifterFlash_drixa55", cc = "steamer_s1d9ittc", fc = "steamerFlash_shk7cc5", vc = "noAnimation_nttqpkc", mc = "selectedBet_s1xs3ppz", hc = "bookieLogo_bd76kis", pc = "buttonUnsupported_b86phbh", yc = "textWrapper_t1h9f86g", bc = "ocLogoWrapper_o10rai6", gc = "logoWrapper_lif7al8", Mc = "buttonWithVerticalBadge_b16ssfx3", _c = ({ classNamesFactory: t }) => {
  const [e, r] = ie([]);
  return X(() => {
    r(t(!0));
  }, [t]), [e, () => {
    r(t(!1));
  }];
}, wc = ({
  bookieCode: t,
  bookmakerConfig: e,
  children: r,
  className: a,
  disableAnimation: n,
  disabled: o,
  isSelected: s,
  isUnsupported: i,
  isVerticalBadgeLogo: u = !1,
  renderBadge: l = !1,
  steamOrDrift: d,
  tooltip: m,
  ...h
}) => {
  const c = He(
    () => Ec(d, n),
    [d, n]
  ), [v, f] = _c({
    classNamesFactory: c
  }), p = nc.useMediaQuery(oc), b = t === "OC_NON_CLICKABLE", M = t === "OC", g = e == null ? void 0 : e.logoLarge, y = e == null ? void 0 : e.logoSmall, _ = !p && l && u, P = !p && u ? g : y, S = () => b ? /* @__PURE__ */ F("div", { className: bc, children: /* @__PURE__ */ F(ic, {}) }) : l && P ? /* @__PURE__ */ F(
    "div",
    {
      className: gc,
      style: !M && (e != null && e.brandColour) ? { backgroundColor: e.brandColour } : void 0,
      children: /* @__PURE__ */ F(
        "img",
        {
          alt: "bookie logo",
          className: hc,
          src: P,
          style: !M && (e != null && e.brandColour) ? { backgroundColor: e.brandColour } : void 0
        }
      )
    }
  ) : null;
  return /* @__PURE__ */ Le(
    Vu,
    {
      className: ur(
        uc,
        ...s && !o && !i ? [mc] : v,
        i ? pc : "",
        l || b ? sc : "",
        _ ? Mc : "",
        a || ""
      ),
      "data-testid": "odds-button",
      onTransitionEnd: f,
      ...h,
      children: [
        S(),
        /* @__PURE__ */ F("div", { className: yc, children: r }),
        m
      ]
    }
  );
};
function Ec(t, e) {
  return (r) => {
    const a = [];
    switch (t) {
      case "drifting":
        a.push(lc), r && !e && a.push(dc);
        break;
      case "shortening":
        a.push(cc), r && !e && a.push(fc);
        break;
    }
    return e && a.push(vc), a;
  };
}
class Pc extends uu {
  constructor(e) {
    super(e), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(e) {
    return { error: e, hasError: !0 };
  }
  componentDidCatch(e, r) {
    console.error("MostPopularBets Error:", e, r);
  }
  render() {
    return this.state.hasError ? this.props.fallback ? this.props.fallback : /* @__PURE__ */ F(ac, { children: "Unable to load popular bets at this time. Please try again later." }) : this.props.children;
  }
}
const Oo = (t) => {
  let e;
  const r = /* @__PURE__ */ new Set(), a = (d, m) => {
    const h = typeof d == "function" ? d(e) : d;
    if (!Object.is(h, e)) {
      const c = e;
      e = m ?? (typeof h != "object" || h === null) ? h : Object.assign({}, e, h), r.forEach((v) => v(e, c));
    }
  }, n = () => e, u = { setState: a, getState: n, getInitialState: () => l, subscribe: (d) => (r.add(d), () => r.delete(d)), destroy: () => {
    r.clear();
  } }, l = e = t(a, n, u);
  return u;
}, Sc = (t) => t ? Oo(t) : Oo;
var Br = { exports: {} }, _r = {}, Gt = { exports: {} }, wr = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xo;
function Oc() {
  if (xo)
    return wr;
  xo = 1;
  var t = st;
  function e(m, h) {
    return m === h && (m !== 0 || 1 / m === 1 / h) || m !== m && h !== h;
  }
  var r = typeof Object.is == "function" ? Object.is : e, a = t.useState, n = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function i(m, h) {
    var c = h(), v = a({ inst: { value: c, getSnapshot: h } }), f = v[0].inst, p = v[1];
    return o(
      function() {
        f.value = c, f.getSnapshot = h, u(f) && p({ inst: f });
      },
      [m, c, h]
    ), n(
      function() {
        return u(f) && p({ inst: f }), m(function() {
          u(f) && p({ inst: f });
        });
      },
      [m]
    ), s(c), c;
  }
  function u(m) {
    var h = m.getSnapshot;
    m = m.value;
    try {
      var c = h();
      return !r(m, c);
    } catch {
      return !0;
    }
  }
  function l(m, h) {
    return h();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : i;
  return wr.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, wr;
}
var Er = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Do;
function xc() {
  return Do || (Do = 1, process.env.NODE_ENV !== "production" && function() {
    function t(c, v) {
      return c === v && (c !== 0 || 1 / c === 1 / v) || c !== c && v !== v;
    }
    function e(c, v) {
      d || n.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var f = v();
      if (!m) {
        var p = v();
        o(f, p) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), m = !0);
      }
      p = s({
        inst: { value: f, getSnapshot: v }
      });
      var b = p[0].inst, M = p[1];
      return u(
        function() {
          b.value = f, b.getSnapshot = v, r(b) && M({ inst: b });
        },
        [c, f, v]
      ), i(
        function() {
          return r(b) && M({ inst: b }), c(function() {
            r(b) && M({ inst: b });
          });
        },
        [c]
      ), l(f), f;
    }
    function r(c) {
      var v = c.getSnapshot;
      c = c.value;
      try {
        var f = v();
        return !o(c, f);
      } catch {
        return !0;
      }
    }
    function a(c, v) {
      return v();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var n = st, o = typeof Object.is == "function" ? Object.is : t, s = n.useState, i = n.useEffect, u = n.useLayoutEffect, l = n.useDebugValue, d = !1, m = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : e;
    Er.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Er;
}
var Co;
function Li() {
  return Co || (Co = 1, process.env.NODE_ENV === "production" ? Gt.exports = Oc() : Gt.exports = xc()), Gt.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var To;
function Dc() {
  if (To)
    return _r;
  To = 1;
  var t = st, e = Li();
  function r(l, d) {
    return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
  }
  var a = typeof Object.is == "function" ? Object.is : r, n = e.useSyncExternalStore, o = t.useRef, s = t.useEffect, i = t.useMemo, u = t.useDebugValue;
  return _r.useSyncExternalStoreWithSelector = function(l, d, m, h, c) {
    var v = o(null);
    if (v.current === null) {
      var f = { hasValue: !1, value: null };
      v.current = f;
    } else
      f = v.current;
    v = i(
      function() {
        function b(P) {
          if (!M) {
            if (M = !0, g = P, P = h(P), c !== void 0 && f.hasValue) {
              var S = f.value;
              if (c(S, P))
                return y = S;
            }
            return y = P;
          }
          if (S = y, a(g, P))
            return S;
          var D = h(P);
          return c !== void 0 && c(S, D) ? (g = P, S) : (g = P, y = D);
        }
        var M = !1, g, y, _ = m === void 0 ? null : m;
        return [
          function() {
            return b(d());
          },
          _ === null ? void 0 : function() {
            return b(_());
          }
        ];
      },
      [d, m, h, c]
    );
    var p = n(l, v[0], v[1]);
    return s(
      function() {
        f.hasValue = !0, f.value = p;
      },
      [p]
    ), u(p), p;
  }, _r;
}
var Pr = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ao;
function Cc() {
  return Ao || (Ao = 1, process.env.NODE_ENV !== "production" && function() {
    function t(l, d) {
      return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = st, r = Li(), a = typeof Object.is == "function" ? Object.is : t, n = r.useSyncExternalStore, o = e.useRef, s = e.useEffect, i = e.useMemo, u = e.useDebugValue;
    Pr.useSyncExternalStoreWithSelector = function(l, d, m, h, c) {
      var v = o(null);
      if (v.current === null) {
        var f = { hasValue: !1, value: null };
        v.current = f;
      } else
        f = v.current;
      v = i(
        function() {
          function b(P) {
            if (!M) {
              if (M = !0, g = P, P = h(P), c !== void 0 && f.hasValue) {
                var S = f.value;
                if (c(S, P))
                  return y = S;
              }
              return y = P;
            }
            if (S = y, a(g, P))
              return S;
            var D = h(P);
            return c !== void 0 && c(S, D) ? (g = P, S) : (g = P, y = D);
          }
          var M = !1, g, y, _ = m === void 0 ? null : m;
          return [
            function() {
              return b(d());
            },
            _ === null ? void 0 : function() {
              return b(_());
            }
          ];
        },
        [d, m, h, c]
      );
      var p = n(l, v[0], v[1]);
      return s(
        function() {
          f.hasValue = !0, f.value = p;
        },
        [p]
      ), u(p), p;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Pr;
}
process.env.NODE_ENV === "production" ? Br.exports = Dc() : Br.exports = Cc();
var Tc = Br.exports;
const Ac = /* @__PURE__ */ ye(Tc), { useDebugValue: Rc } = st, { useSyncExternalStoreWithSelector: kc } = Ac;
const jc = (t) => t;
function Ic(t, e = jc, r) {
  const a = kc(
    t.subscribe,
    t.getState,
    t.getServerState || t.getInitialState,
    e,
    r
  );
  return Rc(a), a;
}
const zr = /* @__PURE__ */ new Map(), Jt = (t) => {
  const e = zr.get(t);
  return e ? Object.fromEntries(
    Object.entries(e.stores).map(([r, a]) => [r, a.getState()])
  ) : {};
}, Lc = (t, e, r) => {
  if (t === void 0)
    return {
      type: "untracked",
      connection: e.connect(r)
    };
  const a = zr.get(r.name);
  if (a)
    return { type: "tracked", store: t, ...a };
  const n = {
    connection: e.connect(r),
    stores: {}
  };
  return zr.set(r.name, n), { type: "tracked", store: t, ...n };
}, Wc = (t, e = {}) => (r, a, n) => {
  const { enabled: o, anonymousActionType: s, store: i, ...u } = e;
  let l;
  try {
    l = (o ?? !1) && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!l)
    return t(r, a, n);
  const { connection: d, ...m } = Lc(i, l, u);
  let h = !0;
  n.setState = (f, p, b) => {
    const M = r(f, p);
    if (!h)
      return M;
    const g = b === void 0 ? { type: s || "anonymous" } : typeof b == "string" ? { type: b } : b;
    return i === void 0 ? (d == null || d.send(g, a()), M) : (d == null || d.send(
      {
        ...g,
        type: `${i}/${g.type}`
      },
      {
        ...Jt(u.name),
        [i]: n.getState()
      }
    ), M);
  };
  const c = (...f) => {
    const p = h;
    h = !1, r(...f), h = p;
  }, v = t(n.setState, a, n);
  if (m.type === "untracked" ? d == null || d.init(v) : (m.stores[m.store] = n, d == null || d.init(
    Object.fromEntries(
      Object.entries(m.stores).map(([f, p]) => [
        f,
        f === m.store ? v : p.getState()
      ])
    )
  )), n.dispatchFromDevtools && typeof n.dispatch == "function") {
    let f = !1;
    const p = n.dispatch;
    n.dispatch = (...b) => {
      p(...b);
    };
  }
  return d.subscribe((f) => {
    var p;
    switch (f.type) {
      case "ACTION":
        if (typeof f.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return Sr(
          f.payload,
          (b) => {
            if (b.type === "__setState") {
              if (i === void 0) {
                c(b.state);
                return;
              }
              Object.keys(b.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const M = b.state[i];
              if (M == null)
                return;
              JSON.stringify(n.getState()) !== JSON.stringify(M) && c(M);
              return;
            }
            n.dispatchFromDevtools && typeof n.dispatch == "function" && n.dispatch(b);
          }
        );
      case "DISPATCH":
        switch (f.payload.type) {
          case "RESET":
            return c(v), i === void 0 ? d == null ? void 0 : d.init(n.getState()) : d == null ? void 0 : d.init(Jt(u.name));
          case "COMMIT":
            if (i === void 0) {
              d == null || d.init(n.getState());
              return;
            }
            return d == null ? void 0 : d.init(Jt(u.name));
          case "ROLLBACK":
            return Sr(f.state, (b) => {
              if (i === void 0) {
                c(b), d == null || d.init(n.getState());
                return;
              }
              c(b[i]), d == null || d.init(Jt(u.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return Sr(f.state, (b) => {
              if (i === void 0) {
                c(b);
                return;
              }
              JSON.stringify(n.getState()) !== JSON.stringify(b[i]) && c(b[i]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: b } = f.payload, M = (p = b.computedStates.slice(-1)[0]) == null ? void 0 : p.state;
            if (!M)
              return;
            c(i === void 0 ? M : M[i]), d == null || d.send(
              null,
              // FIXME no-any
              b
            );
            return;
          }
          case "PAUSE_RECORDING":
            return h = !h;
        }
        return;
    }
  }), v;
}, Fc = Wc, Sr = (t, e) => {
  let r;
  try {
    r = JSON.parse(t);
  } catch (a) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      a
    );
  }
  r !== void 0 && e(r);
}, Nc = () => Sc()(
  Fc(
    (t) => ({
      addSelectedBet: (e) => {
        t((r) => ({
          selectedBets: [...(r.selectedBets || []).filter((a) => a.betId !== e.betId), e]
        }));
      },
      removeAllSelectedBets: () => {
        t({ selectedBets: [] });
      },
      removeSelectedBet: (e) => {
        t((r) => ({
          selectedBets: (r.selectedBets || []).filter((a) => a.betId !== e)
        }));
      },
      selectedBets: [],
      syncBetslip: (e, r) => {
        t((a) => {
          if (r)
            return {
              selectedBets: e.map((o) => ({
                betId: o.betId,
                bookieCode: o.bestOddsBookmakers.split(",")[0]
              }))
            };
          const n = a.selectedBets || [];
          return {
            selectedBets: [
              ...n,
              ...e.reduce((o, s) => (n.find(({ betId: i }) => s.betId === i) || o.push({
                betId: s.betId,
                bookieCode: s.bestOddsBookmakers.split(",")[0]
              }), o), [])
            ]
          };
        });
      }
    }),
    { enabled: !1, name: "MostPopularBetsStore" }
  )
), Wn = Qe(null), Hc = ({ children: t, ...e }) => {
  const r = He(() => Nc(), []), a = W(() => {
    r.getState().removeAllSelectedBets();
  }, [r]), n = W(
    (s) => {
      r.getState().removeSelectedBet(s);
    },
    [r]
  ), o = W(
    (s, i) => {
      var u, l;
      (l = (u = r.getState()).syncBetslip) == null || l.call(u, s, i);
    },
    [r]
  );
  return X(() => {
    var s, i;
    (i = (s = window.ocBetslip) == null ? void 0 : s.setCallbacks) == null || i.call(s, {
      clearBetslip: a,
      removeBet: n,
      syncBetslip: o
    });
  }, [a, n, o]), /* @__PURE__ */ F(Wn.Provider, { value: { props: e, store: r }, children: t });
}, cr = () => {
  const t = Ee(Wn);
  if (!t)
    throw new Error("useMostPopularBetsProps must be used within MostPopularBetsPropsProvider");
  return t.props;
}, Or = (t) => {
  const e = Ee(Wn);
  if (!e)
    throw new Error("useMostPopularBetsStore must be used within MostPopularBetsPropsProvider");
  return Ic(e.store, t);
};
function Wi(t) {
  var e, r, a = "";
  if (typeof t == "string" || typeof t == "number")
    a += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var n = t.length;
      for (e = 0; e < n; e++)
        t[e] && (r = Wi(t[e])) && (a && (a += " "), a += r);
    } else
      for (r in t)
        t[r] && (a && (a += " "), a += r);
  return a;
}
function Nt() {
  for (var t, e, r = 0, a = "", n = arguments.length; r < n; r++)
    (t = arguments[r]) && (e = Wi(t)) && (a && (a += " "), a += e);
  return a;
}
var $r = { exports: {} }, Fi = { exports: {} };
(function(t) {
  function e(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Fi);
var N = Fi.exports, qr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "mindre end ét sekund",
      other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
      one: "1 sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "ét halvt minut",
    lessThanXMinutes: {
      one: "mindre end ét minut",
      other: "mindre end {{count}} minutter"
    },
    xMinutes: {
      one: "1 minut",
      other: "{{count}} minutter"
    },
    aboutXHours: {
      one: "cirka 1 time",
      other: "cirka {{count}} timer"
    },
    xHours: {
      one: "1 time",
      other: "{{count}} timer"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dage"
    },
    aboutXWeeks: {
      one: "cirka 1 uge",
      other: "cirka {{count}} uger"
    },
    xWeeks: {
      one: "1 uge",
      other: "{{count}} uger"
    },
    aboutXMonths: {
      one: "cirka 1 måned",
      other: "cirka {{count}} måneder"
    },
    xMonths: {
      one: "1 måned",
      other: "{{count}} måneder"
    },
    aboutXYears: {
      one: "cirka 1 år",
      other: "cirka {{count}} år"
    },
    xYears: {
      one: "1 år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "over 1 år",
      other: "over {{count}} år"
    },
    almostXYears: {
      one: "næsten 1 år",
      other: "næsten {{count}} år"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", String(i)), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "om " + l : l + " siden" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(qr, qr.exports);
var Bc = qr.exports, Vr = { exports: {} }, Kr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = n.width ? String(n.width) : a.defaultWidth, s = a.formats[o] || a.formats[a.defaultWidth];
      return s;
    };
  }
  t.exports = e.default;
})(Kr, Kr.exports);
var _e = Kr.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(Vr, Vr.exports);
var zc = Vr.exports, Ur = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i går kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'på' eeee 'kl.' p",
    other: "P"
  }, a = function(s, i, u, l) {
    return r[s];
  }, n = a;
  e.default = n, t.exports = e.default;
})(Ur, Ur.exports);
var $c = Ur.exports, Yr = { exports: {} }, Xr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function(n, o) {
      var s = o != null && o.context ? String(o.context) : "standalone", i;
      if (s === "formatting" && a.formattingValues) {
        var u = a.defaultFormattingWidth || a.defaultWidth, l = o != null && o.width ? String(o.width) : u;
        i = a.formattingValues[l] || a.formattingValues[u];
      } else {
        var d = a.defaultWidth, m = o != null && o.width ? String(o.width) : a.defaultWidth;
        i = a.values[m] || a.values[d];
      }
      var h = a.argumentCallback ? a.argumentCallback(n) : n;
      return i[h];
    };
  }
  t.exports = e.default;
})(Xr, Xr.exports);
var ze = Xr.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["fvt", "vt"],
    abbreviated: ["f.v.t.", "v.t."],
    wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
    wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
  }, i = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
    abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
    wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    }
  }, d = function(v, f) {
    var p = Number(v);
    return p + ".";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, h = m;
  e.default = h, t.exports = e.default;
})(Yr, Yr.exports);
var qc = Yr.exports, Gr = { exports: {} }, Jr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(o) {
    return function(s) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = i.width, l = u && o.matchPatterns[u] || o.matchPatterns[o.defaultMatchWidth], d = s.match(l);
      if (!d)
        return null;
      var m = d[0], h = u && o.parsePatterns[u] || o.parsePatterns[o.defaultParseWidth], c = Array.isArray(h) ? n(h, function(p) {
        return p.test(m);
      }) : a(h, function(p) {
        return p.test(m);
      }), v;
      v = o.valueCallback ? o.valueCallback(c) : c, v = i.valueCallback ? i.valueCallback(v) : v;
      var f = s.slice(m.length);
      return {
        value: v,
        rest: f
      };
    };
  }
  function a(o, s) {
    for (var i in o)
      if (o.hasOwnProperty(i) && s(o[i]))
        return i;
  }
  function n(o, s) {
    for (var i = 0; i < o.length; i++)
      if (s(o[i]))
        return i;
  }
  t.exports = e.default;
})(Jr, Jr.exports);
var $e = Jr.exports, Qr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.match(a.matchPattern);
      if (!s)
        return null;
      var i = s[0], u = n.match(a.parsePattern);
      if (!u)
        return null;
      var l = a.valueCallback ? a.valueCallback(u[0]) : u[0];
      l = o.valueCallback ? o.valueCallback(l) : l;
      var d = n.slice(i.length);
      return {
        value: l,
        rest: d
      };
    };
  }
  t.exports = e.default;
})(Qr, Qr.exports);
var qe = Qr.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)(\.)?/i, s = /\d+/i, i = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
  }, u = {
    any: [/^f/i, /^(v|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
  }, v = {
    narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, f = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /midnat/i,
      noon: /middag/i,
      morning: /morgen/i,
      afternoon: /eftermiddag/i,
      evening: /aften/i,
      night: /nat/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Gr, Gr.exports);
var Vc = Gr.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Bc), n = r(zc), o = r($c), s = r(qc), i = r(Vc), u = {
    code: "da",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})($r, $r.exports);
var Kc = $r.exports;
const Uc = /* @__PURE__ */ ye(Kc);
var Zr = { exports: {} }, ea = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      standalone: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      },
      withPreposition: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      }
    },
    xSeconds: {
      standalone: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      },
      withPreposition: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      }
    },
    halfAMinute: {
      standalone: "halbe Minute",
      withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
      standalone: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      },
      withPreposition: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      }
    },
    xMinutes: {
      standalone: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      },
      withPreposition: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      }
    },
    aboutXHours: {
      standalone: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      },
      withPreposition: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      }
    },
    xHours: {
      standalone: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      },
      withPreposition: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      }
    },
    xDays: {
      standalone: {
        one: "1 Tag",
        other: "{{count}} Tage"
      },
      withPreposition: {
        one: "1 Tag",
        other: "{{count}} Tagen"
      }
    },
    aboutXWeeks: {
      standalone: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      },
      withPreposition: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      }
    },
    xWeeks: {
      standalone: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      },
      withPreposition: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      }
    },
    aboutXMonths: {
      standalone: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monate"
      },
      withPreposition: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monaten"
      }
    },
    xMonths: {
      standalone: {
        one: "1 Monat",
        other: "{{count}} Monate"
      },
      withPreposition: {
        one: "1 Monat",
        other: "{{count}} Monaten"
      }
    },
    aboutXYears: {
      standalone: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahre"
      },
      withPreposition: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahren"
      }
    },
    xYears: {
      standalone: {
        one: "1 Jahr",
        other: "{{count}} Jahre"
      },
      withPreposition: {
        one: "1 Jahr",
        other: "{{count}} Jahren"
      }
    },
    overXYears: {
      standalone: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahre"
      },
      withPreposition: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahren"
      }
    },
    almostXYears: {
      standalone: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahre"
      },
      withPreposition: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahren"
      }
    }
  }, a = function(s, i, u) {
    var l, d = u != null && u.addSuffix ? r[s].withPreposition : r[s].standalone;
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", String(i)), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "in " + l : "vor " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(ea, ea.exports);
var Yc = ea.exports, ta = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y"
    // 07.01.2018
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(ta, ta.exports);
var Xc = ta.exports, ra = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
  }, a = function(s, i, u, l) {
    return r[s];
  }, n = a;
  e.default = n, t.exports = e.default;
})(ra, ra.exports);
var Gc = ra.exports, aa = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["v.Chr.", "n.Chr."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["vor Christus", "nach Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
  }, i = {
    narrow: s.narrow,
    abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
    wide: s.wide
  }, u = {
    narrow: ["S", "M", "D", "M", "D", "F", "S"],
    short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
    wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
  }, l = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachm.",
      evening: "Abend",
      night: "Nacht"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    }
  }, d = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachm.",
      evening: "abends",
      night: "nachts"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    }
  }, m = function(f) {
    var p = Number(f);
    return p + ".";
  }, h = {
    ordinalNumber: m,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      formattingValues: i,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, c = h;
  e.default = c, t.exports = e.default;
})(aa, aa.exports);
var Jc = aa.exports, na = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)(\.)?/i, s = /\d+/i, i = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
  }, u = {
    any: [/^v/i, /^n/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
  }, v = {
    any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
  }, f = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
  }, p = {
    any: {
      am: /^v/i,
      pm: /^n/i,
      midnight: /^Mitte/i,
      noon: /^Mitta/i,
      morning: /morgens/i,
      afternoon: /nachmittags/i,
      // will never be matched. Afternoon is matched by `pm`
      evening: /abends/i,
      night: /nachts/i
      // will never be matched. Night is matched by `pm`
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(na, na.exports);
var Qc = na.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Yc), n = r(Xc), o = r(Gc), s = r(Jc), i = r(Qc), u = {
    code: "de",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(Zr, Zr.exports);
var Zc = Zr.exports;
const ef = /* @__PURE__ */ ye(Zc);
var oa = { exports: {} }, ia = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", i.toString()), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(ia, ia.exports);
var Ot = ia.exports, ua = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(ua, ua.exports);
var tf = ua.exports, sa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, a = function(s, i, u, l) {
    return r[s];
  }, n = a;
  e.default = n, t.exports = e.default;
})(sa, sa.exports);
var ct = sa.exports, la = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, i = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, d = function(v, f) {
    var p = Number(v), b = p % 100;
    if (b > 20 || b < 10)
      switch (b % 10) {
        case 1:
          return p + "st";
        case 2:
          return p + "nd";
        case 3:
          return p + "rd";
      }
    return p + "th";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, h = m;
  e.default = h, t.exports = e.default;
})(la, la.exports);
var ft = la.exports, da = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)(th|st|nd|rd)?/i, s = /\d+/i, i = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, u = {
    any: [/^b/i, /^(a|c)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, v = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, f = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(da, da.exports);
var vt = da.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ot), n = r(tf), o = r(ct), s = r(ft), i = r(vt), u = {
    code: "en-AU",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(oa, oa.exports);
var rf = oa.exports;
const af = /* @__PURE__ */ ye(rf);
var ca = { exports: {} }, fa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "a second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "a minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about an hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "an hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "a day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about a week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "a week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about a month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "a month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about a year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "a year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over a year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost a year",
      other: "almost {{count}} years"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", i.toString()), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(fa, fa.exports);
var nf = fa.exports, va = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(va, va.exports);
var of = va.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ct), n = r(ft), o = r(vt), s = r(nf), i = r(of), u = {
    code: "en-CA",
    formatDistance: s.default,
    formatLong: i.default,
    formatRelative: a.default,
    localize: n.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(ca, ca.exports);
var uf = ca.exports;
const sf = /* @__PURE__ */ ye(uf);
var ma = { exports: {} }, ha = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(ha, ha.exports);
var lf = ha.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ot), n = r(ct), o = r(ft), s = r(vt), i = r(lf), u = {
    code: "en-GB",
    formatDistance: a.default,
    formatLong: i.default,
    formatRelative: n.default,
    localize: o.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(ma, ma.exports);
var df = ma.exports;
const cf = /* @__PURE__ */ ye(df);
var pa = { exports: {} }, ya = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(ya, ya.exports);
var ff = ya.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ot), n = r(ct), o = r(ft), s = r(vt), i = r(ff), u = {
    code: "en-IN",
    formatDistance: a.default,
    formatLong: i.default,
    formatRelative: n.default,
    localize: o.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      // Monday is the first day of the week.
      firstWeekContainsDate: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(pa, pa.exports);
var vf = pa.exports;
const mf = /* @__PURE__ */ ye(vf);
var ba = { exports: {} }, ga = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(ga, ga.exports);
var hf = ga.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ot), n = r(ct), o = r(ft), s = r(vt), i = r(hf), u = {
    code: "en-NZ",
    formatDistance: a.default,
    formatLong: i.default,
    formatRelative: n.default,
    localize: o.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(ba, ba.exports);
var pf = ba.exports;
const yf = /* @__PURE__ */ ye(pf);
var Ma = { exports: {} }, _a = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(_a, _a.exports);
var bf = _a.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ot), n = r(bf), o = r(ct), s = r(ft), i = r(vt), u = {
    code: "en-US",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(Ma, Ma.exports);
var gf = Ma.exports;
const Mf = /* @__PURE__ */ ye(gf);
var wa = { exports: {} }, Ea = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(Ea, Ea.exports);
var _f = Ea.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ot), n = r(ct), o = r(ft), s = r(vt), i = r(_f), u = {
    code: "en-ZA",
    formatDistance: a.default,
    formatLong: i.default,
    formatRelative: n.default,
    localize: o.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      // Sunday is the first day of the week.
      firstWeekContainsDate: 1
      // The week that contains Jan 1st is the first week of the year.
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(wa, wa.exports);
var wf = wa.exports;
const Ef = /* @__PURE__ */ ye(wf);
var Pa = { exports: {} }, Sa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de un segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
      one: "menos de un minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "alrededor de 1 hora",
      other: "alrededor de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 día",
      other: "{{count}} días"
    },
    aboutXWeeks: {
      one: "alrededor de 1 semana",
      other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "alrededor de 1 mes",
      other: "alrededor de {{count}} meses"
    },
    xMonths: {
      one: "1 mes",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "alrededor de 1 año",
      other: "alrededor de {{count}} años"
    },
    xYears: {
      one: "1 año",
      other: "{{count}} años"
    },
    overXYears: {
      one: "más de 1 año",
      other: "más de {{count}} años"
    },
    almostXYears: {
      one: "casi 1 año",
      other: "casi {{count}} años"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", i.toString()), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "en " + l : "hace " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Sa, Sa.exports);
var Pf = Sa.exports, Oa = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(Oa, Oa.exports);
var Sf = Oa.exports, xa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'mañana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
  }, a = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'mañana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
  }, n = function(i, u, l, d) {
    return u.getUTCHours() !== 1 ? a[i] : r[i];
  }, o = n;
  e.default = o, t.exports = e.default;
})(xa, xa.exports);
var Of = xa.exports, Da = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "después de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
  }, i = {
    narrow: ["d", "l", "m", "m", "j", "v", "s"],
    short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
    abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    }
  }, d = function(v, f) {
    var p = Number(v);
    return p + "º";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return Number(v) - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, h = m;
  e.default = h, t.exports = e.default;
})(Da, Da.exports);
var xf = Da.exports, Ca = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(qe), n = r($e), o = /^(\d+)(º)?/i, s = /\d+/i, i = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
  }, u = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
  }, h = {
    narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
  }, c = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
  }, v = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
  }, f = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn/i,
      noon: /^md/i,
      morning: /mañana/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noche/i
    }
  }, b = {
    ordinalNumber: (0, a.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Ca, Ca.exports);
var Df = Ca.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Pf), n = r(Sf), o = r(Of), s = r(xf), i = r(Df), u = {
    code: "es",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 1
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(Pa, Pa.exports);
var Cf = Pa.exports;
const Tf = /* @__PURE__ */ ye(Cf);
var Ta = { exports: {} }, Aa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "moins d’une seconde",
      other: "moins de {{count}} secondes"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
      one: "moins d’une minute",
      other: "moins de {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "environ 1 heure",
      other: "environ {{count}} heures"
    },
    xHours: {
      one: "1 heure",
      other: "{{count}} heures"
    },
    xDays: {
      one: "1 jour",
      other: "{{count}} jours"
    },
    aboutXWeeks: {
      one: "environ 1 semaine",
      other: "environ {{count}} semaines"
    },
    xWeeks: {
      one: "1 semaine",
      other: "{{count}} semaines"
    },
    aboutXMonths: {
      one: "environ 1 mois",
      other: "environ {{count}} mois"
    },
    xMonths: {
      one: "1 mois",
      other: "{{count}} mois"
    },
    aboutXYears: {
      one: "environ 1 an",
      other: "environ {{count}} ans"
    },
    xYears: {
      one: "1 an",
      other: "{{count}} ans"
    },
    overXYears: {
      one: "plus d’un an",
      other: "plus de {{count}} ans"
    },
    almostXYears: {
      one: "presqu’un an",
      other: "presque {{count}} ans"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", String(i)), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "dans " + l : "il y a " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Aa, Aa.exports);
var Af = Aa.exports, Ra = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'à' {{time}}",
    long: "{{date}} 'à' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(Ra, Ra.exports);
var Rf = Ra.exports, ka = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "eeee 'dernier à' p",
    yesterday: "'hier à' p",
    today: "'aujourd’hui à' p",
    tomorrow: "'demain à' p'",
    nextWeek: "eeee 'prochain à' p",
    other: "P"
  }, a = function(s, i, u, l) {
    return r[s];
  }, n = a;
  e.default = n, t.exports = e.default;
})(ka, ka.exports);
var kf = ka.exports, ja = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["av. J.-C", "ap. J.-C"],
    abbreviated: ["av. J.-C", "ap. J.-C"],
    wide: ["avant Jésus-Christ", "après Jésus-Christ"]
  }, o = {
    narrow: ["T1", "T2", "T3", "T4"],
    abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
    wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  }, i = {
    narrow: ["D", "L", "M", "M", "J", "V", "S"],
    short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
    abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  }, u = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "mat.",
      afternoon: "ap.m.",
      evening: "soir",
      night: "mat."
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "matin",
      afternoon: "après-midi",
      evening: "soir",
      night: "matin"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "du matin",
      afternoon: "de l’après-midi",
      evening: "du soir",
      night: "du matin"
    }
  }, l = function(c, v) {
    var f = Number(c), p = v == null ? void 0 : v.unit;
    if (f === 0)
      return "0";
    var b = ["year", "week", "hour", "minute", "second"], M;
    return f === 1 ? M = p && b.includes(p) ? "ère" : "er" : M = "ème", f + M;
  }, d = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(c) {
        return c - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    })
  }, m = d;
  e.default = m, t.exports = e.default;
})(ja, ja.exports);
var jf = ja.exports, Ia = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)(ième|ère|ème|er|e)?/i, s = /\d+/i, i = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
  }, u = {
    any: [/^av/i, /^ap/i]
  }, l = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
  }, v = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
  }, f = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^min/i,
      noon: /^mid/i,
      morning: /mat/i,
      afternoon: /ap/i,
      evening: /soir/i,
      night: /nuit/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Ia, Ia.exports);
var If = Ia.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Af), n = r(Rf), o = r(kf), s = r(jf), i = r(If), u = {
    code: "fr",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(Ta, Ta.exports);
var Lf = Ta.exports;
const Wf = /* @__PURE__ */ ye(Lf);
var La = { exports: {} }, Wa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "meno di un secondo",
      other: "meno di {{count}} secondi"
    },
    xSeconds: {
      one: "un secondo",
      other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
      one: "meno di un minuto",
      other: "meno di {{count}} minuti"
    },
    xMinutes: {
      one: "un minuto",
      other: "{{count}} minuti"
    },
    aboutXHours: {
      one: "circa un'ora",
      other: "circa {{count}} ore"
    },
    xHours: {
      one: "un'ora",
      other: "{{count}} ore"
    },
    xDays: {
      one: "un giorno",
      other: "{{count}} giorni"
    },
    aboutXWeeks: {
      one: "circa una settimana",
      other: "circa {{count}} settimane"
    },
    xWeeks: {
      one: "una settimana",
      other: "{{count}} settimane"
    },
    aboutXMonths: {
      one: "circa un mese",
      other: "circa {{count}} mesi"
    },
    xMonths: {
      one: "un mese",
      other: "{{count}} mesi"
    },
    aboutXYears: {
      one: "circa un anno",
      other: "circa {{count}} anni"
    },
    xYears: {
      one: "un anno",
      other: "{{count}} anni"
    },
    overXYears: {
      one: "più di un anno",
      other: "più di {{count}} anni"
    },
    almostXYears: {
      one: "quasi un anno",
      other: "quasi {{count}} anni"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", i.toString()), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "tra " + l : l + " fa" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Wa, Wa.exports);
var Ff = Wa.exports, Fa = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(Fa, Fa.exports);
var Nf = Fa.exports, Na = { exports: {} }, Ha = { exports: {} }, Ba = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a, n) {
    if (n.length < a)
      throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  t.exports = e.default;
})(Ba, Ba.exports);
var Fn = Ba.exports, za = { exports: {} }, $a = { exports: {} }, Ni = { exports: {} };
(function(t) {
  function e(r) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Ni);
var Hf = Ni.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(Hf), n = r(Fn);
  function o(s) {
    (0, n.default)(1, arguments);
    var i = Object.prototype.toString.call(s);
    return s instanceof Date || (0, a.default)(s) === "object" && i === "[object Date]" ? new Date(s.getTime()) : typeof s == "number" || i === "[object Number]" ? new Date(s) : ((typeof s == "string" || i === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})($a, $a.exports);
var Bf = $a.exports, qa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  t.exports = e.default;
})(qa, qa.exports);
var zf = qa.exports, fr = {};
Object.defineProperty(fr, "__esModule", {
  value: !0
});
fr.getDefaultOptions = $f;
fr.setDefaultOptions = qf;
var Hi = {};
function $f() {
  return Hi;
}
function qf(t) {
  Hi = t;
}
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var a = r(Bf), n = r(Fn), o = r(zf), s = fr;
  function i(u, l) {
    var d, m, h, c, v, f, p, b;
    (0, n.default)(1, arguments);
    var M = (0, s.getDefaultOptions)(), g = (0, o.default)((d = (m = (h = (c = l == null ? void 0 : l.weekStartsOn) !== null && c !== void 0 ? c : l == null || (v = l.locale) === null || v === void 0 || (f = v.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && h !== void 0 ? h : M.weekStartsOn) !== null && m !== void 0 ? m : (p = M.locale) === null || p === void 0 || (b = p.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && d !== void 0 ? d : 0);
    if (!(g >= 0 && g <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var y = (0, a.default)(u), _ = y.getUTCDay(), P = (_ < g ? 7 : 0) + _ - g;
    return y.setUTCDate(y.getUTCDate() - P), y.setUTCHours(0, 0, 0, 0), y;
  }
  t.exports = e.default;
})(za, za.exports);
var Vf = za.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(Fn), n = r(Vf);
  function o(s, i, u) {
    (0, a.default)(2, arguments);
    var l = (0, n.default)(s, u), d = (0, n.default)(i, u);
    return l.getTime() === d.getTime();
  }
  t.exports = e.default;
})(Ha, Ha.exports);
var Kf = Ha.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Kf), n = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  function o(m) {
    switch (m) {
      case 0:
        return "'domenica scorsa alle' p";
      default:
        return "'" + n[m] + " scorso alle' p";
    }
  }
  function s(m) {
    return "'" + n[m] + " alle' p";
  }
  function i(m) {
    switch (m) {
      case 0:
        return "'domenica prossima alle' p";
      default:
        return "'" + n[m] + " prossimo alle' p";
    }
  }
  var u = {
    lastWeek: function(h, c, v) {
      var f = h.getUTCDay();
      return (0, a.default)(h, c, v) ? s(f) : o(f);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function(h, c, v) {
      var f = h.getUTCDay();
      return (0, a.default)(h, c, v) ? s(f) : i(f);
    },
    other: "P"
  }, l = function(h, c, v, f) {
    var p = u[h];
    return typeof p == "function" ? p(c, v, f) : p;
  }, d = l;
  e.default = d, t.exports = e.default;
})(Na, Na.exports);
var Uf = Na.exports, Va = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["avanti Cristo", "dopo Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
    abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
    wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
  }, i = {
    narrow: ["D", "L", "M", "M", "G", "V", "S"],
    short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
  }, u = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    }
  }, l = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    }
  }, d = function(v, f) {
    var p = Number(v);
    return String(p);
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, h = m;
  e.default = h, t.exports = e.default;
})(Va, Va.exports);
var Yf = Va.exports, Ka = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)(º)?/i, s = /\d+/i, i = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
  }, u = {
    any: [/^a/i, /^(d|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
  }, h = {
    narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
  }, v = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
    any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
  }, f = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mezza/i,
      noon: /^mezzo/i,
      morning: /mattina/i,
      afternoon: /pomeriggio/i,
      evening: /sera/i,
      night: /notte/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Ka, Ka.exports);
var Xf = Ka.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ff), n = r(Nf), o = r(Uf), s = r(Yf), i = r(Xf), u = {
    code: "it",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(La, La.exports);
var Gf = La.exports;
const Jf = /* @__PURE__ */ ye(Gf);
var Ua = { exports: {} }, Ya = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "minder dan een seconde",
      other: "minder dan {{count}} seconden"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
      one: "minder dan een minuut",
      other: "minder dan {{count}} minuten"
    },
    xMinutes: {
      one: "een minuut",
      other: "{{count}} minuten"
    },
    aboutXHours: {
      one: "ongeveer 1 uur",
      other: "ongeveer {{count}} uur"
    },
    xHours: {
      one: "1 uur",
      other: "{{count}} uur"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dagen"
    },
    aboutXWeeks: {
      one: "ongeveer 1 week",
      other: "ongeveer {{count}} weken"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weken"
    },
    aboutXMonths: {
      one: "ongeveer 1 maand",
      other: "ongeveer {{count}} maanden"
    },
    xMonths: {
      one: "1 maand",
      other: "{{count}} maanden"
    },
    aboutXYears: {
      one: "ongeveer 1 jaar",
      other: "ongeveer {{count}} jaar"
    },
    xYears: {
      one: "1 jaar",
      other: "{{count}} jaar"
    },
    overXYears: {
      one: "meer dan 1 jaar",
      other: "meer dan {{count}} jaar"
    },
    almostXYears: {
      one: "bijna 1 jaar",
      other: "bijna {{count}} jaar"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", String(i)), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "over " + l : l + " geleden" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Ya, Ya.exports);
var Qf = Ya.exports, Xa = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(Xa, Xa.exports);
var Zf = Xa.exports, Ga = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
  }, a = function(s, i, u, l) {
    return r[s];
  }, n = a;
  e.default = n, t.exports = e.default;
})(Ga, Ga.exports);
var ev = Ga.exports, Ja = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["v.C.", "n.C."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["voor Christus", "na Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["K1", "K2", "K3", "K4"],
    wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
  }, i = {
    narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
    short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
    wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
  }, u = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    }
  }, l = function(c, v) {
    var f = Number(c);
    return f + "e";
  }, d = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(c) {
        return c - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    })
  }, m = d;
  e.default = m, t.exports = e.default;
})(Ja, Ja.exports);
var tv = Ja.exports, Qa = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)e?/i, s = /\d+/i, i = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
  }, u = {
    any: [/^v/, /^n/]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
  }, c = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
  }, v = {
    narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
    any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
  }, f = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
  }, p = {
    any: {
      am: /^am/i,
      pm: /^pm/i,
      midnight: /^middernacht/i,
      noon: /^het middaguur/i,
      morning: /ochtend/i,
      afternoon: /middag/i,
      evening: /avond/i,
      night: /nacht/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(Qa, Qa.exports);
var rv = Qa.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Qf), n = r(Zf), o = r(ev), s = r(tv), i = r(rv), u = {
    code: "nl",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(Ua, Ua.exports);
var av = Ua.exports;
const nv = /* @__PURE__ */ ye(av);
var Za = { exports: {} }, en = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "aproximadamente 1 hora",
      other: "aproximadamente {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "aproximadamente 1 semana",
      other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "aproximadamente 1 mês",
      other: "aproximadamente {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "aproximadamente 1 ano",
      other: "aproximadamente {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", String(i)), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "daqui a " + l : "há " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(en, en.exports);
var ov = en.exports, tn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(tn, tn.exports);
var iv = tn.exports, rn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: function(s) {
      var i = s.getUTCDay(), u = i === 0 || i === 6 ? "último" : "última";
      return "'" + u + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(s, i, u, l) {
    var d = r[s];
    return typeof d == "function" ? d(i) : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(rn, rn.exports);
var uv = rn.exports, an = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["antes de Cristo", "depois de Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, i = {
    narrow: ["d", "s", "t", "q", "q", "s", "s"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, u = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    }
  }, l = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    }
  }, d = function(v, f) {
    var p = Number(v);
    return p + "º";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, h = m;
  e.default = h, t.exports = e.default;
})(an, an.exports);
var sv = an.exports, nn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)(º|ª)?/i, s = /\d+/i, i = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
  }, u = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
  }, v = {
    narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
  }, f = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^meia/i,
      noon: /^meio/i,
      morning: /manh[ãa]/i,
      afternoon: /tarde/i,
      evening: /noite/i,
      night: /madrugada/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(nn, nn.exports);
var lv = nn.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ov), n = r(iv), o = r(uv), s = r(sv), i = r(lv), u = {
    code: "pt",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(Za, Za.exports);
var dv = Za.exports;
const cv = /* @__PURE__ */ ye(dv);
var on = { exports: {} }, un = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "cerca de 1 hora",
      other: "cerca de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "cerca de 1 semana",
      other: "cerca de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "cerca de 1 mês",
      other: "cerca de {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "cerca de 1 ano",
      other: "cerca de {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(s, i, u) {
    var l, d = r[s];
    return typeof d == "string" ? l = d : i === 1 ? l = d.one : l = d.other.replace("{{count}}", String(i)), u != null && u.addSuffix ? u.comparison && u.comparison > 0 ? "em " + l : "há " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(un, un.exports);
var fv = un.exports, sn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(sn, sn.exports);
var vv = sn.exports, ln = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: function(s) {
      var i = s.getUTCDay(), u = i === 0 || i === 6 ? "último" : "última";
      return "'" + u + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(s, i, u, l) {
    var d = r[s];
    return typeof d == "function" ? d(i) : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(ln, ln.exports);
var mv = ln.exports, dn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "depois de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, s = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, i = {
    narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    }
  }, d = function(v, f) {
    var p = Number(v);
    return (f == null ? void 0 : f.unit) === "week" ? p + "ª" : p + "º";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, h = m;
  e.default = h, t.exports = e.default;
})(dn, dn.exports);
var hv = dn.exports, cn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)[ºªo]?/i, s = /\d+/i, i = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
  }, u = {
    any: [/^ac/i, /^dc/i],
    wide: [/^antes de cristo/i, /^depois de cristo/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
  }, c = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
  }, v = {
    short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
  }, f = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn|^meia[-\s]noite/i,
      noon: /^md|^meio[-\s]dia/i,
      morning: /manhã/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noite/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(cn, cn.exports);
var pv = cn.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(fv), n = r(vv), o = r(mv), s = r(hv), i = r(pv), u = {
    code: "pt-BR",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(on, on.exports);
var yv = on.exports;
const bv = /* @__PURE__ */ ye(yv);
var fn = { exports: {} }, vn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "mindre än en sekund",
      other: "mindre än {{count}} sekunder"
    },
    xSeconds: {
      one: "en sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
      one: "mindre än en minut",
      other: "mindre än {{count}} minuter"
    },
    xMinutes: {
      one: "en minut",
      other: "{{count}} minuter"
    },
    aboutXHours: {
      one: "ungefär en timme",
      other: "ungefär {{count}} timmar"
    },
    xHours: {
      one: "en timme",
      other: "{{count}} timmar"
    },
    xDays: {
      one: "en dag",
      other: "{{count}} dagar"
    },
    aboutXWeeks: {
      one: "ungefär en vecka",
      other: "ungefär {{count}} vecka"
    },
    xWeeks: {
      one: "en vecka",
      other: "{{count}} vecka"
    },
    aboutXMonths: {
      one: "ungefär en månad",
      other: "ungefär {{count}} månader"
    },
    xMonths: {
      one: "en månad",
      other: "{{count}} månader"
    },
    aboutXYears: {
      one: "ungefär ett år",
      other: "ungefär {{count}} år"
    },
    xYears: {
      one: "ett år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "över ett år",
      other: "över {{count}} år"
    },
    almostXYears: {
      one: "nästan ett år",
      other: "nästan {{count}} år"
    }
  }, a = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], n = function(i, u, l) {
    var d, m = r[i];
    return typeof m == "string" ? d = m : u === 1 ? d = m.one : l && l.onlyNumeric ? d = m.other.replace("{{count}}", String(u)) : d = m.other.replace("{{count}}", u < 13 ? a[u] : String(u)), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "om " + d : d + " sedan" : d;
  }, o = n;
  e.default = o, t.exports = e.default;
})(vn, vn.exports);
var gv = vn.exports, mn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
  }, o = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, s = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, i = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, u = i;
  e.default = u, t.exports = e.default;
})(mn, mn.exports);
var Mv = mn.exports, hn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'igår kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
  }, a = function(s, i, u, l) {
    return r[s];
  }, n = a;
  e.default = n, t.exports = e.default;
})(hn, hn.exports);
var _v = hn.exports, pn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(ze), n = {
    narrow: ["f.Kr.", "e.Kr."],
    abbreviated: ["f.Kr.", "e.Kr."],
    wide: ["före Kristus", "efter Kristus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
  }, i = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
    abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
    wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
  }, u = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "morg.",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    abbreviated: {
      am: "f.m.",
      pm: "e.m.",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    wide: {
      am: "förmiddag",
      pm: "eftermiddag",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "eftermiddag",
      evening: "kväll",
      night: "natt"
    }
  }, l = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    abbreviated: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    wide: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morgonen",
      afternoon: "på eftermiddagen",
      evening: "på kvällen",
      night: "på natten"
    }
  }, d = function(v, f) {
    var p = Number(v), b = p % 100;
    if (b > 20 || b < 10)
      switch (b % 10) {
        case 1:
        case 2:
          return p + ":a";
      }
    return p + ":e";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, h = m;
  e.default = h, t.exports = e.default;
})(pn, pn.exports);
var wv = pn.exports, yn = { exports: {} };
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($e), n = r(qe), o = /^(\d+)(:a|:e)?/i, s = /\d+/i, i = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
  }, u = {
    any: [/^f/i, /^[ev]/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
  }, h = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
  }, v = {
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, f = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
  }, p = {
    any: {
      am: /^f/i,
      pm: /^e/i,
      midnight: /^midn/i,
      noon: /^midd/i,
      morning: /morgon/i,
      afternoon: /eftermiddag/i,
      evening: /kväll/i,
      night: /natt/i
    }
  }, b = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(y) {
        return parseInt(y, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(y) {
        return y + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: f,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, M = b;
  e.default = M, t.exports = e.default;
})(yn, yn.exports);
var Ev = yn.exports;
(function(t, e) {
  var r = N.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(gv), n = r(Mv), o = r(_v), s = r(wv), i = r(Ev), u = {
    code: "sv",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = u;
  e.default = l, t.exports = e.default;
})(fn, fn.exports);
var Pv = fn.exports;
const Sv = /* @__PURE__ */ ye(Pv), se = {
  da: Uc,
  de: ef,
  enAU: af,
  enCA: sf,
  enGB: cf,
  enIN: mf,
  enNZ: yf,
  enUS: Mf,
  enZA: Ef,
  es: Tf,
  fr: Wf,
  it: Jf,
  nl: nv,
  pt: cv,
  ptBR: bv,
  sv: Sv
}, xr = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: se.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: se.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: se.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: se.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: se.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: se.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: se.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: se.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: se.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: se.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: se.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: se.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: se.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: se.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: se.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: se.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: se.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, Ov = [xr.IT.name, xr.ES.name, xr.BR.name], xv = [
  { id: 18, name: "AMERICAN FOOTBALL", translationFile: "american_football" },
  { id: 11, name: "ATHLETICS", translationFile: "athletics" },
  { id: 23, name: "AUSSIE RULES", translationFile: "aussie_rules" },
  { id: 32, name: "BADMINTON", translationFile: "badminton" },
  { id: 48, name: "BANDY", translationFile: "bandy" },
  { id: 46, name: "BASEBALL", translationFile: "baseball" },
  { id: 47, name: "BASKETBALL", translationFile: "basketball" },
  { id: 28, name: "BETTYPE", translationFile: "bettype" },
  { id: 31, name: "BOWLS", translationFile: "bowls" },
  { id: 10, name: "BOXING", translationFile: "boxing" },
  { id: 76, name: "CASINO", translationFile: "casino" },
  { id: 19, name: "CRICKET", translationFile: "cricket" },
  { id: 14, name: "CYCLING", translationFile: "cycling" },
  { id: 21, name: "DARTS", translationFile: "darts" },
  { id: 49, name: "DUMMY", translationFile: "dummy" },
  { id: 33, name: "EQUESTRIAN", translationFile: "equestrian" },
  { id: 34, name: "FINANCIAL", translationFile: "financial" },
  { id: 29, name: "FLOORBALL", translationFile: "floorball" },
  { id: 2, name: "FOOTBALL", translationFile: "football" },
  { id: 24, name: "GAELIC SPORTS", translationFile: "gaelic_sports" },
  { id: 6, name: "GOLF", translationFile: "golf" },
  { id: 5, name: "GREYHOUNDS", translationFile: "greyhounds" },
  { id: 35, name: "HANDBALL", translationFile: "handball" },
  { id: 74, name: "HARNESS RACING", translationFile: "harness_racing" },
  { id: 36, name: "HOCKEY", translationFile: "hockey" },
  { id: 3, name: "HORSE RACING", translationFile: "horse_racing" },
  { id: 45, name: "ICE HOCKEY", translationFile: "ice_hockey" },
  { id: 0, name: "LABEL", translationFile: "label" },
  { id: 27, name: "MENU", translationFile: "menu" },
  { id: 17, name: "MOTOR SPORT", translationFile: "motor_sport" },
  { id: 37, name: "NETBALL", translationFile: "netball" },
  { id: 62, name: "OLYMPICS", translationFile: "olympics" },
  { id: 26, name: "OTHER SPORTS", translationFile: "other_sports" },
  { id: 25, name: "POKER", translationFile: "poker" },
  { id: 68, name: "POLITICS", translationFile: "politics" },
  { id: 20, name: "POOL", translationFile: "pool" },
  { id: 22, name: "ROWING", translationFile: "rowing" },
  { id: 30, name: "RUGBY LEAGUE", translationFile: "rugby_league" },
  { id: 9, name: "RUGBY UNION", translationFile: "rugby_union" },
  { id: 8, name: "SNOOKER", translationFile: "snooker" },
  { id: 15, name: "SPECIALS", translationFile: "specials" },
  { id: 38, name: "SWIMMING", translationFile: "swimming" },
  { id: 39, name: "TABLE TENNIS", translationFile: "table_tennis" },
  { id: 7, name: "TENNIS", translationFile: "tennis" },
  { id: 40, name: "TROTTING", translationFile: "trotting" },
  { id: 71, name: "TV", translationFile: "tv" },
  { id: 61, name: "VIRTUAL FOOTBALL", translationFile: "virtual_football" },
  { id: 58, name: "VIRTUAL MOTORSPORT", translationFile: "virtual_motorsport" },
  { id: 41, name: "VOLLEYBALL", translationFile: "volleyball" },
  { id: 42, name: "WATER POLO", translationFile: "water_polo" },
  { id: 43, name: "WINTER SPORTS", translationFile: "winter_sports" },
  { id: 44, name: "YACHTING", translationFile: "yachting" }
];
/*! js-cookie v3.0.8 | MIT */
function Qt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var a in r)
      a !== "__proto__" && (t[a] = r[a]);
  }
  return t;
}
var Dv = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function bn(t, e) {
  function r(n, o, s) {
    if (!(typeof document > "u")) {
      s = Qt({}, e, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var u in s)
        s[u] && (i += "; " + u, s[u] !== !0 && (i += "=" + s[u].split(";")[0]));
      return document.cookie = n + "=" + t.write(o, n) + i;
    }
  }
  function a(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], s = {}, i = 0; i < o.length; i++) {
        var u = o[i].split("="), l = u.slice(1).join("=");
        try {
          var d = decodeURIComponent(u[0]);
          if (d in s || (s[d] = t.read(l, d)), n === d)
            break;
        } catch {
        }
      }
      return n ? s[n] : s;
    }
  }
  return Object.create(
    {
      set: r,
      get: a,
      remove: function(n, o) {
        r(
          n,
          "",
          Qt({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return bn(this.converter, Qt({}, this.attributes, n));
      },
      withConverter: function(n) {
        return bn(Qt({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
bn(Dv, { path: "/" });
Qe(void 0);
function Dr(t, e) {
  return +(Math.round(+(t + "e+" + e)) + "e-" + e);
}
function Cv(t) {
  switch (!0) {
    case t < 1.01:
      return Dr(t, 3);
    case t < 10:
      return Dr(t, 2);
    case t < 20:
      return Dr(t, 1);
    default:
      return Math.ceil(t);
  }
}
function Tv(t) {
  const e = [" v ", " at "];
  for (const r of e) {
    const a = t.split(r);
    if (a.length === 2) {
      const [n, o] = a.map((s) => s.trim());
      return r === " v " ? { away: o, first: n, home: n, second: o, separator: r, success: !0 } : { away: n, first: n, home: o, second: o, separator: r, success: !0 };
    }
  }
  return {
    away: "",
    first: "",
    home: "",
    second: "",
    separator: "",
    success: !1
  };
}
function Bi(t, e = {}, r) {
  const n = r || (() => {
    if (typeof window < "u")
      return window.dataLayer = window.dataLayer || [], window.dataLayer;
  })();
  n && n.push({
    event: t,
    ...e
  });
}
const Nn = () => {
  const { analyticsDataLayer: t, analyticsImpressionEventData: e, analyticsImpressionEventName: r, disableAnalytics: a } = cr(), n = W(
    (o, s = {}) => {
      a || Bi(o, { ...e, ...s }, t);
    },
    [t, e, a]
  );
  return {
    analyticsDataLayer: t,
    analyticsImpressionEventData: e,
    // Suppress impressions entirely when analytics is disabled.
    impressionEventName: a ? void 0 : r,
    track: n
  };
}, Av = ({
  betId: t,
  betName: e,
  betOdds: r,
  bookieCode: a,
  marketName: n,
  subeventName: o
}) => {
  const s = Or((m) => m.selectedBets), i = Or((m) => m.addSelectedBet), u = Or((m) => m.removeSelectedBet), l = He(() => s.some((m) => m.betId === t), [t, s]), d = W(() => {
    try {
      window.bettingActions.addOrRemoveFromBetslip(
        [{ betId: t, selectedBookie: a }],
        [t],
        a,
        r == null ? void 0 : r.toString(),
        e,
        "most-popular-bets",
        o,
        n,
        "n/a"
      );
    } catch (m) {
      console.error("useBetslip.toggleBetslipBet", m);
    }
    l ? u(t) : i({ betId: t, bookieCode: a });
  }, [
    l,
    u,
    t,
    i,
    a,
    r,
    e,
    o,
    n
  ]);
  return { isBookieBetSelected: l, toggleBetslipBet: d };
}, Rv = "application/json", zi = "Content-Type", mt = Symbol(), $i = Symbol();
function Ro(t = {}) {
  var e;
  const r = t instanceof Array ? Object.fromEntries(t) : t;
  return (e = Object.entries(r).find(([a]) => a.toLowerCase() === zi.toLowerCase())) === null || e === void 0 ? void 0 : e[1];
}
function ko(t) {
  return /^application\/.*json.*/.test(t);
}
const nt = function(t, e, r = !1) {
  return Object.entries(e).reduce((a, [n, o]) => {
    const s = t[n];
    return Array.isArray(s) && Array.isArray(o) ? a[n] = r ? [...s, ...o] : o : typeof s == "object" && typeof o == "object" ? a[n] = nt(s, o, r) : a[n] = o, a;
  }, { ...t });
}, wt = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(t, e = !0, r = !1, ...a) {
    const n = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof global < "u" ? global[t] : null);
    if (e && !n)
      throw new Error(t + " is not defined");
    return r && n ? new n(...a) : n;
  }
};
function kv(t, e = !1) {
  wt.options = e ? t : nt(wt.options, t);
}
function jv(t, e = !1) {
  wt.polyfills = e ? t : nt(wt.polyfills, t);
}
function Iv(t) {
  wt.errorType = t;
}
const Lv = (t) => (e) => t.reduceRight((r, a) => a(r), e) || e;
class qi extends Error {
}
const Wv = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  t = t._addons.reduce((g, y) => y.beforeRequest && y.beforeRequest(g, t._options, e) || g, t);
  const { _url: r, _options: a, _config: n, _catchers: o, _resolvers: s, _middlewares: i, _addons: u } = t, l = new Map(o), d = nt(n.options, a);
  let m = r;
  const h = Lv(i)((g, y) => (m = g, n.polyfill("fetch")(g, y)))(r, d), c = new Error(), v = h.catch((g) => {
    throw { [mt]: g };
  }).then((g) => {
    var y;
    if (!g.ok) {
      const _ = new qi();
      if (_.cause = c, _.stack = _.stack + `
CAUSE: ` + c.stack, _.response = g, _.status = g.status, _.url = m, g.type === "opaque")
        throw _;
      const P = n.errorType === "json" || ((y = g.headers.get("Content-Type")) === null || y === void 0 ? void 0 : y.split(";")[0]) === "application/json";
      return (n.errorType ? P ? g.text() : g[n.errorType]() : Promise.resolve(g.body)).then((D) => {
        if (_.message = typeof D == "string" ? D : g.statusText, D)
          if (P && typeof D == "string") {
            _.text = D;
            try {
              _.json = JSON.parse(D);
            } catch {
            }
          } else
            _[n.errorType] = D;
        throw _;
      });
    }
    return g;
  }), f = (g) => g.catch((y) => {
    const _ = Object.prototype.hasOwnProperty.call(y, mt), P = _ ? y[mt] : y, S = (P == null ? void 0 : P.status) && l.get(P.status) || l.get(P == null ? void 0 : P.name) || _ && l.has(mt) && l.get(mt);
    if (S)
      return S(P, t);
    const D = l.get($i);
    if (D)
      return D(P, t);
    throw P;
  }), p = (g) => (y) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ f(g ? v.then((_) => _ && _[g]()).then((_) => y ? y(_) : _) : v.then((_) => y ? y(_) : _)), b = {
    _wretchReq: t,
    _fetchReq: h,
    _sharedState: e,
    res: p(null),
    json: p("json"),
    blob: p("blob"),
    formData: p("formData"),
    arrayBuffer: p("arrayBuffer"),
    text: p("text"),
    error(g, y) {
      return l.set(g, y), this;
    },
    badRequest(g) {
      return this.error(400, g);
    },
    unauthorized(g) {
      return this.error(401, g);
    },
    forbidden(g) {
      return this.error(403, g);
    },
    notFound(g) {
      return this.error(404, g);
    },
    timeout(g) {
      return this.error(408, g);
    },
    internalError(g) {
      return this.error(500, g);
    },
    fetchError(g) {
      return this.error(mt, g);
    }
  }, M = u.reduce((g, y) => ({
    ...g,
    ...typeof y.resolver == "function" ? y.resolver(g) : y.resolver
  }), b);
  return s.reduce((g, y) => y(g, t), M);
}, Fv = {
  _url: "",
  _options: {},
  _config: wt,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(t) {
    return { ...this, _addons: [...this._addons, t], ...t.wretch };
  },
  errorType(t) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: t
      }
    };
  },
  polyfills(t, e = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: e ? t : nt(this._config.polyfills, t)
      }
    };
  },
  url(t, e = !1) {
    if (e)
      return { ...this, _url: t };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + t + "?" + r[1] : this._url + t
    };
  },
  options(t, e = !1) {
    return { ...this, _options: e ? t : nt(this._options, t) };
  },
  headers(t) {
    const e = t ? Array.isArray(t) ? Object.fromEntries(t) : "entries" in t ? Object.fromEntries(t.entries()) : t : {};
    return { ...this, _options: nt(this._options, { headers: e }) };
  },
  accept(t) {
    return this.headers({ Accept: t });
  },
  content(t) {
    return this.headers({ [zi]: t });
  },
  auth(t) {
    return this.headers({ Authorization: t });
  },
  catcher(t, e) {
    const r = new Map(this._catchers);
    return r.set(t, e), { ...this, _catchers: r };
  },
  catcherFallback(t) {
    return this.catcher($i, t);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(t, e = !1) {
    return { ...this, _resolvers: e ? [t] : [...this._resolvers, t] };
  },
  defer(t, e = !1) {
    return {
      ...this,
      _deferred: e ? [t] : [...this._deferred, t]
    };
  },
  middlewares(t, e = !1) {
    return {
      ...this,
      _middlewares: e ? t : [...this._middlewares, ...t]
    };
  },
  fetch(t = this._options.method, e = "", r = null) {
    let a = this.url(e).options({ method: t });
    const n = Ro(a._options.headers), o = this._config.polyfill("FormData", !1), s = typeof r == "object" && !(o && r instanceof o) && (!a._options.headers || !n || ko(n));
    return a = r ? s ? a.json(r, n) : a.body(r) : a, Wv(a._deferred.reduce((i, u) => u(i, i._url, i._options), a));
  },
  get(t = "") {
    return this.fetch("GET", t);
  },
  delete(t = "") {
    return this.fetch("DELETE", t);
  },
  put(t, e = "") {
    return this.fetch("PUT", e, t);
  },
  post(t, e = "") {
    return this.fetch("POST", e, t);
  },
  patch(t, e = "") {
    return this.fetch("PATCH", e, t);
  },
  head(t = "") {
    return this.fetch("HEAD", t);
  },
  opts(t = "") {
    return this.fetch("OPTIONS", t);
  },
  body(t) {
    return { ...this, _options: { ...this._options, body: t } };
  },
  json(t, e) {
    const r = Ro(this._options.headers);
    return this.content(e || ko(r) && r || Rv).body(JSON.stringify(t));
  }
};
function ut(t = "", e = {}) {
  return { ...Fv, _url: t, _options: e };
}
ut.default = ut;
ut.options = kv;
ut.errorType = Iv;
ut.polyfills = jv;
ut.WretchError = qi;
class Nv extends Error {
  constructor(r, a, n, o, s) {
    super(r);
    Ve(this, "statusCode");
    Ve(this, "endpoint");
    Ve(this, "args");
    Ve(this, "response");
    this.name = "ApiError", this.statusCode = a, this.endpoint = n, this.args = o, this.response = s;
  }
}
class Hn extends Nv {
  constructor(e, r, a, n) {
    super(`Client error ${e} occurred while fetching ${r}`, e, r, a, n), this.name = "Api4xxError";
  }
}
class Hv extends Hn {
  constructor(e, r, a) {
    super(404, e, r, a), this.name = "Api404Error";
  }
}
class Bv extends Hn {
  constructor(e, r, a) {
    super(400, e, r, a), this.name = "Api400Error";
  }
}
class zv {
  constructor(e = {}) {
    Ve(this, "logger");
    Ve(this, "notFoundLogLevel");
    Ve(this, "badRequestLogLevel");
    Ve(this, "other4xxLogLevel");
    this.logger = e.logger, this.notFoundLogLevel = e.notFoundLogLevel || "info", this.badRequestLogLevel = e.badRequestLogLevel || "warn", this.other4xxLogLevel = e.other4xxLogLevel || "warn";
  }
  log(e, r, a) {
    this.logger && this.logger[e](r, a);
  }
  async handleApiError(e, r, a) {
    if (!(e instanceof Response))
      throw e;
    const { status: n } = e;
    if (n === 404) {
      const o = new Hv(r, a, e);
      return this.log(this.notFoundLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    if (n === 400) {
      const o = new Bv(r, a, e);
      return this.log(this.badRequestLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    if (n >= 400 && n < 500) {
      const o = new Hn(n, r, a, e);
      return this.log(this.other4xxLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    throw e;
  }
}
const $v = (t, e) => {
  const r = new zv(e);
  return t.catcher(404, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(400, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(401, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(403, async (a) => (await r.handleApiError(a.response, a.url), null)).catcherFallback(async (a) => {
    if (a.status >= 400 && a.status < 500)
      return await r.handleApiError(a.response, a.url), null;
    throw a;
  });
}, qv = (t, e) => {
  var a, n;
  const r = new URLSearchParams();
  return (a = e.categoryGroupIds) != null && a.length ? r.set("categoryGroupIds", e.categoryGroupIds.join(",")) : e.categoryGroupId != null && r.set("categoryGroupIds", String(e.categoryGroupId)), (n = e.eventIds) != null && n.length && r.set("eventIds", e.eventIds.join(",")), e.subeventId != null && r.set("subeventId", String(e.subeventId)), e.limit != null && r.set("limit", String(e.limit)), e.includeAll && r.set("includeAll", "true"), `${t}/v1/popular-bets?${r.toString()}`;
}, er = async (t, e, { apiKey: r, countryCode: a, repub: n, subdivisionCode: o }, s) => {
  if (!t)
    throw new Error("No API endpoint");
  const i = qv(t, e), u = {
    accept: "application/json",
    "content-type": "application/json"
  };
  r && (u["api-key"] = r), n && (u.repub = n.toUpperCase()), a && (u["country-code"] = a.toUpperCase()), o && (u["subdivision-code"] = o.toUpperCase());
  const l = $v(ut(i, { headers: u }), s);
  try {
    return await l.get().json();
  } catch (d) {
    return s != null && s.logger && s.logger.error("Error fetching most-popular-bets data", d), null;
  }
}, Ct = (t) => ["most-popular-bets", t], Vv = (t, e) => {
  if (!t)
    return null;
  const r = t.startTime != null && e >= Date.parse(t.startTime), a = r ? t.inPlaySubeventId : t.preMatchSubeventId, n = r ? t.preMatchSubeventId : t.inPlaySubeventId;
  return a ?? n ?? null;
}, Vi = (t, e = Date.now()) => {
  var o, s;
  const r = t.subeventId ?? Vv(t.subeventMeta, e);
  if (r != null)
    return { kind: "subevent", subeventId: r };
  const n = ((o = t.eventIds) != null && o.length ? t.eventIds : ((s = t.eventMetas) == null ? void 0 : s.map((i) => i.eventId)) ?? []).filter((i) => i != null);
  return n.length > 0 ? { eventIds: n, kind: "events" } : { kind: "sports" };
}, ot = -1, Kv = () => {
  var _;
  const t = cr(), { apiKey: e, countryCode: r, dataApiEndpoint: a, includeAll: n, limit: o, repub: s, sports: i, subdivisionCode: u } = t, l = Vi(t), d = l.kind !== "sports", m = n ? ot : ((_ = i[0]) == null ? void 0 : _.categoryGroupId) ?? ot, [h, c] = ie(m), v = { apiKey: e, countryCode: r, repub: s, subdivisionCode: u }, f = h === ot, p = (() => {
    switch (l.kind) {
      case "subevent":
        return { limit: o, subeventId: l.subeventId };
      case "events":
        return { eventIds: l.eventIds, limit: o };
      default:
        return f && n ? { categoryGroupIds: i.map((S) => S.categoryGroupId), includeAll: !0, limit: o } : { categoryGroupId: f ? void 0 : h, limit: o };
    }
  })(), { data: b, error: M } = du({
    queryFn: () => er(a, p, v, { logger: console }),
    queryKey: Ct(p)
  }), g = (b == null ? void 0 : b.bets) ?? [];
  return {
    allSportsBets: (b == null ? void 0 : b.allSportsBets) ?? [],
    bets: g,
    error: M,
    includeAll: n,
    isSingleTarget: d,
    selectedCategoryGroupId: h,
    setSelectedCategoryGroupId: c,
    sports: i
  };
};
var Uv = typeof Dt == "object" && Dt && Dt.Object === Object && Dt, Yv = typeof self == "object" && self && self.Object === Object && self;
Uv || Yv || Function("return this")();
function Xv({
  threshold: t = 0,
  root: e = null,
  rootMargin: r = "0%",
  freezeOnceVisible: a = !1,
  initialIsIntersecting: n = !1,
  onChange: o
} = {}) {
  var s;
  const [i, u] = ie(null), [l, d] = ie(() => ({
    isIntersecting: n,
    entry: void 0
  })), m = U();
  m.current = o;
  const h = ((s = l.entry) == null ? void 0 : s.isIntersecting) && a;
  X(() => {
    if (!i || !("IntersectionObserver" in window) || h)
      return;
    let f;
    const p = new IntersectionObserver(
      (b) => {
        const M = Array.isArray(p.thresholds) ? p.thresholds : [p.thresholds];
        b.forEach((g) => {
          const y = g.isIntersecting && M.some((_) => g.intersectionRatio >= _);
          d({ isIntersecting: y, entry: g }), m.current && m.current(y, g), y && a && f && (f(), f = void 0);
        });
      },
      { threshold: t, root: e, rootMargin: r }
    );
    return p.observe(i), () => {
      p.disconnect();
    };
  }, [
    i,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(t),
    e,
    r,
    h,
    a
  ]);
  const c = U(null);
  X(() => {
    var f;
    !i && ((f = l.entry) != null && f.target) && !a && !h && c.current !== l.entry.target && (c.current = l.entry.target, d({ isIntersecting: n, entry: void 0 }));
  }, [i, l.entry, a, h, n]);
  const v = [
    u,
    !!l.isIntersecting,
    l.entry
  ];
  return v.ref = v[0], v.isIntersecting = v[1], v.entry = v[2], v;
}
function Gv(t, e, r) {
  const { isIntersecting: a, ref: n } = Xv({ threshold: 0.5 }), o = U(!1);
  return X(() => {
    t && a && !o.current && (Bi(t, e, r), o.current = !0);
  }, [r, e, t, a]), n;
}
const gn = (t, e) => {
  var r;
  return e === ot ? "All Sports" : ((r = t.find((a) => a.categoryGroupId === e)) == null ? void 0 : r.label) ?? "";
}, Jv = (t, e, r) => {
  const a = r(t);
  return e ? `${a} ${e}`.trim() : a;
}, Qv = (t, e) => {
  const r = Tv(t);
  return r.success ? `${e(r.first)}${r.separator}${e(r.second)}`.trim() : e(t);
}, Zv = "_container_dvhg8_1", em = "_header_dvhg8_9", tm = "_title_dvhg8_16", rm = "_sportButton_dvhg8_26", am = "_sportButtonLabel_dvhg8_42", nm = "_sportButtonChevron_dvhg8_49", om = "_sportButtonChevronOpen_dvhg8_56", im = "_sportMenu_dvhg8_60", um = "_sportMenuItem_dvhg8_87", sm = "_sportMenuItemSelected_dvhg8_110", lm = "_list_dvhg8_114", dm = "_row_dvhg8_121", cm = "_link_dvhg8_128", fm = "_linkNoIcon_dvhg8_136", vm = "_sportIcon_dvhg8_140", mm = "_betInfo_dvhg8_148", hm = "_betName_dvhg8_156", pm = "_subeventName_dvhg8_162", ym = "_oddsButton_dvhg8_167", bm = "_selected_dvhg8_180", gm = "_odds_dvhg8_167", fe = {
  container: Zv,
  header: em,
  title: tm,
  sportButton: rm,
  sportButtonLabel: am,
  sportButtonChevron: nm,
  sportButtonChevronOpen: om,
  sportMenu: im,
  sportMenuItem: um,
  sportMenuItemSelected: sm,
  list: lm,
  row: dm,
  link: cm,
  linkNoIcon: fm,
  sportIcon: vm,
  betInfo: mm,
  betName: hm,
  subeventName: pm,
  oddsButton: ym,
  selected: bm,
  odds: gm
}, Mm = ({ includeAll: t, onSelect: e, selectedCategoryGroupId: r, sports: a }) => {
  const n = Hd({ animated: !1, gutter: 4, placement: "bottom-end" }), { track: o } = Nn(), { t: s } = Ln("label"), i = ({ categoryGroupId: h, label: c }) => h === ot ? s("CX_MOST_POPULAR_BETS_ALL_SPORTS", { defaultValue: "All Sports" }) : s(c, { defaultValue: c }), u = t ? [{ categoryGroupId: ot, label: "All Sports" }, ...a] : a, l = u.find((h) => h.categoryGroupId === r) ?? u[0], d = l ? i(l) : "", m = (h) => {
    h !== r && o("most_popular_bets_filter_change", {
      fromSport: gn(a, r),
      toSport: gn(a, h)
    }), e(h), n.hide();
  };
  return /* @__PURE__ */ Le(Io, { children: [
    /* @__PURE__ */ Le(
      Ad,
      {
        ...n,
        "aria-label": "Select sport",
        className: fe.sportButton,
        "data-testid": "most-popular-bets-sport-select",
        children: [
          /* @__PURE__ */ F("span", { className: fe.sportButtonLabel, children: d }),
          /* @__PURE__ */ F(
            "svg",
            {
              "aria-hidden": "true",
              className: Nt(fe.sportButtonChevron, n.visible && fe.sportButtonChevronOpen),
              fill: "none",
              height: "16",
              viewBox: "0 0 16 16",
              width: "16",
              children: /* @__PURE__ */ F("path", { d: "M4 6l4 4 4-4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ F(xd, { ...n, "aria-label": "Sports", className: fe.sportMenu, "data-testid": "most-popular-bets-sport-menu", children: u.map((h) => /* @__PURE__ */ De(
      Nd,
      {
        ...n,
        className: Nt(
          fe.sportMenuItem,
          h.categoryGroupId === r && fe.sportMenuItemSelected
        ),
        "data-testid": "most-popular-bets-sport-option",
        key: h.categoryGroupId,
        onClick: () => m(h.categoryGroupId)
      },
      i(h)
    )) })
  ] });
}, _m = (t) => /* @__PURE__ */ F("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M18.574 4.241a1.5 1.5 0 011.128 1.03l.03.113a12.046 12.046 0 01-3.277 11.07A12.025 12.025 0 017.925 20c-.842 0-1.693-.089-2.54-.269a1.503 1.503 0 01-1.144-1.157A12.14 12.14 0 017.567 7.567 12.145 12.145 0 0118.574 4.24zM5.085 14.789a11.173 11.173 0 00.137 3.587c.037.183.19.338.373.376 1.211.26 2.434.313 3.624.172L5.085 14.79zm8.505-9.488a11.14 11.14 0 00-5.315 2.974A11.152 11.152 0 005.3 13.59l5.122 5.125a11.069 11.069 0 005.325-2.967 11.057 11.057 0 002.965-5.325L13.59 5.301zm-.737 3.847l.645.645.647-.646a.5.5 0 01.707.707l-.647.646.646.646a.499.499 0 11-.706.707l-.647-.646-.793.793.647.647a.5.5 0 01-.257.844L13 13.5a.5.5 0 01-.353-.147L12 12.706l-.793.793.646.647a.499.499 0 11-.705.707l-.648-.647-.645.647a.5.5 0 01-.258.136l-.095.01a.5.5 0 01-.354-.853l.645-.647-.645-.646a.5.5 0 01.707-.707l.645.646.791-.792-.645-.645a.5.5 0 01.707-.707l.645.645.793-.792-.645-.645a.5.5 0 01.707-.707zM16.16 5c-.46 0-.918.028-1.371.085l4.134 4.135c.14-1.191.088-2.415-.17-3.628a.496.496 0 00-.377-.371A11.245 11.245 0 0016.16 5z",
    fill: "currentColor"
  }
) }), wm = (t) => /* @__PURE__ */ F("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M17.5 4a2.503 2.503 0 011.538 4.472L7.58 17.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L15.528 4.96a.268.268 0 01.035-.048A2.502 2.502 0 0117.5 4zM5.147 17.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L6.88 17.052l.067.067 1.901-1.563-.405-.405zM17.5 5c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0017.5 5zM6 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z",
    fill: "currentColor"
  }
) }), Em = (t) => /* @__PURE__ */ F("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M17.656 6.34A7.956 7.956 0 0120 12a7.95 7.95 0 01-2.344 5.66A7.974 7.974 0 0112 20a7.97 7.97 0 01-5.657-2.34A7.953 7.953 0 014 12c0-2.059.771-3.999 2.178-5.489l.165-.17c3.118-3.12 8.194-3.122 11.313 0zm-8.142 8.853l-2.099 2.101a6.975 6.975 0 004.089 1.69 8.707 8.707 0 00-1.99-3.79zm2.485-2.486l-1.776 1.777a9.738 9.738 0 012.308 4.496 6.975 6.975 0 004.052-1.685l-4.584-4.588zm2.484-2.484L12.707 12l4.584 4.587a6.944 6.944 0 001.69-4.055 9.734 9.734 0 01-4.497-2.309zm-9.465 2.272l.013.173a6.942 6.942 0 001.678 3.918l2.099-2.1a8.72 8.72 0 00-3.79-1.991zm.013-1.163l-.01.136a9.709 9.709 0 014.496 2.31L11.292 12 6.709 7.414a6.957 6.957 0 00-1.678 3.918zM17.29 7.414l-2.098 2.1a8.752 8.752 0 003.791 1.992 6.941 6.941 0 00-1.693-4.092zM11.47 5.02l-.14.011a6.976 6.976 0 00-3.913 1.676L12 11.293l1.777-1.778a9.714 9.714 0 01-2.306-4.494h-.002zm1.027-.003l.042.17a8.734 8.734 0 001.947 3.618l2.098-2.099a6.968 6.968 0 00-4.086-1.689h-.001z",
    fill: "currentColor"
  }
) }), Pm = (t) => /* @__PURE__ */ F("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M15.92 4a4.13 4.13 0 013.015 1.303 3.96 3.96 0 011.048 3.063l-.665 7.179a.505.505 0 01-.508.455v3.5c0 .276-.229.5-.51.5H9.106a.505.505 0 01-.51-.5V16l-.071-.006-.034-.004-.044-.012-.039-.012-.025-.012a.518.518 0 01-.137-.088l-4.071-3.49A.494.494 0 014 12v-1.5C4 9.122 5.146 8 6.553 8h.854c0-.992.378-1.958 1.065-2.697A4.125 4.125 0 0111.486 4h4.433zm-4.25 12H9.618v3h8.17v-3h-6.116zm2.543 1c.282 0 .51.224.51.5s-.228.5-.51.5h-1.021c-.281 0-.51-.224-.51-.5s.229-.5.51-.5h1.022zM15.92 5h-4.433a3.05 3.05 0 00-2.26.977 2.972 2.972 0 00-.786 2.297l.015.141a.538.538 0 01.007.069L9.107 15h9.236l.622-6.725a2.962 2.962 0 00-.787-2.299A3.05 3.05 0 0015.92 5zM7.483 9h-.93c-.844 0-1.532.673-1.532 1.5v1.273l2.95 2.528L7.484 9z",
    fill: "currentColor"
  }
) }), Sm = (t) => /* @__PURE__ */ F("svg", { fill: "none", height: "1em", viewBox: "0.48 0.48 17.04 17.04", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M1.05194 2.68363L1.81307 2.98149C1.12782 4.74838 0.843008 7.04121 0.733028 8.27806C0.666142 9.03006 0.684423 9.70762 0.789032 10.3496C1.44787 14.3885 4.90112 17.3202 9.0002 17.3202C13.0993 17.3202 16.5525 14.3885 17.2114 10.3493C17.316 9.7074 17.3344 9.02983 17.2674 8.2778C17.1574 7.04091 16.8726 4.74823 16.1873 2.98123L16.9486 2.68337C17.1744 2.59501 17.3202 2.38129 17.3202 2.13885V1.26484C17.3202 0.94231 17.0579 0.679993 16.7353 0.679993H13.8105C13.4663 0.679993 13.1862 0.960161 13.1862 1.30433V2.78599C13.1862 2.80834 13.1896 2.83053 13.1968 2.85186C13.2171 2.91265 15.1994 8.96966 13.0029 12.0176C12.1708 13.1721 10.8241 13.7575 9.00002 13.7575C7.17958 13.7575 5.8349 13.173 5.00308 12.0202C2.80616 8.97527 4.78312 2.91244 4.80329 2.8519C4.8104 2.83072 4.81403 2.80852 4.81403 2.78617V1.30451C4.81403 0.960358 4.53386 0.680175 4.1897 0.680175H1.26484C0.942311 0.680175 0.679993 0.942496 0.679993 1.26503V2.13903C0.679993 2.38148 0.825808 2.59519 1.05172 2.68355L1.05194 2.68363ZM1.09619 1.2651C1.09619 1.17196 1.17193 1.09622 1.26507 1.09622H4.18992C4.30484 1.09622 4.39827 1.18966 4.39827 1.30457V2.75299C4.22185 3.29606 2.40575 9.13042 4.66567 12.2634C5.58002 13.5311 7.03832 14.1738 9.00024 14.1738C10.9655 14.1738 12.4258 13.5304 13.3404 12.2611C15.5989 9.12748 13.7791 3.29632 13.6021 2.75329V1.30487C13.6021 1.18995 13.6956 1.09652 13.8105 1.09652H16.7353C16.8285 1.09652 16.9042 1.17225 16.9042 1.2654V2.13941C16.9042 2.20934 16.8621 2.27115 16.797 2.29669L15.8404 2.67086C15.7883 2.69118 15.7467 2.73166 15.7248 2.78316C15.7029 2.83467 15.7026 2.8927 15.7241 2.94435C16.4454 4.68297 16.741 7.0557 16.853 8.31521C16.9169 9.03225 16.8997 9.67601 16.8008 10.2829C16.175 14.1198 12.8941 16.9048 9.00004 16.9048C5.10598 16.9048 1.82515 14.1199 1.1993 10.2833C1.10034 9.67609 1.08337 9.03248 1.14707 8.31547C1.25907 7.05596 1.55463 4.68331 2.27602 2.94461C2.2975 2.89296 2.29721 2.83493 2.2753 2.78342C2.25339 2.73206 2.21175 2.69158 2.15966 2.67112L1.20323 2.29695C1.13809 2.27141 1.09587 2.2096 1.09587 2.13967L1.09619 1.2651Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "0.2"
  }
) }), Om = (t) => /* @__PURE__ */ F("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M18.5 4a1.502 1.502 0 011.267 2.303l-8.1 12.768c-.37.582-1 .929-1.688.929H6c-1.103 0-2-.897-2-2s.897-2 2-2h2.944L17.29 4.614A1.502 1.502 0 0118.5 4zM7 17H6c-.55 0-1 .448-1 1s.45 1 1 1h1v-2zm4.142-2.309L9.75 16.592c-.188.256-.49.408-.806.408H8v2h1.978c.344 0 .66-.174.845-.465l1.785-2.815-1.466-1.029zm1.452-1.981l-.861 1.174 1.412.991.739-1.165-1.29-1zM8.5 11a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h4zM8 12H5v1h3v-1zm10.5-7a.496.496 0 00-.403.205l-4.911 6.697 1.237.959 4.5-7.094A.5.5 0 0018.5 5z",
    fill: "currentColor"
  }
) }), xm = (t) => /* @__PURE__ */ F("svg", { height: "1em", viewBox: "0 0 16 16", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M8 0c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm1.768 11.5H6.235l-1.002 1.203.63 1.964a6.99 6.99 0 003.916.104l.974-2.105-.985-1.167zm3.374 1.245l-1.456.287-.572 1.237a7.036 7.036 0 002.028-1.524zm-8.5 1.396l-.343-1.07-1.19-.067c.456.445.971.828 1.533 1.137zm-1.914-7.3L1.033 8.683a6.962 6.962 0 001.193 3.27l2.228.121.98-1.177L4.27 7.594 2.728 6.84zm10.556 0l-1.54.754-1.177 3.301.967 1.146 2.498-.493a6.944 6.944 0 00.935-2.866L13.284 6.84zM8.008 5.424L5.268 7.42l1.086 3.08h3.293l1.1-3.08-2.74-1.996zM1.046 7.191l1.021-1.11-.282-1.3a6.937 6.937 0 00-.739 2.41zM14.224 4.8l-.278 1.284 1.007 1.098a6.944 6.944 0 00-.729-2.382zM10.57 1.49L8.508 2.6v1.95l2.885 2.104 1.572-.77.492-2.264a7.036 7.036 0 00-2.887-2.131zM2.555 3.606l.492 2.277 1.576.77L7.508 4.55V2.596L5.445 1.483a7.027 7.027 0 00-2.89 2.123zM8 1a6.99 6.99 0 00-1.165.097l1.175.635L9.184 1.1C8.799 1.034 8.404 1 8 1z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
) }), Dm = (t) => /* @__PURE__ */ F("svg", { height: "1em", viewBox: "0 0 20 20", width: "1em", ...t, children: /* @__PURE__ */ F(
  "path",
  {
    d: "M16.256 19.805a.556.556 0 00.115-.406l-.716-6.476 4.207-4.79a.563.563 0 00.113-.535.525.525 0 00-.39-.363L13.49 5.953 10.447.273C10.355.103 10.185 0 10 0s-.355.104-.447.272L6.51 5.953.415 7.235a.525.525 0 00-.39.363.558.558 0 00.113.534l4.207 4.791L3.63 19.4a.552.552 0 00.208.498c.15.114.347.135.515.054L10 17.231l5.648 2.72a.488.488 0 00.249.048c.14-.01.27-.08.36-.194z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
) }), Cm = /* @__PURE__ */ new Map([
  [2, xm],
  // Football (soccer)
  [3, Sm],
  // Horse Racing
  [10, Pm],
  // Boxing
  [18, _m],
  // American Football
  [45, Om],
  // Ice Hockey
  [46, wm],
  // Baseball
  [47, Em]
  // Basketball
]), Tm = (t) => Cm.get(t) ?? Dm, Am = ({ categoryGroupId: t, ...e }) => {
  const r = Tm(t);
  return /* @__PURE__ */ F("span", { "aria-hidden": "true", className: fe.sportIcon, "data-testid": "most-popular-bets-sport-icon", children: /* @__PURE__ */ F(r, { ...e }) });
}, Rm = (t, e) => {
  switch (t) {
    case "american":
      return e.bestOddsUs ?? "";
    case "fractional":
      return e.bestOddsFractional ?? "";
    case "decimal":
      return e.bestOddsDecimal != null ? Cv(e.bestOddsDecimal) : "";
    default:
      return "";
  }
}, km = ({
  bet: t,
  oddsFormat: e,
  position: r,
  renderBadge: a,
  selectedSport: n,
  showSportIcon: o
}) => {
  const { bookmakersConfig: s, onOddsButtonClick: i } = cr(), { track: u } = Nn(), l = t.bestOddsBookmakerCode ?? "", d = s == null ? void 0 : s[l], m = Rm(e, t), h = {
    betId: t.id,
    betName: t.name,
    position: r,
    selectedSport: n,
    sport: t.categoryGroupName,
    subeventName: t.subeventName
  }, c = xv.find((P) => P.id === t.categoryGroupId), v = (c == null ? void 0 : c.translationFile) || "", { t: f } = Ln([v, "label", "bettype"]), p = Qv(t.subeventName, f), b = Jv(t.name, t.line, f), { isBookieBetSelected: M, toggleBetslipBet: g } = Av({
    betId: t.id,
    betName: t.name,
    betOdds: m,
    bookieCode: l,
    marketName: t.marketName,
    subeventName: t.subeventName
  }), y = () => {
    if (u("most_popular_bets_odds_click", {
      ...h,
      bookmakerCode: l,
      marketName: t.marketName,
      oddsText: m
    }), i)
      return i("most_popular_bets_click", t.id, l, t.name, m);
    g();
  }, _ = () => {
    u("most_popular_bets_selection_click", { ...h, subeventUrl: t.subeventUrl });
  };
  return /* @__PURE__ */ F("li", { className: fe.row, "data-testid": "most-popular-bets-row", children: /* @__PURE__ */ Le("div", { className: Nt(fe.link, !o && fe.linkNoIcon), children: [
    o && /* @__PURE__ */ F(Am, { categoryGroupId: t.categoryGroupId }),
    /* @__PURE__ */ Le("a", { className: fe.betInfo, href: t.subeventUrl ?? "#", onClick: _, children: [
      /* @__PURE__ */ F("span", { className: fe.betName, children: b }),
      /* @__PURE__ */ F("span", { className: fe.subeventName, children: p })
    ] }),
    m && l ? /* @__PURE__ */ F(
      wc,
      {
        bookieCode: l,
        bookmakerConfig: d,
        className: Nt(fe.oddsButton, M && fe.selected),
        isSelected: M,
        onClick: y,
        renderBadge: a,
        children: m
      }
    ) : /* @__PURE__ */ F("span", { className: fe.odds, children: m })
  ] }) }, t.id);
}, jo = () => {
  const { className: t, emptySlot: e, errorSlot: r, oddsFormat: a = "decimal", repub: n, showBookieLogos: o } = cr(), { t: s } = Ln("label"), i = s("CX_MOST_POPULAR_BETS", { defaultValue: "Most Popular Bets" }), u = o ?? (n != null && Ov.includes(n)), {
    allSportsBets: l,
    bets: d,
    error: m,
    includeAll: h,
    isSingleTarget: c,
    selectedCategoryGroupId: v,
    setSelectedCategoryGroupId: f,
    sports: p
  } = Kv(), { analyticsDataLayer: b, analyticsImpressionEventData: M, impressionEventName: g } = Nn(), y = v === ot, _ = !c && y && h ? l : d, P = !c && p.length > 0, S = gn(p, v), D = He(
    () => ({ ...M, betCount: _.length, selectedSport: S }),
    [_.length, S, M]
  ), O = Gv(g, D, b);
  if (m)
    return r ?? null;
  const E = c || y && h === !0 || p.length <= 1 && !h;
  return _.length === 0 && E ? e ?? null : /* @__PURE__ */ Le("div", { className: Nt(fe.container, t), "data-testid": "most-popular-bets-container", ref: O, children: [
    /* @__PURE__ */ Le("div", { className: fe.header, children: [
      /* @__PURE__ */ F("h2", { className: fe.title, children: i }),
      !c && p.length > 0 && /* @__PURE__ */ F(
        Mm,
        {
          includeAll: h ?? !1,
          onSelect: f,
          selectedCategoryGroupId: v,
          sports: p
        }
      )
    ] }),
    _.length === 0 ? e ?? null : /* @__PURE__ */ F("ul", { className: fe.list, children: _.map((R, x) => /* @__PURE__ */ F(
      km,
      {
        bet: R,
        oddsFormat: a,
        position: x + 1,
        renderBadge: u,
        selectedSport: S,
        showSportIcon: P
      },
      R.id
    )) })
  ] });
}, $m = async (t, e) => {
  const r = Ri(), { apiKey: a, countryCode: n, limit: o, repub: s, sports: i, subdivisionCode: u } = t, l = { apiKey: a, countryCode: n, repub: s, subdivisionCode: u }, d = Vi(t);
  if (d.kind !== "sports") {
    const f = d.kind === "subevent" ? { limit: o, subeventId: d.subeventId } : { eventIds: d.eventIds, limit: o };
    return await r.prefetchQuery({
      queryFn: () => er(e, f, l),
      queryKey: Ct(f)
    }), { dehydratedState: Bn(r), sports: [] };
  }
  const m = i.map((f) => ({
    categoryGroupId: f.categoryGroupId,
    limit: o
  }));
  await Promise.allSettled(
    m.map(
      (f) => r.prefetchQuery({
        queryFn: () => er(e, f, l),
        queryKey: Ct(f)
      })
    )
  );
  const h = i.filter((f, p) => {
    const b = r.getQueryData(
      Ct(m[p])
    );
    return b != null && b.bets.length > 0;
  }), c = t.includeAll ? { categoryGroupIds: h.map((f) => f.categoryGroupId), includeAll: !0, limit: o } : null;
  return c && await r.prefetchQuery({
    queryFn: () => er(e, c, l),
    queryKey: Ct(c)
  }), {
    dehydratedState: Bn(r),
    sports: h
  };
};
function jm() {
  if (globalThis.window !== void 0)
    return globalThis.window.dataLayer;
}
const Im = () => Ri({
  defaultOptions: {
    queries: {
      gcTime: 1 / 0,
      refetchOnMount: !1,
      refetchOnReconnect: !1,
      refetchOnWindowFocus: !1,
      retry: 3,
      retryDelay: (t) => t * 100,
      staleTime: 1 / 0
    }
  }
});
function qm({
  dehydratedState: t,
  loadingElement: e,
  ...r
}) {
  const [a] = st.useState(Im), { analyticsDataLayer: n = jm() } = r;
  return /* @__PURE__ */ F($d, { children: /* @__PURE__ */ F(cu, { client: a, children: /* @__PURE__ */ F(fu, { state: t, children: /* @__PURE__ */ F(su, { fallback: e ?? null, children: /* @__PURE__ */ F(Hc, { ...r, analyticsDataLayer: n, children: /* @__PURE__ */ F(Pc, { children: r.i18n ? /* @__PURE__ */ F(qd, { i18nInstance: r.i18n, children: /* @__PURE__ */ F(jo, {}) }) : /* @__PURE__ */ F(jo, {}) }) }) }) }) }) });
}
export {
  qm as default,
  $m as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
